const postalCodesMap = `
0001	OSLO	0301	OSLO	P
0010	OSLO	0301	OSLO	B
0015	OSLO	0301	OSLO	B
0018	OSLO	0301	OSLO	S
0021	OSLO	0301	OSLO	P
0024	OSLO	0301	OSLO	P
0026	OSLO	0301	OSLO	B
0028	OSLO	0301	OSLO	P
0030	OSLO	0301	OSLO	P
0032	OSLO	0301	OSLO	P
0033	OSLO	0301	OSLO	P
0034	OSLO	0301	OSLO	P
0037	OSLO	0301	OSLO	B
0040	OSLO	0301	OSLO	P
0045	OSLO	0301	OSLO	S
0046	OSLO	0301	OSLO	S
0047	OSLO	0301	OSLO	S
0048	OSLO	0301	OSLO	P
0050	OSLO	0301	OSLO	G
0055	OSLO	0301	OSLO	P
0101	OSLO	0301	OSLO	P
0102	OSLO	0301	OSLO	P
0103	OSLO	0301	OSLO	P
0104	OSLO	0301	OSLO	P
0105	OSLO	0301	OSLO	P
0106	OSLO	0301	OSLO	P
0107	OSLO	0301	OSLO	P
0109	OSLO	0301	OSLO	P
0110	OSLO	0301	OSLO	P
0111	OSLO	0301	OSLO	P
0112	OSLO	0301	OSLO	P
0113	OSLO	0301	OSLO	P
0114	OSLO	0301	OSLO	P
0115	OSLO	0301	OSLO	P
0116	OSLO	0301	OSLO	P
0117	OSLO	0301	OSLO	P
0118	OSLO	0301	OSLO	P
0119	OSLO	0301	OSLO	P
0120	OSLO	0301	OSLO	P
0121	OSLO	0301	OSLO	P
0122	OSLO	0301	OSLO	P
0123	OSLO	0301	OSLO	P
0124	OSLO	0301	OSLO	P
0125	OSLO	0301	OSLO	P
0129	OSLO	0301	OSLO	P
0130	OSLO	0301	OSLO	P
0131	OSLO	0301	OSLO	P
0132	OSLO	0301	OSLO	P
0133	OSLO	0301	OSLO	P
0134	OSLO	0301	OSLO	P
0135	OSLO	0301	OSLO	P
0136	OSLO	0301	OSLO	P
0138	OSLO	0301	OSLO	P
0139	OSLO	0301	OSLO	G
0140	OSLO	0301	OSLO	P
0150	OSLO	0301	OSLO	G
0151	OSLO	0301	OSLO	G
0152	OSLO	0301	OSLO	G
0153	OSLO	0301	OSLO	G
0154	OSLO	0301	OSLO	G
0155	OSLO	0301	OSLO	G
0157	OSLO	0301	OSLO	G
0158	OSLO	0301	OSLO	G
0159	OSLO	0301	OSLO	G
0160	OSLO	0301	OSLO	G
0161	OSLO	0301	OSLO	G
0162	OSLO	0301	OSLO	G
0164	OSLO	0301	OSLO	G
0165	OSLO	0301	OSLO	G
0166	OSLO	0301	OSLO	G
0167	OSLO	0301	OSLO	G
0168	OSLO	0301	OSLO	G
0169	OSLO	0301	OSLO	G
0170	OSLO	0301	OSLO	G
0171	OSLO	0301	OSLO	G
0172	OSLO	0301	OSLO	G
0173	OSLO	0301	OSLO	G
0174	OSLO	0301	OSLO	G
0175	OSLO	0301	OSLO	G
0176	OSLO	0301	OSLO	G
0177	OSLO	0301	OSLO	G
0178	OSLO	0301	OSLO	G
0179	OSLO	0301	OSLO	G
0180	OSLO	0301	OSLO	G
0181	OSLO	0301	OSLO	G
0182	OSLO	0301	OSLO	G
0183	OSLO	0301	OSLO	G
0184	OSLO	0301	OSLO	G
0185	OSLO	0301	OSLO	G
0186	OSLO	0301	OSLO	G
0187	OSLO	0301	OSLO	G
0188	OSLO	0301	OSLO	G
0190	OSLO	0301	OSLO	G
0191	OSLO	0301	OSLO	G
0192	OSLO	0301	OSLO	G
0193	OSLO	0301	OSLO	G
0194	OSLO	0301	OSLO	G
0195	OSLO	0301	OSLO	G
0196	OSLO	0301	OSLO	G
0198	OSLO	0301	OSLO	G
0201	OSLO	0301	OSLO	P
0202	OSLO	0301	OSLO	P
0203	OSLO	0301	OSLO	P
0204	OSLO	0301	OSLO	P
0207	OSLO	0301	OSLO	P
0208	OSLO	0301	OSLO	P
0211	OSLO	0301	OSLO	P
0212	OSLO	0301	OSLO	P
0213	OSLO	0301	OSLO	P
0214	OSLO	0301	OSLO	P
0215	OSLO	0301	OSLO	P
0216	OSLO	0301	OSLO	P
0217	OSLO	0301	OSLO	P
0218	OSLO	0301	OSLO	P
0230	OSLO	0301	OSLO	P
0240	OSLO	0301	OSLO	P
0244	OSLO	0301	OSLO	P
0247	OSLO	0301	OSLO	P
0250	OSLO	0301	OSLO	G
0251	OSLO	0301	OSLO	G
0252	OSLO	0301	OSLO	G
0253	OSLO	0301	OSLO	G
0254	OSLO	0301	OSLO	G
0255	OSLO	0301	OSLO	G
0256	OSLO	0301	OSLO	G
0257	OSLO	0301	OSLO	G
0258	OSLO	0301	OSLO	G
0259	OSLO	0301	OSLO	G
0260	OSLO	0301	OSLO	G
0262	OSLO	0301	OSLO	G
0263	OSLO	0301	OSLO	G
0264	OSLO	0301	OSLO	G
0265	OSLO	0301	OSLO	G
0266	OSLO	0301	OSLO	G
0267	OSLO	0301	OSLO	G
0268	OSLO	0301	OSLO	G
0270	OSLO	0301	OSLO	G
0271	OSLO	0301	OSLO	G
0272	OSLO	0301	OSLO	G
0273	OSLO	0301	OSLO	G
0274	OSLO	0301	OSLO	G
0275	OSLO	0301	OSLO	G
0276	OSLO	0301	OSLO	G
0277	OSLO	0301	OSLO	G
0278	OSLO	0301	OSLO	G
0279	OSLO	0301	OSLO	G
0280	OSLO	0301	OSLO	G
0281	OSLO	0301	OSLO	G
0282	OSLO	0301	OSLO	G
0283	OSLO	0301	OSLO	G
0284	OSLO	0301	OSLO	G
0286	OSLO	0301	OSLO	G
0287	OSLO	0301	OSLO	G
0301	OSLO	0301	OSLO	P
0302	OSLO	0301	OSLO	P
0303	OSLO	0301	OSLO	P
0304	OSLO	0301	OSLO	P
0305	OSLO	0301	OSLO	P
0306	OSLO	0301	OSLO	P
0307	OSLO	0301	OSLO	P
0308	OSLO	0301	OSLO	P
0309	OSLO	0301	OSLO	P
0311	OSLO	0301	OSLO	P
0313	OSLO	0301	OSLO	P
0314	OSLO	0301	OSLO	P
0315	OSLO	0301	OSLO	P
0316	OSLO	0301	OSLO	P
0317	OSLO	0301	OSLO	P
0318	OSLO	0301	OSLO	P
0319	OSLO	0301	OSLO	P
0323	OSLO	0301	OSLO	P
0330	OSLO	0301	OSLO	P
0340	OSLO	0301	OSLO	B
0349	OSLO	0301	OSLO	B
0350	OSLO	0301	OSLO	G
0351	OSLO	0301	OSLO	G
0352	OSLO	0301	OSLO	G
0353	OSLO	0301	OSLO	G
0354	OSLO	0301	OSLO	G
0355	OSLO	0301	OSLO	G
0356	OSLO	0301	OSLO	G
0357	OSLO	0301	OSLO	G
0358	OSLO	0301	OSLO	G
0359	OSLO	0301	OSLO	G
0360	OSLO	0301	OSLO	G
0361	OSLO	0301	OSLO	G
0362	OSLO	0301	OSLO	G
0363	OSLO	0301	OSLO	G
0364	OSLO	0301	OSLO	G
0365	OSLO	0301	OSLO	G
0366	OSLO	0301	OSLO	G
0367	OSLO	0301	OSLO	G
0368	OSLO	0301	OSLO	G
0369	OSLO	0301	OSLO	G
0370	OSLO	0301	OSLO	G
0371	OSLO	0301	OSLO	G
0372	OSLO	0301	OSLO	G
0373	OSLO	0301	OSLO	G
0374	OSLO	0301	OSLO	G
0375	OSLO	0301	OSLO	G
0376	OSLO	0301	OSLO	G
0377	OSLO	0301	OSLO	G
0378	OSLO	0301	OSLO	G
0379	OSLO	0301	OSLO	G
0380	OSLO	0301	OSLO	G
0381	OSLO	0301	OSLO	G
0382	OSLO	0301	OSLO	G
0383	OSLO	0301	OSLO	G
0401	OSLO	0301	OSLO	P
0402	OSLO	0301	OSLO	P
0403	OSLO	0301	OSLO	P
0404	OSLO	0301	OSLO	P
0405	OSLO	0301	OSLO	P
0406	OSLO	0301	OSLO	P
0409	OSLO	0301	OSLO	P
0410	OSLO	0301	OSLO	P
0411	OSLO	0301	OSLO	P
0412	OSLO	0301	OSLO	P
0413	OSLO	0301	OSLO	P
0415	OSLO	0301	OSLO	P
0421	OSLO	0301	OSLO	P
0422	OSLO	0301	OSLO	P
0423	OSLO	0301	OSLO	P
0424	OSLO	0301	OSLO	P
0440	OSLO	0301	OSLO	P
0441	OSLO	0301	OSLO	P
0442	OSLO	0301	OSLO	P
0445	OSLO	0301	OSLO	G
0450	OSLO	0301	OSLO	G
0451	OSLO	0301	OSLO	G
0452	OSLO	0301	OSLO	G
0454	OSLO	0301	OSLO	G
0455	OSLO	0301	OSLO	G
0456	OSLO	0301	OSLO	G
0457	OSLO	0301	OSLO	G
0458	OSLO	0301	OSLO	G
0459	OSLO	0301	OSLO	G
0460	OSLO	0301	OSLO	G
0461	OSLO	0301	OSLO	G
0462	OSLO	0301	OSLO	G
0463	OSLO	0301	OSLO	G
0464	OSLO	0301	OSLO	G
0465	OSLO	0301	OSLO	G
0467	OSLO	0301	OSLO	G
0468	OSLO	0301	OSLO	G
0469	OSLO	0301	OSLO	G
0470	OSLO	0301	OSLO	G
0472	OSLO	0301	OSLO	G
0473	OSLO	0301	OSLO	G
0474	OSLO	0301	OSLO	G
0475	OSLO	0301	OSLO	G
0476	OSLO	0301	OSLO	G
0477	OSLO	0301	OSLO	G
0478	OSLO	0301	OSLO	G
0479	OSLO	0301	OSLO	G
0480	OSLO	0301	OSLO	G
0481	OSLO	0301	OSLO	G
0482	OSLO	0301	OSLO	G
0483	OSLO	0301	OSLO	G
0484	OSLO	0301	OSLO	G
0485	OSLO	0301	OSLO	G
0486	OSLO	0301	OSLO	G
0487	OSLO	0301	OSLO	G
0488	OSLO	0301	OSLO	G
0489	OSLO	0301	OSLO	G
0490	OSLO	0301	OSLO	G
0491	OSLO	0301	OSLO	G
0492	OSLO	0301	OSLO	G
0493	OSLO	0301	OSLO	G
0494	OSLO	0301	OSLO	G
0495	OSLO	0301	OSLO	G
0496	OSLO	0301	OSLO	G
0501	OSLO	0301	OSLO	P
0502	OSLO	0301	OSLO	P
0503	OSLO	0301	OSLO	P
0504	OSLO	0301	OSLO	P
0505	OSLO	0301	OSLO	P
0506	OSLO	0301	OSLO	P
0507	OSLO	0301	OSLO	P
0508	OSLO	0301	OSLO	P
0509	OSLO	0301	OSLO	P
0510	OSLO	0301	OSLO	P
0511	OSLO	0301	OSLO	P
0512	OSLO	0301	OSLO	P
0513	OSLO	0301	OSLO	P
0515	OSLO	0301	OSLO	P
0516	OSLO	0301	OSLO	P
0517	OSLO	0301	OSLO	P
0518	OSLO	0301	OSLO	P
0520	OSLO	0301	OSLO	P
0540	OSLO	0301	OSLO	P
0550	OSLO	0301	OSLO	G
0551	OSLO	0301	OSLO	G
0552	OSLO	0301	OSLO	G
0553	OSLO	0301	OSLO	G
0554	OSLO	0301	OSLO	G
0555	OSLO	0301	OSLO	G
0556	OSLO	0301	OSLO	G
0557	OSLO	0301	OSLO	G
0558	OSLO	0301	OSLO	G
0559	OSLO	0301	OSLO	G
0560	OSLO	0301	OSLO	G
0561	OSLO	0301	OSLO	G
0562	OSLO	0301	OSLO	G
0563	OSLO	0301	OSLO	G
0564	OSLO	0301	OSLO	G
0565	OSLO	0301	OSLO	G
0566	OSLO	0301	OSLO	G
0567	OSLO	0301	OSLO	G
0568	OSLO	0301	OSLO	G
0569	OSLO	0301	OSLO	G
0570	OSLO	0301	OSLO	G
0571	OSLO	0301	OSLO	G
0572	OSLO	0301	OSLO	G
0573	OSLO	0301	OSLO	G
0574	OSLO	0301	OSLO	G
0575	OSLO	0301	OSLO	G
0576	OSLO	0301	OSLO	G
0577	OSLO	0301	OSLO	G
0578	OSLO	0301	OSLO	G
0579	OSLO	0301	OSLO	G
0580	OSLO	0301	OSLO	G
0581	OSLO	0301	OSLO	G
0582	OSLO	0301	OSLO	G
0583	OSLO	0301	OSLO	G
0584	OSLO	0301	OSLO	G
0585	OSLO	0301	OSLO	G
0586	OSLO	0301	OSLO	G
0587	OSLO	0301	OSLO	G
0588	OSLO	0301	OSLO	G
0589	OSLO	0301	OSLO	G
0590	OSLO	0301	OSLO	G
0591	OSLO	0301	OSLO	G
0592	OSLO	0301	OSLO	G
0593	OSLO	0301	OSLO	G
0594	OSLO	0301	OSLO	G
0595	OSLO	0301	OSLO	G
0596	OSLO	0301	OSLO	G
0597	OSLO	0301	OSLO	G
0598	OSLO	0301	OSLO	G
0601	OSLO	0301	OSLO	P
0602	OSLO	0301	OSLO	P
0603	OSLO	0301	OSLO	P
0604	OSLO	0301	OSLO	P
0605	OSLO	0301	OSLO	P
0606	OSLO	0301	OSLO	P
0607	OSLO	0301	OSLO	P
0608	OSLO	0301	OSLO	P
0609	OSLO	0301	OSLO	P
0611	OSLO	0301	OSLO	P
0612	OSLO	0301	OSLO	P
0613	OSLO	0301	OSLO	P
0614	OSLO	0301	OSLO	P
0615	OSLO	0301	OSLO	P
0616	OSLO	0301	OSLO	P
0617	OSLO	0301	OSLO	P
0618	OSLO	0301	OSLO	P
0619	OSLO	0301	OSLO	P
0620	OSLO	0301	OSLO	P
0621	OSLO	0301	OSLO	P
0622	OSLO	0301	OSLO	P
0623	OSLO	0301	OSLO	P
0624	OSLO	0301	OSLO	P
0626	OSLO	0301	OSLO	P
0650	OSLO	0301	OSLO	G
0651	OSLO	0301	OSLO	G
0652	OSLO	0301	OSLO	G
0653	OSLO	0301	OSLO	G
0654	OSLO	0301	OSLO	G
0655	OSLO	0301	OSLO	G
0656	OSLO	0301	OSLO	G
0657	OSLO	0301	OSLO	G
0658	OSLO	0301	OSLO	G
0659	OSLO	0301	OSLO	G
0660	OSLO	0301	OSLO	G
0661	OSLO	0301	OSLO	G
0662	OSLO	0301	OSLO	G
0663	OSLO	0301	OSLO	G
0664	OSLO	0301	OSLO	G
0665	OSLO	0301	OSLO	G
0666	OSLO	0301	OSLO	G
0667	OSLO	0301	OSLO	G
0668	OSLO	0301	OSLO	G
0669	OSLO	0301	OSLO	G
0670	OSLO	0301	OSLO	G
0671	OSLO	0301	OSLO	G
0672	OSLO	0301	OSLO	G
0673	OSLO	0301	OSLO	G
0674	OSLO	0301	OSLO	G
0675	OSLO	0301	OSLO	G
0676	OSLO	0301	OSLO	G
0677	OSLO	0301	OSLO	G
0678	OSLO	0301	OSLO	G
0679	OSLO	0301	OSLO	G
0680	OSLO	0301	OSLO	G
0681	OSLO	0301	OSLO	G
0682	OSLO	0301	OSLO	G
0683	OSLO	0301	OSLO	G
0684	OSLO	0301	OSLO	G
0685	OSLO	0301	OSLO	G
0686	OSLO	0301	OSLO	G
0687	OSLO	0301	OSLO	G
0688	OSLO	0301	OSLO	G
0689	OSLO	0301	OSLO	G
0690	OSLO	0301	OSLO	G
0691	OSLO	0301	OSLO	G
0692	OSLO	0301	OSLO	G
0693	OSLO	0301	OSLO	G
0694	OSLO	0301	OSLO	G
0701	OSLO	0301	OSLO	P
0702	OSLO	0301	OSLO	P
0705	OSLO	0301	OSLO	P
0710	OSLO	0301	OSLO	P
0712	OSLO	0301	OSLO	P
0750	OSLO	0301	OSLO	G
0751	OSLO	0301	OSLO	G
0752	OSLO	0301	OSLO	G
0753	OSLO	0301	OSLO	G
0754	OSLO	0301	OSLO	G
0755	OSLO	0301	OSLO	G
0756	OSLO	0301	OSLO	G
0757	OSLO	0301	OSLO	G
0758	OSLO	0301	OSLO	G
0760	OSLO	0301	OSLO	G
0763	OSLO	0301	OSLO	G
0764	OSLO	0301	OSLO	G
0765	OSLO	0301	OSLO	G
0766	OSLO	0301	OSLO	G
0767	OSLO	0301	OSLO	G
0768	OSLO	0301	OSLO	G
0770	OSLO	0301	OSLO	G
0771	OSLO	0301	OSLO	G
0772	OSLO	0301	OSLO	G
0773	OSLO	0301	OSLO	G
0774	OSLO	0301	OSLO	G
0775	OSLO	0301	OSLO	G
0776	OSLO	0301	OSLO	G
0777	OSLO	0301	OSLO	G
0778	OSLO	0301	OSLO	G
0779	OSLO	0301	OSLO	G
0781	OSLO	0301	OSLO	G
0782	OSLO	0301	OSLO	G
0783	OSLO	0301	OSLO	G
0784	OSLO	0301	OSLO	G
0785	OSLO	0301	OSLO	G
0786	OSLO	0301	OSLO	G
0787	OSLO	0301	OSLO	G
0788	OSLO	0301	OSLO	G
0789	OSLO	0301	OSLO	G
0790	OSLO	0301	OSLO	G
0791	OSLO	0301	OSLO	G
0801	OSLO	0301	OSLO	P
0805	OSLO	0301	OSLO	P
0806	OSLO	0301	OSLO	P
0807	OSLO	0301	OSLO	P
0840	OSLO	0301	OSLO	P
0850	OSLO	0301	OSLO	G
0851	OSLO	0301	OSLO	G
0852	OSLO	0301	OSLO	G
0853	OSLO	0301	OSLO	G
0854	OSLO	0301	OSLO	G
0855	OSLO	0301	OSLO	G
0856	OSLO	0301	OSLO	G
0857	OSLO	0301	OSLO	G
0858	OSLO	0301	OSLO	G
0860	OSLO	0301	OSLO	G
0861	OSLO	0301	OSLO	G
0862	OSLO	0301	OSLO	G
0863	OSLO	0301	OSLO	G
0864	OSLO	0301	OSLO	G
0870	OSLO	0301	OSLO	G
0871	OSLO	0301	OSLO	G
0872	OSLO	0301	OSLO	G
0873	OSLO	0301	OSLO	G
0874	OSLO	0301	OSLO	G
0875	OSLO	0301	OSLO	G
0876	OSLO	0301	OSLO	G
0877	OSLO	0301	OSLO	G
0880	OSLO	0301	OSLO	G
0881	OSLO	0301	OSLO	G
0882	OSLO	0301	OSLO	G
0883	OSLO	0301	OSLO	G
0884	OSLO	0301	OSLO	G
0890	OSLO	0301	OSLO	G
0891	OSLO	0301	OSLO	G
0901	OSLO	0301	OSLO	P
0902	OSLO	0301	OSLO	P
0903	OSLO	0301	OSLO	P
0904	OSLO	0301	OSLO	P
0905	OSLO	0301	OSLO	P
0907	OSLO	0301	OSLO	P
0908	OSLO	0301	OSLO	P
0913	OSLO	0301	OSLO	P
0914	OSLO	0301	OSLO	P
0915	OSLO	0301	OSLO	P
0950	OSLO	0301	OSLO	G
0951	OSLO	0301	OSLO	G
0952	OSLO	0301	OSLO	G
0953	OSLO	0301	OSLO	G
0954	OSLO	0301	OSLO	G
0955	OSLO	0301	OSLO	G
0956	OSLO	0301	OSLO	G
0957	OSLO	0301	OSLO	G
0958	OSLO	0301	OSLO	G
0959	OSLO	0301	OSLO	G
0960	OSLO	0301	OSLO	G
0962	OSLO	0301	OSLO	G
0963	OSLO	0301	OSLO	G
0964	OSLO	0301	OSLO	G
0968	OSLO	0301	OSLO	G
0969	OSLO	0301	OSLO	G
0970	OSLO	0301	OSLO	G
0971	OSLO	0301	OSLO	G
0972	OSLO	0301	OSLO	G
0973	OSLO	0301	OSLO	G
0975	OSLO	0301	OSLO	G
0976	OSLO	0301	OSLO	G
0977	OSLO	0301	OSLO	G
0978	OSLO	0301	OSLO	G
0979	OSLO	0301	OSLO	G
0980	OSLO	0301	OSLO	G
0981	OSLO	0301	OSLO	G
0982	OSLO	0301	OSLO	G
0983	OSLO	0301	OSLO	G
0984	OSLO	0301	OSLO	G
0985	OSLO	0301	OSLO	G
0986	OSLO	0301	OSLO	G
0987	OSLO	0301	OSLO	G
0988	OSLO	0301	OSLO	G
1001	OSLO	0301	OSLO	P
1003	OSLO	0301	OSLO	P
1005	OSLO	0301	OSLO	P
1006	OSLO	0301	OSLO	P
1007	OSLO	0301	OSLO	P
1008	OSLO	0301	OSLO	P
1009	OSLO	0301	OSLO	P
1011	OSLO	0301	OSLO	P
1051	OSLO	0301	OSLO	G
1052	OSLO	0301	OSLO	G
1053	OSLO	0301	OSLO	G
1054	OSLO	0301	OSLO	G
1055	OSLO	0301	OSLO	G
1056	OSLO	0301	OSLO	G
1061	OSLO	0301	OSLO	G
1062	OSLO	0301	OSLO	G
1063	OSLO	0301	OSLO	G
1064	OSLO	0301	OSLO	G
1065	OSLO	0301	OSLO	G
1067	OSLO	0301	OSLO	G
1068	OSLO	0301	OSLO	G
1069	OSLO	0301	OSLO	G
1071	OSLO	0301	OSLO	G
1081	OSLO	0301	OSLO	G
1083	OSLO	0301	OSLO	G
1084	OSLO	0301	OSLO	G
1086	OSLO	0301	OSLO	G
1087	OSLO	0301	OSLO	G
1088	OSLO	0301	OSLO	G
1089	OSLO	0301	OSLO	G
1101	OSLO	0301	OSLO	P
1102	OSLO	0301	OSLO	P
1108	OSLO	0301	OSLO	P
1109	OSLO	0301	OSLO	P
1112	OSLO	0301	OSLO	P
1150	OSLO	0301	OSLO	G
1151	OSLO	0301	OSLO	G
1152	OSLO	0301	OSLO	G
1153	OSLO	0301	OSLO	G
1154	OSLO	0301	OSLO	G
1155	OSLO	0301	OSLO	G
1156	OSLO	0301	OSLO	G
1157	OSLO	0301	OSLO	G
1158	OSLO	0301	OSLO	G
1160	OSLO	0301	OSLO	G
1161	OSLO	0301	OSLO	G
1162	OSLO	0301	OSLO	G
1163	OSLO	0301	OSLO	G
1164	OSLO	0301	OSLO	G
1165	OSLO	0301	OSLO	G
1166	OSLO	0301	OSLO	G
1167	OSLO	0301	OSLO	G
1168	OSLO	0301	OSLO	G
1169	OSLO	0301	OSLO	G
1170	OSLO	0301	OSLO	G
1172	OSLO	0301	OSLO	G
1176	OSLO	0301	OSLO	G
1177	OSLO	0301	OSLO	G
1178	OSLO	0301	OSLO	G
1179	OSLO	0301	OSLO	G
1181	OSLO	0301	OSLO	G
1182	OSLO	0301	OSLO	G
1184	OSLO	0301	OSLO	G
1185	OSLO	0301	OSLO	G
1187	OSLO	0301	OSLO	G
1188	OSLO	0301	OSLO	G
1189	OSLO	0301	OSLO	G
1201	OSLO	0301	OSLO	P
1203	OSLO	0301	OSLO	P
1204	OSLO	0301	OSLO	P
1205	OSLO	0301	OSLO	P
1207	OSLO	0301	OSLO	P
1214	OSLO	0301	OSLO	P
1215	OSLO	0301	OSLO	P
1250	OSLO	0301	OSLO	G
1251	OSLO	0301	OSLO	G
1252	OSLO	0301	OSLO	G
1253	OSLO	0301	OSLO	G
1254	OSLO	0301	OSLO	G
1255	OSLO	0301	OSLO	G
1256	OSLO	0301	OSLO	G
1257	OSLO	0301	OSLO	G
1258	OSLO	0301	OSLO	G
1259	OSLO	0301	OSLO	G
1262	OSLO	0301	OSLO	G
1263	OSLO	0301	OSLO	G
1266	OSLO	0301	OSLO	G
1270	OSLO	0301	OSLO	G
1271	OSLO	0301	OSLO	G
1272	OSLO	0301	OSLO	G
1273	OSLO	0301	OSLO	G
1274	OSLO	0301	OSLO	G
1275	OSLO	0301	OSLO	G
1278	OSLO	0301	OSLO	G
1279	OSLO	0301	OSLO	G
1281	OSLO	0301	OSLO	G
1283	OSLO	0301	OSLO	G
1284	OSLO	0301	OSLO	G
1285	OSLO	0301	OSLO	G
1286	OSLO	0301	OSLO	G
1290	OSLO	0301	OSLO	G
1291	OSLO	0301	OSLO	G
1294	OSLO	0301	OSLO	G
1295	OSLO	0301	OSLO	G
1300	SANDVIKA	3201	BÆRUM	P
1301	SANDVIKA	3201	BÆRUM	P
1302	SANDVIKA	3201	BÆRUM	P
1303	SANDVIKA	3201	BÆRUM	P
1304	SANDVIKA	3201	BÆRUM	P
1305	HASLUM	3201	BÆRUM	P
1306	SANDVIKA	3201	BÆRUM	P
1307	FORNEBU	3201	BÆRUM	P
1308	JAR	3201	BÆRUM	P
1309	RUD	3201	BÆRUM	P
1311	HØVIKODDEN	3201	BÆRUM	G
1312	SLEPENDEN	3201	BÆRUM	P
1313	VØYENENGA	3201	BÆRUM	P
1314	VØYENENGA	3201	BÆRUM	P
1316	EIKSMARKA	3201	BÆRUM	P
1317	BÆRUMS VERK	3201	BÆRUM	P
1318	BEKKESTUA	3201	BÆRUM	P
1319	BEKKESTUA	3201	BÆRUM	P
1321	STABEKK	3201	BÆRUM	P
1322	HØVIK	3201	BÆRUM	P
1323	HØVIK	3201	BÆRUM	P
1324	LYSAKER	3201	BÆRUM	P
1325	LYSAKER	3201	BÆRUM	P
1326	LYSAKER	3201	BÆRUM	P
1327	LYSAKER	3201	BÆRUM	P
1328	HØVIK	3201	BÆRUM	P
1329	LOMMEDALEN	3201	BÆRUM	P
1330	FORNEBU	3201	BÆRUM	P
1331	FORNEBU	3201	BÆRUM	P
1332	ØSTERÅS	3201	BÆRUM	P
1333	KOLSÅS	3201	BÆRUM	P
1334	RYKKINN	3201	BÆRUM	P
1335	SNARØYA	3201	BÆRUM	P
1336	SANDVIKA	3201	BÆRUM	G
1337	SANDVIKA	3201	BÆRUM	G
1338	SANDVIKA	3201	BÆRUM	G
1339	VØYENENGA	3201	BÆRUM	G
1340	SKUI	3201	BÆRUM	G
1341	SLEPENDEN	3201	BÆRUM	G
1342	GJETTUM	3201	BÆRUM	P
1344	HASLUM	3201	BÆRUM	G
1346	GJETTUM	3201	BÆRUM	G
1348	RYKKINN	3201	BÆRUM	G
1349	RYKKINN	3201	BÆRUM	G
1350	LOMMEDALEN	3201	BÆRUM	G
1351	RUD	3201	BÆRUM	G
1352	KOLSÅS	3201	BÆRUM	G
1353	BÆRUMS VERK	3201	BÆRUM	G
1354	BÆRUMS VERK	3201	BÆRUM	G
1356	BEKKESTUA	3201	BÆRUM	G
1357	BEKKESTUA	3201	BÆRUM	G
1358	JAR	3201	BÆRUM	G
1359	EIKSMARKA	3201	BÆRUM	G
1360	FORNEBU	3201	BÆRUM	G
1361	ØSTERÅS	3201	BÆRUM	G
1362	HOSLE	3201	BÆRUM	G
1363	HØVIK	3201	BÆRUM	G
1364	FORNEBU	3201	BÆRUM	G
1365	BLOMMENHOLM	3201	BÆRUM	G
1366	LYSAKER	3201	BÆRUM	G
1367	SNARØYA	3201	BÆRUM	G
1368	STABEKK	3201	BÆRUM	G
1369	STABEKK	3201	BÆRUM	G
1371	ASKER	3203	ASKER	P
1372	ASKER	3203	ASKER	P
1373	ASKER	3203	ASKER	P
1375	BILLINGSTAD	3203	ASKER	P
1376	BILLINGSTAD	3203	ASKER	P
1377	BILLINGSTAD	3203	ASKER	P
1378	NESBRU	3203	ASKER	P
1379	NESBRU	3203	ASKER	P
1380	HEGGEDAL	3203	ASKER	P
1381	VETTRE	3203	ASKER	P
1383	ASKER	3203	ASKER	G
1384	ASKER	3203	ASKER	G
1385	ASKER	3203	ASKER	G
1386	ASKER	3203	ASKER	G
1387	ASKER	3203	ASKER	G
1388	BORGEN	3203	ASKER	G
1389	HEGGEDAL	3203	ASKER	G
1390	VOLLEN	3203	ASKER	G
1391	VOLLEN	3203	ASKER	G
1392	VETTRE	3203	ASKER	G
1393	VOLLEN	3203	ASKER	P
1394	NESBRU	3203	ASKER	G
1395	HVALSTAD	3203	ASKER	G
1396	BILLINGSTAD	3203	ASKER	G
1397	NESØYA	3203	ASKER	G
1399	ASKER	3203	ASKER	P
1400	SKI	3207	NORDRE FOLLO	G
1401	SKI	3207	NORDRE FOLLO	P
1402	SKI	3207	NORDRE FOLLO	P
1403	LANGHUS	3207	NORDRE FOLLO	P
1404	SIGGERUD	3207	NORDRE FOLLO	G
1405	LANGHUS	3207	NORDRE FOLLO	G
1406	SKI	3207	NORDRE FOLLO	G
1407	VINTERBRO	3218	ÅS	G
1408	KRÅKSTAD	3207	NORDRE FOLLO	G
1409	SKOTBU	3207	NORDRE FOLLO	G
1410	KOLBOTN	3207	NORDRE FOLLO	G
1411	KOLBOTN	3207	NORDRE FOLLO	P
1412	SOFIEMYR	3207	NORDRE FOLLO	G
1413	TÅRNÅSEN	3207	NORDRE FOLLO	G
1414	TROLLÅSEN	3207	NORDRE FOLLO	G
1415	OPPEGÅRD	3207	NORDRE FOLLO	G
1416	OPPEGÅRD	3207	NORDRE FOLLO	P
1417	SOFIEMYR	3207	NORDRE FOLLO	P
1418	KOLBOTN	3207	NORDRE FOLLO	P
1419	OPPEGÅRD	3207	NORDRE FOLLO	P
1420	SVARTSKOG	3207	NORDRE FOLLO	G
1421	TROLLÅSEN	3207	NORDRE FOLLO	P
1422	SIGGERUD	3207	NORDRE FOLLO	P
1423	SKI	3207	NORDRE FOLLO	G
1424	SKI	3207	NORDRE FOLLO	G
1425	SKI	3207	NORDRE FOLLO	G
1429	VINTERBRO	3218	ÅS	P
1430	ÅS	3218	ÅS	G
1431	ÅS	3218	ÅS	P
1432	ÅS	3218	ÅS	P
1433	ÅS	3218	ÅS	G
1434	ÅS	3218	ÅS	G
1435	ÅS	3218	ÅS	G
1440	DRØBAK	3214	FROGN	G
1441	DRØBAK	3214	FROGN	P
1442	DRØBAK	3214	FROGN	P
1443	DRØBAK	3214	FROGN	G
1444	DRØBAK	3214	FROGN	G
1445	DRØBAK	3214	FROGN	G
1446	DRØBAK	3214	FROGN	G
1447	DRØBAK	3214	FROGN	G
1448	DRØBAK	3214	FROGN	G
1449	DRØBAK	3214	FROGN	G
1450	NESODDTANGEN	3212	NESODDEN	G
1451	NESODDTANGEN	3212	NESODDEN	P
1452	NESODDTANGEN	3212	NESODDEN	G
1453	BJØRNEMYR	3212	NESODDEN	G
1454	FAGERSTRAND	3212	NESODDEN	G
1455	NORDRE FROGN	3214	FROGN	G
1456	NESODDTANGEN	3212	NESODDEN	G
1457	FAGERSTRAND	3212	NESODDEN	P
1458	FJELLSTRAND	3212	NESODDEN	G
1459	NESODDEN	3212	NESODDEN	G
1461	LØRENSKOG	3222	LØRENSKOG	G
1462	FJELLHAMAR	3222	LØRENSKOG	G
1463	FJELLHAMAR	3222	LØRENSKOG	G
1464	FJELLHAMAR	3222	LØRENSKOG	G
1465	STRØMMEN	3205	LILLESTRØM	G
1466	STRØMMEN	3205	LILLESTRØM	G
1467	STRØMMEN	3205	LILLESTRØM	G
1468	FINSTADJORDET	3222	LØRENSKOG	P
1469	RASTA	3222	LØRENSKOG	P
1470	LØRENSKOG	3222	LØRENSKOG	G
1471	LØRENSKOG	3222	LØRENSKOG	P
1472	FJELLHAMAR	3222	LØRENSKOG	G
1473	LØRENSKOG	3222	LØRENSKOG	G
1474	LØRENSKOG	3222	LØRENSKOG	G
1475	FINSTADJORDET	3222	LØRENSKOG	G
1476	RASTA	3222	LØRENSKOG	G
1477	FJELLHAMAR	3222	LØRENSKOG	P
1478	LØRENSKOG	3222	LØRENSKOG	P
1479	KURLAND	3222	LØRENSKOG	G
1480	SLATTUM	3232	NITTEDAL	G
1481	HAGAN	3232	NITTEDAL	G
1482	NITTEDAL	3232	NITTEDAL	G
1483	HAGAN	3232	NITTEDAL	P
1484	HAKADAL	3232	NITTEDAL	G
1485	HAKADAL	3232	NITTEDAL	P
1486	NITTEDAL	3232	NITTEDAL	P
1487	HAKADAL	3232	NITTEDAL	G
1488	HAKADAL	3232	NITTEDAL	G
1501	MOSS	3103	MOSS	P
1502	MOSS	3103	MOSS	P
1503	MOSS	3103	MOSS	P
1504	MOSS	3103	MOSS	P
1506	MOSS	3103	MOSS	P
1508	MOSS	3103	MOSS	P
1509	MOSS	3103	MOSS	P
1510	MOSS	3103	MOSS	P
1511	MOSS	3103	MOSS	G
1512	MOSS	3103	MOSS	G
1513	MOSS	3103	MOSS	G
1514	MOSS	3103	MOSS	G
1515	MOSS	3103	MOSS	G
1516	MOSS	3103	MOSS	G
1517	MOSS	3103	MOSS	G
1518	MOSS	3103	MOSS	G
1519	MOSS	3103	MOSS	G
1520	MOSS	3103	MOSS	P
1521	MOSS	3103	MOSS	P
1522	MOSS	3103	MOSS	P
1523	MOSS	3103	MOSS	G
1524	MOSS	3103	MOSS	G
1525	MOSS	3103	MOSS	G
1526	MOSS	3103	MOSS	G
1528	MOSS	3103	MOSS	G
1529	MOSS	3103	MOSS	G
1530	MOSS	3103	MOSS	G
1531	MOSS	3103	MOSS	G
1532	MOSS	3103	MOSS	G
1533	MOSS	3103	MOSS	G
1534	MOSS	3103	MOSS	G
1535	MOSS	3103	MOSS	G
1536	MOSS	3103	MOSS	G
1537	MOSS	3103	MOSS	G
1538	MOSS	3103	MOSS	G
1539	MOSS	3103	MOSS	G
1540	VESTBY	3216	VESTBY	G
1541	VESTBY	3216	VESTBY	P
1542	VESTBY	3216	VESTBY	G
1543	VESTBY	3216	VESTBY	G
1544	VESTBY	3216	VESTBY	G
1545	HVITSTEN	3216	VESTBY	G
1550	HØLEN	3216	VESTBY	G
1553	SON	3216	VESTBY	G
1554	SON	3216	VESTBY	G
1555	SON	3216	VESTBY	G
1556	SON	3216	VESTBY	P
1560	LARKOLLEN	3103	MOSS	G
1561	LARKOLLEN	3103	MOSS	P
1570	DILLING	3103	MOSS	G
1580	RYGGE	3103	MOSS	G
1581	RYGGE	3103	MOSS	P
1590	RYGGE	3103	MOSS	P
1591	SPERREBOTN	3114	VÅLER (ØSTFOLD)	G
1592	VÅLER I ØSTFOLD	3114	VÅLER (ØSTFOLD)	G
1593	SVINNDAL	3114	VÅLER (ØSTFOLD)	G
1594	VÅLER I ØSTFOLD	3114	VÅLER (ØSTFOLD)	P
1596	MOSS	3103	MOSS	G
1597	MOSS	3103	MOSS	G
1598	MOSS	3103	MOSS	G
1599	MOSS	3103	MOSS	G
1601	FREDRIKSTAD	3107	FREDRIKSTAD	P
1602	FREDRIKSTAD	3107	FREDRIKSTAD	P
1604	FREDRIKSTAD	3107	FREDRIKSTAD	G
1605	FREDRIKSTAD	3107	FREDRIKSTAD	G
1606	FREDRIKSTAD	3107	FREDRIKSTAD	G
1607	FREDRIKSTAD	3107	FREDRIKSTAD	G
1608	FREDRIKSTAD	3107	FREDRIKSTAD	G
1609	FREDRIKSTAD	3107	FREDRIKSTAD	P
1610	FREDRIKSTAD	3107	FREDRIKSTAD	G
1612	FREDRIKSTAD	3107	FREDRIKSTAD	P
1613	FREDRIKSTAD	3107	FREDRIKSTAD	G
1614	FREDRIKSTAD	3107	FREDRIKSTAD	G
1615	FREDRIKSTAD	3107	FREDRIKSTAD	G
1616	FREDRIKSTAD	3107	FREDRIKSTAD	P
1617	FREDRIKSTAD	3107	FREDRIKSTAD	G
1618	FREDRIKSTAD	3107	FREDRIKSTAD	G
1619	FREDRIKSTAD	3107	FREDRIKSTAD	G
1620	GRESSVIK	3107	FREDRIKSTAD	P
1621	GRESSVIK	3107	FREDRIKSTAD	G
1622	GRESSVIK	3107	FREDRIKSTAD	G
1623	GRESSVIK	3107	FREDRIKSTAD	G
1624	GRESSVIK	3107	FREDRIKSTAD	G
1625	MANSTAD	3107	FREDRIKSTAD	P
1626	MANSTAD	3107	FREDRIKSTAD	G
1628	ENGELSVIKEN	3107	FREDRIKSTAD	G
1629	GAMLE FREDRIKSTAD	3107	FREDRIKSTAD	P
1630	GAMLE FREDRIKSTAD	3107	FREDRIKSTAD	G
1632	GAMLE FREDRIKSTAD	3107	FREDRIKSTAD	G
1633	GAMLE FREDRIKSTAD	3107	FREDRIKSTAD	G
1634	GAMLE FREDRIKSTAD	3107	FREDRIKSTAD	G
1636	GAMLE FREDRIKSTAD	3107	FREDRIKSTAD	G
1637	GAMLE FREDRIKSTAD	3107	FREDRIKSTAD	G
1638	GAMLE FREDRIKSTAD	3107	FREDRIKSTAD	P
1639	GAMLE FREDRIKSTAD	3107	FREDRIKSTAD	G
1640	RÅDE	3112	RÅDE	G
1641	RÅDE	3112	RÅDE	P
1642	SALTNES	3112	RÅDE	G
1643	RÅDE	3112	RÅDE	G
1650	SELLEBAKK	3107	FREDRIKSTAD	P
1651	SELLEBAKK	3107	FREDRIKSTAD	G
1653	SELLEBAKK	3107	FREDRIKSTAD	G
1654	SELLEBAKK	3107	FREDRIKSTAD	G
1655	SELLEBAKK	3107	FREDRIKSTAD	G
1657	TORP	3107	FREDRIKSTAD	G
1658	TORP	3107	FREDRIKSTAD	G
1659	TORP	3107	FREDRIKSTAD	G
1661	ROLVSØY	3107	FREDRIKSTAD	G
1662	ROLVSØY	3107	FREDRIKSTAD	P
1663	ROLVSØY	3107	FREDRIKSTAD	G
1664	ROLVSØY	3107	FREDRIKSTAD	G
1665	ROLVSØY	3107	FREDRIKSTAD	G
1666	ROLVSØY	3107	FREDRIKSTAD	G
1667	ROLVSØY	3107	FREDRIKSTAD	G
1670	KRÅKERØY	3107	FREDRIKSTAD	P
1671	KRÅKERØY	3107	FREDRIKSTAD	G
1672	KRÅKERØY	3107	FREDRIKSTAD	G
1673	KRÅKERØY	3107	FREDRIKSTAD	G
1675	KRÅKERØY	3107	FREDRIKSTAD	G
1676	KRÅKERØY	3107	FREDRIKSTAD	G
1678	KRÅKERØY	3107	FREDRIKSTAD	G
1679	KRÅKERØY	3107	FREDRIKSTAD	G
1680	SKJÆRHALDEN	3110	HVALER	G
1682	SKJÆRHALDEN	3110	HVALER	P
1683	VESTERØY	3110	HVALER	P
1684	VESTERØY	3110	HVALER	G
1690	HERFØL	3110	HVALER	G
1692	NEDGÅRDEN	3110	HVALER	G
1701	SARPSBORG	3105	SARPSBORG	P
1702	SARPSBORG	3105	SARPSBORG	P
1703	SARPSBORG	3105	SARPSBORG	P
1704	SARPSBORG	3105	SARPSBORG	P
1705	SARPSBORG	3105	SARPSBORG	P
1706	SARPSBORG	3105	SARPSBORG	G
1707	SARPSBORG	3105	SARPSBORG	G
1708	SARPSBORG	3105	SARPSBORG	G
1709	SARPSBORG	3105	SARPSBORG	G
1710	SARPSBORG	3105	SARPSBORG	G
1711	SARPSBORG	3105	SARPSBORG	G
1712	GRÅLUM	3105	SARPSBORG	G
1713	GRÅLUM	3105	SARPSBORG	P
1714	GRÅLUM	3105	SARPSBORG	B
1715	YVEN	3105	SARPSBORG	G
1718	GREÅKER	3105	SARPSBORG	G
1719	GREÅKER	3105	SARPSBORG	G
1720	GREÅKER	3105	SARPSBORG	P
1721	SARPSBORG	3105	SARPSBORG	G
1722	SARPSBORG	3105	SARPSBORG	G
1723	SARPSBORG	3105	SARPSBORG	G
1724	SARPSBORG	3105	SARPSBORG	G
1725	SARPSBORG	3105	SARPSBORG	G
1726	SARPSBORG	3105	SARPSBORG	G
1727	SARPSBORG	3105	SARPSBORG	G
1730	ISE	3105	SARPSBORG	G
1733	HAFSLUNDSØY	3105	SARPSBORG	P
1734	HAFSLUNDSØY	3105	SARPSBORG	G
1735	VARTEIG	3105	SARPSBORG	G
1738	BORGENHAUGEN	3105	SARPSBORG	G
1739	BORGENHAUGEN	3105	SARPSBORG	G
1740	BORGENHAUGEN	3105	SARPSBORG	P
1742	KLAVESTADHAUGEN	3105	SARPSBORG	P
1743	KLAVESTADHAUGEN	3105	SARPSBORG	G
1745	SKJEBERG	3105	SARPSBORG	P
1746	SKJEBERG	3105	SARPSBORG	G
1747	SKJEBERG	3105	SARPSBORG	G
1751	HALDEN	3101	HALDEN	P
1752	HALDEN	3101	HALDEN	P
1753	HALDEN	3101	HALDEN	P
1754	HALDEN	3101	HALDEN	P
1757	HALDEN	3101	HALDEN	P
1759	HALDEN	3101	HALDEN	P
1760	HALDEN	3101	HALDEN	P
1761	HALDEN	3101	HALDEN	P
1762	HALDEN	3101	HALDEN	P
1763	HALDEN	3101	HALDEN	G
1764	HALDEN	3101	HALDEN	G
1765	HALDEN	3101	HALDEN	G
1766	HALDEN	3101	HALDEN	G
1767	HALDEN	3101	HALDEN	G
1768	HALDEN	3101	HALDEN	G
1769	HALDEN	3101	HALDEN	G
1771	HALDEN	3101	HALDEN	G
1772	HALDEN	3101	HALDEN	G
1776	HALDEN	3101	HALDEN	G
1777	HALDEN	3101	HALDEN	G
1778	HALDEN	3101	HALDEN	G
1779	HALDEN	3101	HALDEN	G
1781	HALDEN	3101	HALDEN	G
1782	HALDEN	3101	HALDEN	G
1783	HALDEN	3101	HALDEN	G
1784	HALDEN	3101	HALDEN	G
1785	HALDEN	3101	HALDEN	G
1786	HALDEN	3101	HALDEN	G
1787	HALDEN	3101	HALDEN	P
1788	HALDEN	3101	HALDEN	G
1789	BERG I ØSTFOLD	3101	HALDEN	G
1790	TISTEDAL	3101	HALDEN	P
1791	TISTEDAL	3101	HALDEN	G
1792	TISTEDAL	3101	HALDEN	G
1793	TISTEDAL	3101	HALDEN	G
1794	SPONVIKA	3101	HALDEN	G
1796	KORNSJØ	3101	HALDEN	G
1798	AREMARK	3124	AREMARK	G
1799	AREMARK	3124	AREMARK	P
1801	ASKIM	3118	INDRE ØSTFOLD	P
1802	ASKIM	3118	INDRE ØSTFOLD	P
1803	ASKIM	3118	INDRE ØSTFOLD	P
1804	SPYDEBERG	3118	INDRE ØSTFOLD	P
1805	TOMTER	3118	INDRE ØSTFOLD	P
1806	SKIPTVET	3116	SKIPTVET	P
1807	ASKIM	3118	INDRE ØSTFOLD	G
1808	ASKIM	3118	INDRE ØSTFOLD	G
1809	ASKIM	3118	INDRE ØSTFOLD	G
1811	ASKIM	3118	INDRE ØSTFOLD	G
1812	ASKIM	3118	INDRE ØSTFOLD	G
1813	ASKIM	3118	INDRE ØSTFOLD	G
1814	ASKIM	3118	INDRE ØSTFOLD	G
1815	ASKIM	3118	INDRE ØSTFOLD	G
1816	SKIPTVET	3116	SKIPTVET	G
1820	SPYDEBERG	3118	INDRE ØSTFOLD	G
1821	SPYDEBERG	3118	INDRE ØSTFOLD	G
1823	KNAPSTAD	3118	INDRE ØSTFOLD	G
1825	TOMTER	3118	INDRE ØSTFOLD	G
1827	HOBØL	3118	INDRE ØSTFOLD	G
1828	HOBØL	3118	INDRE ØSTFOLD	P
1830	ASKIM	3118	INDRE ØSTFOLD	G
1831	ASKIM	3118	INDRE ØSTFOLD	G
1832	ASKIM	3118	INDRE ØSTFOLD	G
1833	ASKIM	3118	INDRE ØSTFOLD	P
1850	MYSEN	3118	INDRE ØSTFOLD	G
1851	MYSEN	3118	INDRE ØSTFOLD	P
1852	MYSEN	3118	INDRE ØSTFOLD	G
1859	SLITU	3118	INDRE ØSTFOLD	G
1860	TRØGSTAD	3118	INDRE ØSTFOLD	G
1861	TRØGSTAD	3118	INDRE ØSTFOLD	P
1866	BÅSTAD	3118	INDRE ØSTFOLD	G
1867	BÅSTAD	3118	INDRE ØSTFOLD	P
1870	ØRJE	3122	MARKER	G
1871	ØRJE	3122	MARKER	P
1875	OTTEID	3122	MARKER	G
1878	HÆRLAND	3118	INDRE ØSTFOLD	G
1880	EIDSBERG	3118	INDRE ØSTFOLD	G
1890	RAKKESTAD	3120	RAKKESTAD	G
1891	RAKKESTAD	3120	RAKKESTAD	P
1892	DEGERNES	3120	RAKKESTAD	G
1893	DEGERNES	3120	RAKKESTAD	P
1894	RAKKESTAD	3120	RAKKESTAD	G
1900	FETSUND	3205	LILLESTRØM	G
1901	FETSUND	3205	LILLESTRØM	P
1903	GAN	3205	LILLESTRØM	G
1910	ENEBAKKNESET	3205	LILLESTRØM	G
1911	FLATEBY	3220	ENEBAKK	G
1912	ENEBAKK	3220	ENEBAKK	G
1914	YTRE ENEBAKK	3220	ENEBAKK	G
1916	FLATEBY	3220	ENEBAKK	P
1917	YTRE ENEBAKK	3220	ENEBAKK	P
1920	SØRUMSAND	3205	LILLESTRØM	G
1921	SØRUMSAND	3205	LILLESTRØM	P
1923	SØRUM	3205	LILLESTRØM	G
1924	SØRUM	3205	LILLESTRØM	P
1925	BLAKER	3205	LILLESTRØM	G
1926	BLAKER	3205	LILLESTRØM	P
1927	RÅNÅSFOSS	3228	NES	G
1928	AULI	3228	NES	P
1929	AULI	3228	NES	G
1930	AURSKOG	3226	AURSKOG-HØLAND	G
1931	AURSKOG	3226	AURSKOG-HØLAND	P
1940	BJØRKELANGEN	3226	AURSKOG-HØLAND	G
1941	BJØRKELANGEN	3226	AURSKOG-HØLAND	P
1950	RØMSKOG	3226	AURSKOG-HØLAND	G
1951	RØMSKOG	3226	AURSKOG-HØLAND	P
1954	SETSKOG	3226	AURSKOG-HØLAND	G
1960	LØKEN	3226	AURSKOG-HØLAND	G
1961	LØKEN	3226	AURSKOG-HØLAND	P
1963	FOSSER	3226	AURSKOG-HØLAND	G
1970	HEMNES	3226	AURSKOG-HØLAND	G
1971	HEMNES	3226	AURSKOG-HØLAND	P
2000	LILLESTRØM	3205	LILLESTRØM	G
2001	LILLESTRØM	3205	LILLESTRØM	P
2003	LILLESTRØM	3205	LILLESTRØM	G
2004	LILLESTRØM	3205	LILLESTRØM	G
2005	RÆLINGEN	3224	RÆLINGEN	G
2006	LØVENSTAD	3224	RÆLINGEN	G
2007	KJELLER	3205	LILLESTRØM	G
2008	FJERDINGBY	3224	RÆLINGEN	G
2009	NORDBY	3224	RÆLINGEN	G
2010	STRØMMEN	3205	LILLESTRØM	G
2011	STRØMMEN	3205	LILLESTRØM	P
2012	LILLESTRØM	3205	LILLESTRØM	P
2013	SKJETTEN	3205	LILLESTRØM	G
2014	BLYSTADLIA	3224	RÆLINGEN	G
2015	LEIRSUND	3205	LILLESTRØM	G
2016	FROGNER	3205	LILLESTRØM	G
2017	FROGNER	3205	LILLESTRØM	P
2018	LØVENSTAD	3224	RÆLINGEN	P
2019	SKEDSMOKORSET	3205	LILLESTRØM	G
2020	SKEDSMOKORSET	3205	LILLESTRØM	G
2021	SKEDSMOKORSET	3205	LILLESTRØM	P
2022	GJERDRUM	3230	GJERDRUM	G
2023	SKEDSMOKORSET	3205	LILLESTRØM	P
2024	GJERDRUM	3230	GJERDRUM	P
2025	FJERDINGBY	3224	RÆLINGEN	P
2026	SKJETTEN	3205	LILLESTRØM	P
2027	KJELLER	3205	LILLESTRØM	P
2028	LILLESTRØM	3205	LILLESTRØM	P
2029	RÆLINGEN	3224	RÆLINGEN	P
2030	NANNESTAD	3238	NANNESTAD	G
2031	NANNESTAD	3238	NANNESTAD	P
2032	MAURA	3238	NANNESTAD	G
2033	ÅSGREINA	3238	NANNESTAD	G
2034	HOLTER	3238	NANNESTAD	G
2035	HOLTER	3238	NANNESTAD	P
2036	MAURA	3238	NANNESTAD	P
2040	KLØFTA	3209	ULLENSAKER	G
2041	KLØFTA	3209	ULLENSAKER	P
2050	JESSHEIM	3209	ULLENSAKER	G
2051	JESSHEIM	3209	ULLENSAKER	P
2052	JESSHEIM	3209	ULLENSAKER	G
2053	JESSHEIM	3209	ULLENSAKER	G
2054	MOGREINA	3209	ULLENSAKER	G
2055	NORDKISA	3209	ULLENSAKER	G
2056	ALGARHEIM	3209	ULLENSAKER	G
2057	JESSHEIM	3209	ULLENSAKER	P
2058	SESSVOLLMOEN	3209	ULLENSAKER	G
2060	GARDERMOEN	3209	ULLENSAKER	G
2061	GARDERMOEN	3209	ULLENSAKER	P
2062	JESSHEIM	3209	ULLENSAKER	P
2063	JESSHEIM	3209	ULLENSAKER	G
2066	JESSHEIM	3209	ULLENSAKER	G
2067	JESSHEIM	3209	ULLENSAKER	G
2068	JESSHEIM	3209	ULLENSAKER	G
2069	JESSHEIM	3209	ULLENSAKER	G
2070	RÅHOLT	3240	EIDSVOLL	G
2071	RÅHOLT	3240	EIDSVOLL	P
2072	DAL	3240	EIDSVOLL	G
2073	BØN	3240	EIDSVOLL	G
2074	EIDSVOLL VERK	3240	EIDSVOLL	G
2076	DAL	3240	EIDSVOLL	P
2080	EIDSVOLL	3240	EIDSVOLL	G
2081	EIDSVOLL	3240	EIDSVOLL	P
2090	HURDAL	3242	HURDAL	G
2091	HURDAL	3242	HURDAL	P
2092	MINNESUND	3240	EIDSVOLL	G
2093	FEIRING	3240	EIDSVOLL	G
2094	MINNESUND	3240	EIDSVOLL	P
2100	SKARNES	3415	SØR-ODAL	G
2101	SKARNES	3415	SØR-ODAL	P
2110	SLÅSTAD	3415	SØR-ODAL	G
2114	DISENÅ	3415	SØR-ODAL	G
2116	SANDER	3415	SØR-ODAL	G
2120	SAGSTUA	3414	NORD-ODAL	G
2121	SAGSTUA	3414	NORD-ODAL	P
2123	BRUVOLL	3414	NORD-ODAL	G
2130	KNAPPER	3414	NORD-ODAL	G
2132	GARDVIK	3414	NORD-ODAL	P
2133	GARDVIK	3414	NORD-ODAL	G
2134	AUSTVATN	3414	NORD-ODAL	G
2150	ÅRNES	3228	NES	G
2151	ÅRNES	3228	NES	P
2160	VORMSUND	3228	NES	G
2161	VORMSUND	3228	NES	P
2162	BRÅRUD	3228	NES	G
2163	SKOGBYGDA	3228	NES	P
2164	SKOGBYGDA	3228	NES	G
2165	HVAM	3228	NES	G
2166	OPPAKER	3228	NES	G
2167	HVAM	3228	NES	P
2170	FENSTAD	3228	NES	G
2201	KONGSVINGER	3401	KONGSVINGER	P
2202	KONGSVINGER	3401	KONGSVINGER	P
2203	KONGSVINGER	3401	KONGSVINGER	P
2204	KONGSVINGER	3401	KONGSVINGER	P
2205	KONGSVINGER	3401	KONGSVINGER	P
2206	KONGSVINGER	3401	KONGSVINGER	P
2207	KONGSVINGER	3401	KONGSVINGER	P
2208	KONGSVINGER	3401	KONGSVINGER	G
2209	KONGSVINGER	3401	KONGSVINGER	G
2210	GRANLI	3401	KONGSVINGER	G
2211	KONGSVINGER	3401	KONGSVINGER	G
2212	KONGSVINGER	3401	KONGSVINGER	G
2213	KONGSVINGER	3401	KONGSVINGER	G
2214	KONGSVINGER	3401	KONGSVINGER	G
2215	ROVERUD	3401	KONGSVINGER	P
2216	ROVERUD	3401	KONGSVINGER	G
2217	HOKKÅSEN	3401	KONGSVINGER	G
2218	LUNDERSÆTER	3401	KONGSVINGER	G
2219	BRANDVAL	3401	KONGSVINGER	G
2220	ÅBOGEN	3416	EIDSKOG	G
2223	GALTERUD	3415	SØR-ODAL	G
2224	AUSTMARKA	3401	KONGSVINGER	G
2225	KONGSVINGER	3401	KONGSVINGER	P
2226	KONGSVINGER	3401	KONGSVINGER	P
2227	AUSTMARKA	3401	KONGSVINGER	P
2230	SKOTTERUD	3416	EIDSKOG	G
2231	SKOTTERUD	3416	EIDSKOG	P
2232	TOBØL	3416	EIDSKOG	G
2233	VESTMARKA	3416	EIDSKOG	G
2235	MATRAND	3416	EIDSKOG	G
2240	MAGNOR	3416	EIDSKOG	G
2241	MAGNOR	3416	EIDSKOG	P
2251	GRUE FINNSKOG	3417	GRUE	P
2256	GRUE FINNSKOG	3417	GRUE	G
2260	KIRKENÆR	3417	GRUE	G
2261	KIRKENÆR	3417	GRUE	P
2264	GRINDER	3417	GRUE	G
2265	NAMNÅ	3417	GRUE	G
2266	ARNEBERG	3418	ÅSNES	G
2270	FLISA	3418	ÅSNES	G
2271	FLISA	3418	ÅSNES	P
2280	GJESÅSEN	3418	ÅSNES	G
2283	ÅSNES FINNSKOG	3418	ÅSNES	G
2301	HAMAR	3403	HAMAR	P
2302	HAMAR	3403	HAMAR	P
2303	HAMAR	3403	HAMAR	P
2304	HAMAR	3403	HAMAR	P
2305	HAMAR	3403	HAMAR	P
2306	HAMAR	3403	HAMAR	P
2307	HAMAR	3403	HAMAR	P
2308	HAMAR	3403	HAMAR	P
2309	HAMAR	3403	HAMAR	P
2311	HAMAR	3403	HAMAR	P
2312	OTTESTAD	3413	STANGE	G
2313	OTTESTAD	3413	STANGE	P
2314	OTTESTAD	3413	STANGE	P
2315	HAMAR	3403	HAMAR	G
2316	HAMAR	3403	HAMAR	G
2317	HAMAR	3403	HAMAR	G
2318	HAMAR	3403	HAMAR	G
2319	HAMAR	3403	HAMAR	G
2320	FURNES	3411	RINGSAKER	G
2321	HAMAR	3403	HAMAR	G
2322	RIDABU	3403	HAMAR	G
2323	INGEBERG	3403	HAMAR	G
2324	VANG PÅ HEDMARKEN	3403	HAMAR	G
2325	HAMAR	3403	HAMAR	P
2326	HAMAR	3403	HAMAR	P
2327	FURNES	3411	RINGSAKER	P
2328	RIDABU	3403	HAMAR	P
2329	VANG PÅ HEDMARKEN	3403	HAMAR	P
2330	VALLSET	3413	STANGE	G
2331	VALLSET	3413	STANGE	P
2332	ÅSVANG	3413	STANGE	G
2333	ROMEDAL	3413	STANGE	P
2334	ROMEDAL	3413	STANGE	G
2335	STANGE	3413	STANGE	G
2336	STANGE	3413	STANGE	P
2337	TANGEN	3413	STANGE	G
2338	ESPA	3413	STANGE	G
2339	TANGEN	3413	STANGE	P
2340	LØTEN	3412	LØTEN	G
2341	LØTEN	3412	LØTEN	P
2344	ILSENG	3413	STANGE	G
2345	ÅDALSBRUK	3412	LØTEN	G
2346	ILSENG	3413	STANGE	P
2350	NES PÅ HEDMARKEN	3411	RINGSAKER	G
2351	NES PÅ HEDMARKEN	3411	RINGSAKER	P
2353	STAVSJØ	3411	RINGSAKER	G
2355	GAUPEN	3411	RINGSAKER	G
2360	RUDSHØGDA	3411	RINGSAKER	G
2361	RUDSHØGDA	3411	RINGSAKER	P
2364	NÆROSET	3411	RINGSAKER	G
2365	ÅSMARKA	3411	RINGSAKER	G
2372	BRØTTUM	3411	RINGSAKER	G
2373	BRØTTUM	3411	RINGSAKER	P
2380	BRUMUNDDAL	3411	RINGSAKER	G
2381	BRUMUNDDAL	3411	RINGSAKER	P
2382	BRUMUNDDAL	3411	RINGSAKER	G
2383	BRUMUNDDAL	3411	RINGSAKER	G
2384	BRUMUNDDAL	3411	RINGSAKER	G
2385	BRUMUNDDAL	3411	RINGSAKER	G
2386	BRUMUNDDAL	3411	RINGSAKER	G
2387	BRUMUNDDAL	3411	RINGSAKER	G
2388	BRUMUNDDAL	3411	RINGSAKER	G
2389	BRUMUNDDAL	3411	RINGSAKER	P
2390	MOELV	3411	RINGSAKER	G
2391	MOELV	3411	RINGSAKER	P
2401	ELVERUM	3420	ELVERUM	P
2402	ELVERUM	3420	ELVERUM	P
2403	ELVERUM	3420	ELVERUM	P
2405	ELVERUM	3420	ELVERUM	P
2406	ELVERUM	3420	ELVERUM	G
2407	ELVERUM	3420	ELVERUM	G
2408	ELVERUM	3420	ELVERUM	G
2409	ELVERUM	3420	ELVERUM	G
2410	HERNES	3420	ELVERUM	G
2411	ELVERUM	3420	ELVERUM	G
2412	SØRSKOGBYGDA	3420	ELVERUM	G
2413	ELVERUM	3420	ELVERUM	G
2414	ELVERUM	3420	ELVERUM	G
2415	HERADSBYGD	3420	ELVERUM	G
2416	JØMNA	3420	ELVERUM	G
2417	ELVERUM	3420	ELVERUM	P
2418	ELVERUM	3420	ELVERUM	P
2419	ELVERUM	3420	ELVERUM	P
2420	TRYSIL	3421	TRYSIL	G
2421	TRYSIL	3421	TRYSIL	P
2422	NYBERGSUND	3421	TRYSIL	G
2423	ØSTBY	3421	TRYSIL	G
2424	ØSTBY	3421	TRYSIL	P
2425	LJØRDALEN	3421	TRYSIL	G
2426	LJØRDALEN	3421	TRYSIL	P
2427	PLASSEN	3421	TRYSIL	G
2428	SØRE OSEN	3421	TRYSIL	G
2429	TØRBERGET	3421	TRYSIL	G
2430	JORDET	3421	TRYSIL	G
2432	SLETTÅS	3421	TRYSIL	G
2434	BRASKEREIDFOSS	3419	VÅLER (INNLANDET)	P
2435	BRASKEREIDFOSS	3419	VÅLER (INNLANDET)	G
2436	VÅLER I SOLØR	3419	VÅLER (INNLANDET)	G
2437	HASLEMOEN	3419	VÅLER (INNLANDET)	G
2438	GRAVBERGET	3419	VÅLER (INNLANDET)	G
2440	ENGERDAL	3425	ENGERDAL	G
2441	ENGERDAL	3425	ENGERDAL	P
2442	HERADSBYGD	3420	ELVERUM	P
2443	DREVSJØ	3425	ENGERDAL	G
2444	DREVSJØ	3425	ENGERDAL	P
2446	ELGÅ	3425	ENGERDAL	G
2447	SØRE OSEN	3421	TRYSIL	P
2448	SØMÅDALEN	3425	ENGERDAL	G
2450	RENA	3422	ÅMOT	G
2451	RENA	3422	ÅMOT	P
2460	OSEN	3422	ÅMOT	G
2461	OSEN	3422	ÅMOT	P
2476	ATNA	3423	STOR-ELVDAL	G
2477	SOLLIA	3423	STOR-ELVDAL	G
2478	HANESTAD	3424	RENDALEN	G
2480	KOPPANG	3423	STOR-ELVDAL	G
2481	KOPPANG	3423	STOR-ELVDAL	P
2484	RENDALEN	3424	RENDALEN	G
2485	RENDALEN	3424	RENDALEN	G
2486	RENDALEN	3424	RENDALEN	P
2487	RENDALEN	3424	RENDALEN	P
2488	RENDALEN	3424	RENDALEN	P
2500	TYNSET	3427	TYNSET	G
2501	TYNSET	3427	TYNSET	P
2510	TYLLDALEN	3427	TYNSET	G
2512	KVIKNE	3427	TYNSET	G
2540	TOLGA	3426	TOLGA	G
2541	TOLGA	3426	TOLGA	P
2542	VINGELEN	3426	TOLGA	G
2544	ØVERSJØDALEN	3426	TOLGA	G
2550	OS I ØSTERDALEN	3430	OS	G
2551	OS I ØSTERDALEN	3430	OS	P
2552	DALSBYGDA	3430	OS	G
2555	TUFSINGDALEN	3430	OS	G
2560	ALVDAL	3428	ALVDAL	G
2561	ALVDAL	3428	ALVDAL	P
2580	FOLLDAL	3429	FOLLDAL	G
2581	FOLLDAL	3429	FOLLDAL	P
2582	GRIMSBU	3429	FOLLDAL	G
2584	DALHOLEN	3429	FOLLDAL	G
2601	LILLEHAMMER	3405	LILLEHAMMER	P
2602	LILLEHAMMER	3405	LILLEHAMMER	P
2603	LILLEHAMMER	3405	LILLEHAMMER	P
2604	LILLEHAMMER	3405	LILLEHAMMER	P
2605	LILLEHAMMER	3405	LILLEHAMMER	P
2606	LILLEHAMMER	3405	LILLEHAMMER	P
2607	VINGROM	3405	LILLEHAMMER	G
2608	LILLEHAMMER	3405	LILLEHAMMER	G
2609	LILLEHAMMER	3405	LILLEHAMMER	G
2610	MESNALI	3411	RINGSAKER	G
2611	LILLEHAMMER	3405	LILLEHAMMER	G
2612	SJUSJØEN	3411	RINGSAKER	G
2613	LILLEHAMMER	3405	LILLEHAMMER	G
2614	LILLEHAMMER	3405	LILLEHAMMER	G
2615	LILLEHAMMER	3405	LILLEHAMMER	G
2616	LISMARKA	3411	RINGSAKER	G
2617	LILLEHAMMER	3405	LILLEHAMMER	P
2618	LILLEHAMMER	3405	LILLEHAMMER	G
2619	LILLEHAMMER	3405	LILLEHAMMER	G
2620	MESNALI	3411	RINGSAKER	P
2621	VINGROM	3405	LILLEHAMMER	P
2622	LILLEHAMMER	3405	LILLEHAMMER	P
2623	LILLEHAMMER	3405	LILLEHAMMER	P
2624	LILLEHAMMER	3405	LILLEHAMMER	G
2625	FÅBERG	3405	LILLEHAMMER	G
2626	LILLEHAMMER	3405	LILLEHAMMER	P
2627	FÅBERG	3405	LILLEHAMMER	P
2628	SJUSJØEN	3411	RINGSAKER	P
2629	LILLEHAMMER	3405	LILLEHAMMER	P
2630	RINGEBU	3439	RINGEBU	G
2631	RINGEBU	3439	RINGEBU	P
2632	VENABYGD	3439	RINGEBU	G
2633	FÅVANG	3439	RINGEBU	P
2634	FÅVANG	3439	RINGEBU	G
2635	TRETTEN	3440	ØYER	G
2636	ØYER	3440	ØYER	G
2637	ØYER	3440	ØYER	P
2638	TRETTEN	3440	ØYER	P
2639	VINSTRA	3436	NORD-FRON	P
2640	VINSTRA	3436	NORD-FRON	G
2641	KVAM	3436	NORD-FRON	P
2642	KVAM	3436	NORD-FRON	G
2643	SKÅBU	3436	NORD-FRON	G
2644	SKÅBU	3436	NORD-FRON	P
2646	GÅLÅ	3438	SØR-FRON	G
2647	SØR-FRON	3438	SØR-FRON	G
2649	ØSTRE GAUSDAL	3441	GAUSDAL	P
2651	ØSTRE GAUSDAL	3441	GAUSDAL	G
2652	SVINGVOLL	3441	GAUSDAL	G
2653	VESTRE GAUSDAL	3441	GAUSDAL	G
2654	VESTRE GAUSDAL	3441	GAUSDAL	P
2656	FOLLEBU	3441	GAUSDAL	G
2657	SVATSUM	3441	GAUSDAL	G
2658	ESPEDALEN	3438	SØR-FRON	G
2659	DOMBÅS	3431	DOVRE	P
2660	DOMBÅS	3431	DOVRE	G
2661	HJERKINN	3431	DOVRE	G
2662	DOVRE	3431	DOVRE	G
2663	DOVRESKOGEN	3431	DOVRE	G
2664	DOVRE	3431	DOVRE	P
2665	LESJA	3432	LESJA	G
2666	LORA	3432	LESJA	G
2667	LESJAVERK	3432	LESJA	G
2668	LESJASKOG	3432	LESJA	G
2669	BJORLI	3432	LESJA	G
2670	OTTA	3437	SEL	G
2671	LESJA	3432	LESJA	P
2672	SEL	3437	SEL	G
2673	HØVRINGEN	3437	SEL	G
2674	MYSUSÆTER	3437	SEL	G
2675	OTTA	3437	SEL	P
2676	HEIDAL	3437	SEL	G
2677	NEDRE HEIDAL	3437	SEL	G
2678	SEL	3437	SEL	P
2680	VÅGÅ	3435	VÅGÅ	G
2681	LALM	3435	VÅGÅ	P
2682	LALM	3435	VÅGÅ	G
2683	TESSANDEN	3435	VÅGÅ	G
2684	VÅGÅ	3435	VÅGÅ	P
2685	GARMO	3434	LOM	G
2686	LOM	3434	LOM	G
2687	BØVERDALEN	3434	LOM	G
2688	LOM	3434	LOM	P
2690	SKJÅK	3433	SKJÅK	G
2693	NORDBERG	3433	SKJÅK	G
2694	SKJÅK	3433	SKJÅK	P
2695	GROTLI	3433	SKJÅK	G
2711	GRAN	3446	GRAN	P
2712	BRANDBU	3446	GRAN	P
2713	ROA	3234	LUNNER	P
2714	JAREN	3446	GRAN	P
2715	LUNNER	3234	LUNNER	P
2716	HARESTUA	3234	LUNNER	P
2717	GRUA	3234	LUNNER	P
2718	BRANDBU	3446	GRAN	P
2720	GRINDVOLL	3234	LUNNER	G
2730	LUNNER	3234	LUNNER	G
2740	ROA	3234	LUNNER	G
2742	GRUA	3234	LUNNER	G
2743	HARESTUA	3234	LUNNER	G
2750	GRAN	3446	GRAN	G
2760	BRANDBU	3446	GRAN	G
2770	JAREN	3446	GRAN	G
2801	GJØVIK	3407	GJØVIK	P
2802	GJØVIK	3407	GJØVIK	P
2803	GJØVIK	3407	GJØVIK	P
2804	GJØVIK	3407	GJØVIK	P
2805	GJØVIK	3407	GJØVIK	P
2806	GJØVIK	3407	GJØVIK	P
2807	HUNNDALEN	3407	GJØVIK	P
2808	GJØVIK	3407	GJØVIK	P
2810	GJØVIK	3407	GJØVIK	P
2811	HUNNDALEN	3407	GJØVIK	P
2812	GJØVIK	3407	GJØVIK	P
2815	GJØVIK	3407	GJØVIK	G
2816	GJØVIK	3407	GJØVIK	G
2817	GJØVIK	3407	GJØVIK	G
2818	GJØVIK	3407	GJØVIK	G
2819	GJØVIK	3407	GJØVIK	G
2820	NORDRE TOTEN	3442	ØSTRE TOTEN	G
2821	GJØVIK	3407	GJØVIK	G
2822	BYBRUA	3407	GJØVIK	G
2825	GJØVIK	3407	GJØVIK	G
2827	HUNNDALEN	3407	GJØVIK	G
2830	RAUFOSS	3443	VESTRE TOTEN	G
2831	RAUFOSS	3443	VESTRE TOTEN	P
2832	BIRI	3407	GJØVIK	P
2833	RAUFOSS	3443	VESTRE TOTEN	G
2834	RAUFOSS	3443	VESTRE TOTEN	G
2835	RAUFOSS	3443	VESTRE TOTEN	G
2836	BIRI	3407	GJØVIK	G
2837	BIRISTRAND	3407	GJØVIK	G
2838	SNERTINGDAL	3407	GJØVIK	G
2839	ØVRE SNERTINGDAL	3407	GJØVIK	G
2840	REINSVOLL	3443	VESTRE TOTEN	G
2841	SNERTINGDAL	3407	GJØVIK	P
2843	EINA	3443	VESTRE TOTEN	G
2844	KOLBU	3442	ØSTRE TOTEN	P
2845	BØVERBRU	3443	VESTRE TOTEN	P
2846	BØVERBRU	3443	VESTRE TOTEN	G
2847	KOLBU	3442	ØSTRE TOTEN	G
2848	SKREIA	3442	ØSTRE TOTEN	G
2849	KAPP	3442	ØSTRE TOTEN	G
2850	LENA	3442	ØSTRE TOTEN	G
2851	LENA	3442	ØSTRE TOTEN	P
2853	REINSVOLL	3443	VESTRE TOTEN	P
2854	EINA	3443	VESTRE TOTEN	P
2857	SKREIA	3442	ØSTRE TOTEN	P
2858	KAPP	3442	ØSTRE TOTEN	P
2860	HOV	3447	SØNDRE LAND	G
2861	LANDÅSBYGDA	3447	SØNDRE LAND	G
2862	FLUBERG	3447	SØNDRE LAND	G
2863	VESTSIDA	3447	SØNDRE LAND	G
2864	FALL	3447	SØNDRE LAND	G
2866	ENGER	3447	SØNDRE LAND	G
2867	HOV	3447	SØNDRE LAND	P
2870	DOKKA	3448	NORDRE LAND	G
2879	ODNES	3447	SØNDRE LAND	G
2880	NORD-TORPA	3448	NORDRE LAND	G
2881	AUST-TORPA	3448	NORDRE LAND	G
2882	DOKKA	3448	NORDRE LAND	P
2890	ETNEDAL	3450	ETNEDAL	G
2893	ETNEDAL	3450	ETNEDAL	P
2900	FAGERNES	3451	NORD-AURDAL	G
2901	FAGERNES	3451	NORD-AURDAL	P
2907	LEIRA I VALDRES	3451	NORD-AURDAL	P
2909	AURDAL	3451	NORD-AURDAL	P
2910	AURDAL	3451	NORD-AURDAL	G
2917	SKRAUTVÅL	3451	NORD-AURDAL	G
2918	ULNES	3451	NORD-AURDAL	G
2920	LEIRA I VALDRES	3451	NORD-AURDAL	G
2923	TISLEIDALEN	3451	NORD-AURDAL	G
2929	BAGN	3449	SØR-AURDAL	P
2930	BAGN	3449	SØR-AURDAL	G
2933	REINLI	3449	SØR-AURDAL	G
2936	BEGNADALEN	3449	SØR-AURDAL	G
2937	BEGNA	3449	SØR-AURDAL	G
2939	HEGGENES	3453	ØYSTRE SLIDRE	P
2940	HEGGENES	3453	ØYSTRE SLIDRE	G
2943	ROGNE	3453	ØYSTRE SLIDRE	G
2950	SKAMMESTEIN	3453	ØYSTRE SLIDRE	G
2952	BEITO	3453	ØYSTRE SLIDRE	G
2953	BEITOSTØLEN	3453	ØYSTRE SLIDRE	G
2954	BEITOSTØLEN	3453	ØYSTRE SLIDRE	P
2959	RØN	3452	VESTRE SLIDRE	P
2960	RØN	3452	VESTRE SLIDRE	G
2965	SLIDRE	3452	VESTRE SLIDRE	P
2966	SLIDRE	3452	VESTRE SLIDRE	G
2967	LOMEN	3452	VESTRE SLIDRE	G
2972	RYFOSS	3454	VANG	P
2973	RYFOSS	3454	VANG	G
2974	VANG I VALDRES	3454	VANG	P
2975	VANG I VALDRES	3454	VANG	G
2977	ØYE	3454	VANG	G
2985	TYINKRYSSET	3454	VANG	G
3001	DRAMMEN	3301	DRAMMEN	P
3002	DRAMMEN	3301	DRAMMEN	P
3003	DRAMMEN	3301	DRAMMEN	P
3004	DRAMMEN	3301	DRAMMEN	B
3005	DRAMMEN	3301	DRAMMEN	P
3006	DRAMMEN	3301	DRAMMEN	P
3007	DRAMMEN	3301	DRAMMEN	P
3008	DRAMMEN	3301	DRAMMEN	P
3009	DRAMMEN	3301	DRAMMEN	P
3010	DRAMMEN	3301	DRAMMEN	P
3011	DRAMMEN	3301	DRAMMEN	G
3012	DRAMMEN	3301	DRAMMEN	G
3013	DRAMMEN	3301	DRAMMEN	G
3014	DRAMMEN	3301	DRAMMEN	G
3015	DRAMMEN	3301	DRAMMEN	G
3016	DRAMMEN	3301	DRAMMEN	G
3017	DRAMMEN	3301	DRAMMEN	G
3018	DRAMMEN	3301	DRAMMEN	G
3019	DRAMMEN	3301	DRAMMEN	G
3021	DRAMMEN	3301	DRAMMEN	G
3022	DRAMMEN	3301	DRAMMEN	G
3023	DRAMMEN	3301	DRAMMEN	G
3024	DRAMMEN	3301	DRAMMEN	G
3025	DRAMMEN	3301	DRAMMEN	G
3026	DRAMMEN	3301	DRAMMEN	G
3027	DRAMMEN	3301	DRAMMEN	G
3028	DRAMMEN	3301	DRAMMEN	G
3029	DRAMMEN	3301	DRAMMEN	G
3030	DRAMMEN	3301	DRAMMEN	G
3031	DRAMMEN	3301	DRAMMEN	G
3032	DRAMMEN	3301	DRAMMEN	G
3033	DRAMMEN	3301	DRAMMEN	G
3034	DRAMMEN	3301	DRAMMEN	G
3035	DRAMMEN	3301	DRAMMEN	G
3036	DRAMMEN	3301	DRAMMEN	G
3037	DRAMMEN	3301	DRAMMEN	G
3038	DRAMMEN	3301	DRAMMEN	G
3039	DRAMMEN	3301	DRAMMEN	G
3040	DRAMMEN	3301	DRAMMEN	G
3041	DRAMMEN	3301	DRAMMEN	G
3042	DRAMMEN	3301	DRAMMEN	G
3043	DRAMMEN	3301	DRAMMEN	G
3044	DRAMMEN	3301	DRAMMEN	G
3045	DRAMMEN	3301	DRAMMEN	G
3046	DRAMMEN	3301	DRAMMEN	G
3047	DRAMMEN	3301	DRAMMEN	G
3048	DRAMMEN	3301	DRAMMEN	G
3050	MJØNDALEN	3301	DRAMMEN	G
3051	MJØNDALEN	3301	DRAMMEN	P
3053	STEINBERG	3301	DRAMMEN	G
3054	KROKSTADELVA	3301	DRAMMEN	P
3055	KROKSTADELVA	3301	DRAMMEN	G
3056	SOLBERGELVA	3301	DRAMMEN	P
3057	SOLBERGELVA	3301	DRAMMEN	G
3058	SOLBERGMOEN	3301	DRAMMEN	G
3060	SVELVIK	3301	DRAMMEN	G
3061	SVELVIK	3301	DRAMMEN	P
3063	DRAMMEN	3301	DRAMMEN	P
3064	DRAMMEN	3301	DRAMMEN	P
3065	DRAMMEN	3301	DRAMMEN	P
3066	DRAMMEN	3301	DRAMMEN	P
3070	SANDE I VESTFOLD	3903	HOLMESTRAND	G
3071	SANDE I VESTFOLD	3903	HOLMESTRAND	P
3072	SANDE I VESTFOLD	3903	HOLMESTRAND	G
3073	SANDE I VESTFOLD	3903	HOLMESTRAND	G
3074	SANDE I VESTFOLD	3903	HOLMESTRAND	G
3075	BERGER	3301	DRAMMEN	G
3076	SANDE I VESTFOLD	3903	HOLMESTRAND	G
3077	SANDE I VESTFOLD	3903	HOLMESTRAND	G
3080	HOLMESTRAND	3903	HOLMESTRAND	G
3081	HOLMESTRAND	3903	HOLMESTRAND	P
3082	HOLMESTRAND	3903	HOLMESTRAND	P
3083	HOLMESTRAND	3903	HOLMESTRAND	G
3084	HOLMESTRAND	3903	HOLMESTRAND	G
3085	HOLMESTRAND	3903	HOLMESTRAND	G
3086	HOLMESTRAND	3903	HOLMESTRAND	G
3087	HOLMESTRAND	3903	HOLMESTRAND	P
3088	HOLMESTRAND	3903	HOLMESTRAND	P
3089	HOLMESTRAND	3903	HOLMESTRAND	G
3090	HOF	3903	HOLMESTRAND	G
3091	HOF	3903	HOLMESTRAND	P
3092	SUNDBYFOSS	3903	HOLMESTRAND	G
3095	EIDSFOSS	3903	HOLMESTRAND	G
3101	TØNSBERG	3905	TØNSBERG	P
3103	TØNSBERG	3905	TØNSBERG	P
3104	TØNSBERG	3905	TØNSBERG	P
3105	TØNSBERG	3905	TØNSBERG	P
3106	NØTTERØY	3911	FÆRDER	P
3107	SEM	3905	TØNSBERG	P
3108	VEAR	3905	TØNSBERG	P
3109	TØNSBERG	3905	TØNSBERG	P
3110	TØNSBERG	3905	TØNSBERG	G
3111	TØNSBERG	3905	TØNSBERG	G
3112	TØNSBERG	3905	TØNSBERG	G
3113	TØNSBERG	3905	TØNSBERG	G
3114	TØNSBERG	3905	TØNSBERG	G
3115	TØNSBERG	3905	TØNSBERG	G
3116	TØNSBERG	3905	TØNSBERG	G
3117	TØNSBERG	3905	TØNSBERG	G
3118	TØNSBERG	3905	TØNSBERG	G
3119	TØNSBERG	3905	TØNSBERG	P
3120	NØTTERØY	3911	FÆRDER	G
3121	NØTTERØY	3911	FÆRDER	G
3122	TØNSBERG	3905	TØNSBERG	G
3123	TØNSBERG	3905	TØNSBERG	G
3124	TØNSBERG	3905	TØNSBERG	G
3125	TØNSBERG	3905	TØNSBERG	G
3126	TØNSBERG	3905	TØNSBERG	G
3127	TØNSBERG	3905	TØNSBERG	G
3128	NØTTERØY	3911	FÆRDER	G
3129	TØNSBERG	3905	TØNSBERG	P
3131	HUSØYSUND	3911	FÆRDER	P
3132	HUSØYSUND	3911	FÆRDER	G
3133	DUKEN	3911	FÆRDER	G
3134	TØNSBERG	3905	TØNSBERG	P
3135	TORØD	3911	FÆRDER	G
3137	TORØD	3911	FÆRDER	P
3138	SKALLESTAD	3911	FÆRDER	G
3139	SKALLESTAD	3911	FÆRDER	P
3140	NØTTERØY	3911	FÆRDER	G
3141	KJØPMANNSKJÆR	3911	FÆRDER	P
3142	VESTSKOGEN	3911	FÆRDER	G
3143	KJØPMANNSKJÆR	3911	FÆRDER	G
3144	VEIERLAND	3911	FÆRDER	B
3145	TJØME	3911	FÆRDER	G
3148	HVASSER	3911	FÆRDER	G
3150	TOLVSRØD	3905	TØNSBERG	G
3151	TOLVSRØD	3905	TØNSBERG	G
3152	TOLVSRØD	3905	TØNSBERG	G
3153	TOLVSRØD	3905	TØNSBERG	G
3154	TOLVSRØD	3905	TØNSBERG	G
3156	MELSOMVIK	3907	SANDEFJORD	P
3157	BARKÅKER	3905	TØNSBERG	G
3158	ANDEBU	3907	SANDEFJORD	G
3159	MELSOMVIK	3907	SANDEFJORD	G
3160	STOKKE	3907	SANDEFJORD	G
3161	STOKKE	3907	SANDEFJORD	P
3162	ANDEBU	3907	SANDEFJORD	P
3163	NØTTERØY	3911	FÆRDER	P
3164	REVETAL	3905	TØNSBERG	P
3165	TJØME	3911	FÆRDER	P
3166	TOLVSRØD	3905	TØNSBERG	P
3167	ÅSGÅRDSTRAND	3901	HORTEN	P
3170	SEM	3905	TØNSBERG	G
3171	SEM	3905	TØNSBERG	G
3172	VEAR	3905	TØNSBERG	G
3173	VEAR	3905	TØNSBERG	G
3174	REVETAL	3905	TØNSBERG	G
3175	RAMNES	3905	TØNSBERG	G
3176	UNDRUMSDAL	3905	TØNSBERG	G
3177	VÅLE	3905	TØNSBERG	P
3178	VÅLE	3905	TØNSBERG	G
3179	ÅSGÅRDSTRAND	3901	HORTEN	G
3180	NYKIRKE	3901	HORTEN	G
3181	HORTEN	3901	HORTEN	G
3182	HORTEN	3901	HORTEN	G
3183	HORTEN	3901	HORTEN	G
3184	BORRE	3901	HORTEN	G
3185	SKOPPUM	3901	HORTEN	G
3186	HORTEN	3901	HORTEN	G
3187	HORTEN	3901	HORTEN	G
3188	HORTEN	3901	HORTEN	G
3189	HORTEN	3901	HORTEN	G
3191	HORTEN	3901	HORTEN	P
3192	HORTEN	3901	HORTEN	P
3193	HORTEN	3901	HORTEN	P
3194	HORTEN	3901	HORTEN	P
3195	SKOPPUM	3901	HORTEN	P
3196	HORTEN	3901	HORTEN	P
3197	NYKIRKE	3901	HORTEN	P
3199	BORRE	3901	HORTEN	P
3201	SANDEFJORD	3907	SANDEFJORD	P
3202	SANDEFJORD	3907	SANDEFJORD	P
3203	SANDEFJORD	3907	SANDEFJORD	P
3204	SANDEFJORD	3907	SANDEFJORD	P
3205	SANDEFJORD	3907	SANDEFJORD	P
3206	SANDEFJORD	3907	SANDEFJORD	P
3207	SANDEFJORD	3907	SANDEFJORD	P
3208	SANDEFJORD	3907	SANDEFJORD	G
3209	SANDEFJORD	3907	SANDEFJORD	G
3210	SANDEFJORD	3907	SANDEFJORD	G
3211	SANDEFJORD	3907	SANDEFJORD	G
3212	SANDEFJORD	3907	SANDEFJORD	G
3213	SANDEFJORD	3907	SANDEFJORD	G
3214	SANDEFJORD	3907	SANDEFJORD	G
3215	SANDEFJORD	3907	SANDEFJORD	G
3216	SANDEFJORD	3907	SANDEFJORD	G
3217	SANDEFJORD	3907	SANDEFJORD	G
3218	SANDEFJORD	3907	SANDEFJORD	G
3219	SANDEFJORD	3907	SANDEFJORD	G
3220	SANDEFJORD	3907	SANDEFJORD	G
3221	SANDEFJORD	3907	SANDEFJORD	G
3222	SANDEFJORD	3907	SANDEFJORD	G
3223	SANDEFJORD	3907	SANDEFJORD	G
3224	SANDEFJORD	3907	SANDEFJORD	G
3225	SANDEFJORD	3907	SANDEFJORD	G
3226	SANDEFJORD	3907	SANDEFJORD	G
3227	SANDEFJORD	3907	SANDEFJORD	G
3228	SANDEFJORD	3907	SANDEFJORD	G
3229	SANDEFJORD	3907	SANDEFJORD	G
3230	SANDEFJORD	3907	SANDEFJORD	G
3231	SANDEFJORD	3907	SANDEFJORD	G
3232	SANDEFJORD	3907	SANDEFJORD	G
3233	SANDEFJORD	3907	SANDEFJORD	G
3234	SANDEFJORD	3907	SANDEFJORD	G
3235	SANDEFJORD	3907	SANDEFJORD	G
3236	SANDEFJORD	3907	SANDEFJORD	G
3237	SANDEFJORD	3907	SANDEFJORD	G
3238	SANDEFJORD	3907	SANDEFJORD	G
3239	SANDEFJORD	3907	SANDEFJORD	G
3240	SANDEFJORD	3907	SANDEFJORD	P
3241	SANDEFJORD	3907	SANDEFJORD	G
3242	SANDEFJORD	3907	SANDEFJORD	G
3243	KODAL	3907	SANDEFJORD	G
3244	SANDEFJORD	3907	SANDEFJORD	G
3245	KODAL	3907	SANDEFJORD	P
3246	SANDEFJORD	3907	SANDEFJORD	P
3247	SANDEFJORD	3907	SANDEFJORD	P
3248	SANDEFJORD	3907	SANDEFJORD	P
3249	SANDEFJORD	3907	SANDEFJORD	P
3251	LARVIK	3909	LARVIK	P
3252	LARVIK	3909	LARVIK	P
3253	LARVIK	3909	LARVIK	P
3254	LARVIK	3909	LARVIK	P
3255	LARVIK	3909	LARVIK	P
3256	LARVIK	3909	LARVIK	G
3257	LARVIK	3909	LARVIK	G
3258	LARVIK	3909	LARVIK	G
3259	LARVIK	3909	LARVIK	G
3260	LARVIK	3909	LARVIK	G
3261	LARVIK	3909	LARVIK	G
3262	LARVIK	3909	LARVIK	G
3263	LARVIK	3909	LARVIK	G
3264	LARVIK	3909	LARVIK	G
3265	LARVIK	3909	LARVIK	G
3267	LARVIK	3909	LARVIK	G
3268	LARVIK	3909	LARVIK	G
3269	LARVIK	3909	LARVIK	G
3270	LARVIK	3909	LARVIK	G
3271	LARVIK	3909	LARVIK	G
3274	LARVIK	3909	LARVIK	G
3275	SVARSTAD	3909	LARVIK	G
3276	SVARSTAD	3909	LARVIK	P
3277	STEINSHOLT	3909	LARVIK	G
3280	TJODALYNG	3909	LARVIK	G
3281	TJODALYNG	3909	LARVIK	P
3282	KVELDE	3909	LARVIK	G
3284	KVELDE	3909	LARVIK	P
3285	LARVIK	3909	LARVIK	P
3290	STAVERN	3909	LARVIK	G
3291	STAVERN	3909	LARVIK	P
3292	STAVERN	3909	LARVIK	G
3294	STAVERN	3909	LARVIK	G
3295	HELGEROA	3909	LARVIK	G
3296	NEVLUNGHAVN	3909	LARVIK	G
3297	HELGEROA	3909	LARVIK	P
3300	HOKKSUND	3314	ØVRE EIKER	G
3301	HOKKSUND	3314	ØVRE EIKER	P
3302	HOKKSUND	3314	ØVRE EIKER	G
3303	HOKKSUND	3314	ØVRE EIKER	G
3320	VESTFOSSEN	3314	ØVRE EIKER	G
3321	VESTFOSSEN	3314	ØVRE EIKER	P
3322	FISKUM	3314	ØVRE EIKER	G
3330	SKOTSELV	3314	ØVRE EIKER	G
3331	SKOTSELV	3314	ØVRE EIKER	P
3340	ÅMOT	3316	MODUM	G
3341	ÅMOT	3316	MODUM	P
3342	ÅMOT	3316	MODUM	P
3350	PRESTFOSS	3332	SIGDAL	G
3351	PRESTFOSS	3332	SIGDAL	P
3355	SOLUMSMOEN	3332	SIGDAL	G
3357	EGGEDAL	3332	SIGDAL	P
3358	NEDRE EGGEDAL	3332	SIGDAL	G
3359	EGGEDAL	3332	SIGDAL	G
3360	GEITHUS	3316	MODUM	G
3361	GEITHUS	3316	MODUM	P
3370	VIKERSUND	3316	MODUM	G
3371	VIKERSUND	3316	MODUM	P
3401	LIER	3312	LIER	P
3402	LIER	3312	LIER	G
3403	LIER	3312	LIER	G
3404	LIER	3312	LIER	G
3405	LIER	3312	LIER	G
3406	TRANBY	3312	LIER	G
3407	TRANBY	3312	LIER	P
3408	TRANBY	3312	LIER	G
3409	TRANBY	3312	LIER	G
3410	SYLLING	3312	LIER	G
3411	SYLLING	3312	LIER	P
3412	LIERSTRANDA	3312	LIER	P
3413	LIER	3312	LIER	G
3414	LIERSTRANDA	3312	LIER	G
3420	LIERSKOGEN	3312	LIER	G
3421	LIERSKOGEN	3312	LIER	P
3425	REISTAD	3312	LIER	G
3426	GULLAUG	3312	LIER	G
3427	GULLAUG	3312	LIER	G
3428	GULLAUG	3312	LIER	P
3430	SPIKKESTAD	3203	ASKER	G
3431	SPIKKESTAD	3203	ASKER	P
3440	RØYKEN	3203	ASKER	G
3441	RØYKEN	3203	ASKER	P
3442	HYGGEN	3203	ASKER	G
3470	SLEMMESTAD	3203	ASKER	G
3471	SLEMMESTAD	3203	ASKER	P
3472	BØDALEN	3203	ASKER	G
3474	ÅROS	3203	ASKER	G
3475	SÆTRE	3203	ASKER	G
3476	SÆTRE	3203	ASKER	P
3477	BÅTSTØ	3203	ASKER	G
3478	NÆRSNES	3203	ASKER	G
3479	NÆRSNES	3203	ASKER	P
3480	FILTVET	3203	ASKER	G
3481	TOFTE	3203	ASKER	P
3482	TOFTE	3203	ASKER	G
3483	KANA	3203	ASKER	G
3484	HOLMSBU	3203	ASKER	G
3485	FILTVET	3203	ASKER	P
3490	KLOKKARSTUA	3203	ASKER	G
3501	HØNEFOSS	3305	RINGERIKE	P
3502	HØNEFOSS	3305	RINGERIKE	P
3503	HØNEFOSS	3305	RINGERIKE	P
3504	HØNEFOSS	3305	RINGERIKE	P
3507	HØNEFOSS	3305	RINGERIKE	P
3510	HØNEFOSS	3305	RINGERIKE	G
3511	HØNEFOSS	3305	RINGERIKE	G
3512	HØNEFOSS	3305	RINGERIKE	G
3513	HØNEFOSS	3305	RINGERIKE	G
3514	HØNEFOSS	3305	RINGERIKE	G
3515	HØNEFOSS	3305	RINGERIKE	G
3516	HØNEFOSS	3305	RINGERIKE	G
3517	HØNEFOSS	3305	RINGERIKE	G
3518	HØNEFOSS	3305	RINGERIKE	G
3519	HØNEFOSS	3305	RINGERIKE	G
3520	JEVNAKER	3236	JEVNAKER	G
3521	JEVNAKER	3236	JEVNAKER	P
3522	BJONEROA	3446	GRAN	G
3523	NES I ÅDAL	3305	RINGERIKE	P
3524	NES I ÅDAL	3305	RINGERIKE	G
3525	HALLINGBY	3305	RINGERIKE	G
3526	HALLINGBY	3305	RINGERIKE	P
3528	HEDALEN	3449	SØR-AURDAL	G
3529	RØYSE	3310	HOLE	P
3530	RØYSE	3310	HOLE	G
3531	KROKKLEIVA	3310	HOLE	G
3532	TYRISTRAND	3305	RINGERIKE	P
3533	TYRISTRAND	3305	RINGERIKE	G
3534	SOKNA	3305	RINGERIKE	G
3535	KRØDEREN	3318	KRØDSHERAD	G
3536	NORESUND	3318	KRØDSHERAD	G
3537	KRØDEREN	3318	KRØDSHERAD	P
3538	SOLLIHØGDA	3310	HOLE	G
3539	FLÅ	3320	FLÅ	G
3540	NESBYEN	3322	NESBYEN	G
3541	NESBYEN	3322	NESBYEN	P
3542	SOKNA	3305	RINGERIKE	P
3543	NORESUND	3318	KRØDSHERAD	P
3544	TUNHOVD	3338	NORE OG UVDAL	G
3545	FLÅ	3320	FLÅ	P
3546	KROKKLEIVA	3310	HOLE	P
3550	GOL	3324	GOL	G
3551	GOL	3324	GOL	P
3560	HEMSEDAL	3326	HEMSEDAL	G
3561	HEMSEDAL	3326	HEMSEDAL	P
3570	ÅL	3328	ÅL	G
3571	ÅL	3328	ÅL	P
3576	HOL	3330	HOL	G
3577	HOVET	3330	HOL	G
3579	TORPO	3328	ÅL	G
3580	GEILO	3330	HOL	G
3581	GEILO	3330	HOL	P
3588	DAGALI	3330	HOL	G
3593	USTAOSET	3330	HOL	B
3595	HAUGASTØL	3330	HOL	B
3601	KONGSBERG	3303	KONGSBERG	P
3602	KONGSBERG	3303	KONGSBERG	P
3603	KONGSBERG	3303	KONGSBERG	P
3604	KONGSBERG	3303	KONGSBERG	P
3605	KONGSBERG	3303	KONGSBERG	P
3606	KONGSBERG	3303	KONGSBERG	P
3607	KONGSBERG	3303	KONGSBERG	P
3608	HEISTADMOEN	3303	KONGSBERG	G
3609	KONGSBERG	3303	KONGSBERG	P
3610	KONGSBERG	3303	KONGSBERG	G
3611	KONGSBERG	3303	KONGSBERG	G
3612	KONGSBERG	3303	KONGSBERG	G
3613	KONGSBERG	3303	KONGSBERG	G
3614	KONGSBERG	3303	KONGSBERG	G
3615	KONGSBERG	3303	KONGSBERG	G
3616	KONGSBERG	3303	KONGSBERG	G
3617	KONGSBERG	3303	KONGSBERG	G
3618	SKOLLENBORG	3303	KONGSBERG	G
3619	SKOLLENBORG	3303	KONGSBERG	G
3620	FLESBERG	3334	FLESBERG	G
3621	LAMPELAND	3334	FLESBERG	P
3622	SVENE	3334	FLESBERG	G
3623	LAMPELAND	3334	FLESBERG	G
3624	LYNGDAL I NUMEDAL	3334	FLESBERG	G
3625	SKOLLENBORG	3303	KONGSBERG	P
3626	ROLLAG	3336	ROLLAG	G
3627	VEGGLI	3336	ROLLAG	P
3628	VEGGLI	3336	ROLLAG	G
3629	NORE	3338	NORE OG UVDAL	G
3630	RØDBERG	3338	NORE OG UVDAL	G
3631	RØDBERG	3338	NORE OG UVDAL	P
3632	UVDAL	3338	NORE OG UVDAL	G
3634	NORE	3338	NORE OG UVDAL	P
3646	HVITTINGFOSS	3303	KONGSBERG	P
3647	HVITTINGFOSS	3303	KONGSBERG	G
3648	PASSEBEKK	3303	KONGSBERG	G
3650	TINN AUSTBYGD	4026	TINN	G
3652	HOVIN I TELEMARK	4026	TINN	G
3656	ATRÅ	4026	TINN	G
3658	MILAND	4026	TINN	G
3660	RJUKAN	4026	TINN	G
3661	RJUKAN	4026	TINN	P
3665	SAULAND	4024	HJARTDAL	P
3666	ATRÅ	4026	TINN	P
3671	NOTODDEN	4005	NOTODDEN	P
3672	NOTODDEN	4005	NOTODDEN	P
3673	NOTODDEN	4005	NOTODDEN	P
3674	NOTODDEN	4005	NOTODDEN	G
3675	NOTODDEN	4005	NOTODDEN	G
3676	NOTODDEN	4005	NOTODDEN	G
3677	NOTODDEN	4005	NOTODDEN	G
3678	NOTODDEN	4005	NOTODDEN	G
3679	NOTODDEN	4005	NOTODDEN	G
3680	NOTODDEN	4005	NOTODDEN	G
3681	NOTODDEN	4005	NOTODDEN	G
3683	NOTODDEN	4005	NOTODDEN	G
3684	NOTODDEN	4005	NOTODDEN	G
3690	HJARTDAL	4024	HJARTDAL	G
3691	GRANSHERAD	4005	NOTODDEN	G
3692	SAULAND	4024	HJARTDAL	G
3697	TUDDAL	4024	HJARTDAL	G
3701	SKIEN	4003	SKIEN	P
3702	SKIEN	4003	SKIEN	P
3703	SKIEN	4003	SKIEN	P
3704	SKIEN	4003	SKIEN	P
3705	SKIEN	4003	SKIEN	P
3707	SKIEN	4003	SKIEN	P
3710	SKIEN	4003	SKIEN	B
3711	SKIEN	4003	SKIEN	G
3712	SKIEN	4003	SKIEN	G
3713	SKIEN	4003	SKIEN	G
3714	SKIEN	4003	SKIEN	G
3715	SKIEN	4003	SKIEN	G
3716	SKIEN	4003	SKIEN	G
3717	SKIEN	4003	SKIEN	G
3718	SKIEN	4003	SKIEN	G
3719	SKIEN	4003	SKIEN	G
3720	SKIEN	4003	SKIEN	G
3721	SKIEN	4003	SKIEN	G
3722	SKIEN	4003	SKIEN	G
3723	SKIEN	4003	SKIEN	G
3724	SKIEN	4003	SKIEN	G
3725	SKIEN	4003	SKIEN	G
3726	SKIEN	4003	SKIEN	G
3727	SKIEN	4003	SKIEN	G
3728	SKIEN	4003	SKIEN	G
3729	SKIEN	4003	SKIEN	G
3730	SKIEN	4003	SKIEN	G
3731	SKIEN	4003	SKIEN	G
3732	SKIEN	4003	SKIEN	G
3733	SKIEN	4003	SKIEN	G
3734	SKIEN	4003	SKIEN	G
3735	SKIEN	4003	SKIEN	G
3736	SKIEN	4003	SKIEN	G
3737	SKIEN	4003	SKIEN	G
3738	SKIEN	4003	SKIEN	G
3739	SKIEN	4003	SKIEN	G
3740	SKIEN	4003	SKIEN	G
3741	SKIEN	4003	SKIEN	G
3742	SKIEN	4003	SKIEN	G
3743	SKIEN	4003	SKIEN	G
3744	SKIEN	4003	SKIEN	G
3746	SKIEN	4003	SKIEN	G
3747	SKIEN	4003	SKIEN	G
3748	SILJAN	4010	SILJAN	G
3749	SILJAN	4010	SILJAN	P
3750	DRANGEDAL	4016	DRANGEDAL	G
3753	TØRDAL	4016	DRANGEDAL	G
3760	NESLANDSVATN	4016	DRANGEDAL	G
3766	SANNIDAL	4014	KRAGERØ	G
3770	KRAGERØ	4014	KRAGERØ	G
3772	KRAGERØ	4014	KRAGERØ	G
3780	SKÅTØY	4014	KRAGERØ	G
3781	JOMFRULAND	4014	KRAGERØ	G
3783	KRAGERØ SKJÆRGÅRD	4014	KRAGERØ	G
3785	SKIEN	4003	SKIEN	P
3786	SKIEN	4003	SKIEN	P
3788	STABBESTAD	4014	KRAGERØ	G
3789	KRAGERØ	4014	KRAGERØ	P
3790	HELLE	4014	KRAGERØ	G
3791	KRAGERØ	4014	KRAGERØ	P
3792	SKIEN	4003	SKIEN	P
3793	SANNIDAL	4014	KRAGERØ	P
3794	HELLE	4014	KRAGERØ	P
3795	DRANGEDAL	4016	DRANGEDAL	P
3796	SKIEN	4003	SKIEN	P
3798	SKIEN	4003	SKIEN	P
3799	SKIEN	4003	SKIEN	P
3800	BØ I TELEMARK	4020	MIDT-TELEMARK	G
3801	BØ I TELEMARK	4020	MIDT-TELEMARK	G
3802	BØ I TELEMARK	4020	MIDT-TELEMARK	G
3803	BØ I TELEMARK	4020	MIDT-TELEMARK	G
3804	BØ I TELEMARK	4020	MIDT-TELEMARK	G
3805	BØ I TELEMARK	4022	SELJORD	G
3810	GVARV	4020	MIDT-TELEMARK	G
3811	HØRTE	4020	MIDT-TELEMARK	G
3812	AKKERHAUGEN	4020	MIDT-TELEMARK	G
3820	NORDAGUTU	4020	MIDT-TELEMARK	G
3825	LUNDE	4018	NOME	G
3830	ULEFOSS	4018	NOME	G
3831	ULEFOSS	4018	NOME	P
3832	LUNDE	4018	NOME	P
3833	BØ I TELEMARK	4020	MIDT-TELEMARK	P
3834	GVARV	4020	MIDT-TELEMARK	P
3835	SELJORD	4022	SELJORD	P
3836	KVITESEID	4028	KVITESEID	P
3840	SELJORD	4022	SELJORD	G
3841	FLATDAL	4022	SELJORD	G
3844	ÅMOTSDAL	4022	SELJORD	G
3848	MORGEDAL	4028	KVITESEID	G
3849	VRÅLIOSEN	4028	KVITESEID	G
3850	KVITESEID	4028	KVITESEID	G
3852	VRÅDAL	4028	KVITESEID	P
3853	VRÅDAL	4028	KVITESEID	G
3854	NISSEDAL	4030	NISSEDAL	G
3855	TREUNGEN	4030	NISSEDAL	G
3864	RAULAND	4036	VINJE	G
3870	FYRESDAL	4032	FYRESDAL	G
3880	DALEN	4034	TOKKE	G
3882	ÅMDALS VERK	4034	TOKKE	G
3883	TREUNGEN	4030	NISSEDAL	P
3884	RAULAND	4036	VINJE	P
3885	FYRESDAL	4032	FYRESDAL	P
3886	DALEN	4034	TOKKE	P
3887	VINJE	4036	VINJE	P
3888	EDLAND	4036	VINJE	P
3890	VINJE	4036	VINJE	G
3891	HØYDALSMO	4034	TOKKE	G
3893	VINJESVINGEN	4036	VINJE	G
3895	EDLAND	4036	VINJE	G
3901	PORSGRUNN	4001	PORSGRUNN	P
3902	PORSGRUNN	4001	PORSGRUNN	P
3903	PORSGRUNN	4001	PORSGRUNN	P
3904	PORSGRUNN	4001	PORSGRUNN	P
3905	PORSGRUNN	4001	PORSGRUNN	P
3906	PORSGRUNN	4001	PORSGRUNN	P
3910	PORSGRUNN	4001	PORSGRUNN	G
3911	PORSGRUNN	4001	PORSGRUNN	G
3912	PORSGRUNN	4001	PORSGRUNN	G
3913	PORSGRUNN	4001	PORSGRUNN	G
3914	PORSGRUNN	4001	PORSGRUNN	G
3915	PORSGRUNN	4001	PORSGRUNN	G
3916	PORSGRUNN	4001	PORSGRUNN	G
3917	PORSGRUNN	4001	PORSGRUNN	G
3918	PORSGRUNN	4001	PORSGRUNN	G
3919	PORSGRUNN	4001	PORSGRUNN	G
3920	PORSGRUNN	4001	PORSGRUNN	G
3921	PORSGRUNN	4001	PORSGRUNN	G
3922	PORSGRUNN	4001	PORSGRUNN	G
3924	PORSGRUNN	4001	PORSGRUNN	G
3925	PORSGRUNN	4001	PORSGRUNN	G
3928	PORSGRUNN	4001	PORSGRUNN	G
3929	PORSGRUNN	4001	PORSGRUNN	G
3930	PORSGRUNN	4001	PORSGRUNN	G
3931	PORSGRUNN	4001	PORSGRUNN	G
3933	PORSGRUNN	4001	PORSGRUNN	G
3936	PORSGRUNN	4001	PORSGRUNN	G
3937	PORSGRUNN	4001	PORSGRUNN	G
3939	PORSGRUNN	4001	PORSGRUNN	P
3940	PORSGRUNN	4001	PORSGRUNN	G
3941	PORSGRUNN	4001	PORSGRUNN	G
3942	PORSGRUNN	4001	PORSGRUNN	G
3943	PORSGRUNN	4001	PORSGRUNN	G
3944	PORSGRUNN	4001	PORSGRUNN	G
3946	PORSGRUNN	4001	PORSGRUNN	G
3947	LANGANGEN	4001	PORSGRUNN	G
3948	PORSGRUNN	4001	PORSGRUNN	G
3949	PORSGRUNN	4001	PORSGRUNN	G
3950	BREVIK	4001	PORSGRUNN	G
3960	STATHELLE	4012	BAMBLE	G
3961	STATHELLE	4012	BAMBLE	G
3962	STATHELLE	4012	BAMBLE	G
3965	HERRE	4012	BAMBLE	G
3966	STATHELLE	4012	BAMBLE	P
3967	STATHELLE	4012	BAMBLE	G
3970	LANGESUND	4012	BAMBLE	G
3991	BREVIK	4001	PORSGRUNN	P
3993	LANGESUND	4012	BAMBLE	P
3994	LANGESUND	4012	BAMBLE	P
3995	STATHELLE	4012	BAMBLE	P
3996	PORSGRUNN	4001	PORSGRUNN	P
3997	PORSGRUNN	4001	PORSGRUNN	P
3998	PORSGRUNN	4001	PORSGRUNN	P
3999	HERRE	4012	BAMBLE	P
4001	STAVANGER	1103	STAVANGER	P
4002	STAVANGER	1103	STAVANGER	P
4003	STAVANGER	1103	STAVANGER	P
4004	STAVANGER	1103	STAVANGER	P
4005	STAVANGER	1103	STAVANGER	G
4006	STAVANGER	1103	STAVANGER	G
4007	STAVANGER	1103	STAVANGER	G
4008	STAVANGER	1103	STAVANGER	G
4009	STAVANGER	1103	STAVANGER	G
4010	STAVANGER	1103	STAVANGER	G
4011	STAVANGER	1103	STAVANGER	G
4012	STAVANGER	1103	STAVANGER	G
4013	STAVANGER	1103	STAVANGER	G
4014	STAVANGER	1103	STAVANGER	G
4015	STAVANGER	1103	STAVANGER	G
4016	STAVANGER	1103	STAVANGER	G
4017	STAVANGER	1103	STAVANGER	G
4018	STAVANGER	1103	STAVANGER	G
4019	STAVANGER	1103	STAVANGER	G
4020	STAVANGER	1103	STAVANGER	G
4021	STAVANGER	1103	STAVANGER	G
4022	STAVANGER	1103	STAVANGER	G
4023	STAVANGER	1103	STAVANGER	G
4024	STAVANGER	1103	STAVANGER	G
4025	STAVANGER	1103	STAVANGER	G
4026	STAVANGER	1103	STAVANGER	G
4027	STAVANGER	1103	STAVANGER	G
4028	STAVANGER	1103	STAVANGER	G
4029	STAVANGER	1103	STAVANGER	G
4031	STAVANGER	1103	STAVANGER	G
4032	STAVANGER	1103	STAVANGER	G
4033	STAVANGER	1103	STAVANGER	G
4034	STAVANGER	1103	STAVANGER	G
4035	STAVANGER	1103	STAVANGER	B
4036	STAVANGER	1103	STAVANGER	P
4041	HAFRSFJORD	1103	STAVANGER	G
4042	HAFRSFJORD	1103	STAVANGER	G
4043	HAFRSFJORD	1103	STAVANGER	G
4044	HAFRSFJORD	1103	STAVANGER	G
4045	HAFRSFJORD	1103	STAVANGER	G
4046	HAFRSFJORD	1103	STAVANGER	G
4047	HAFRSFJORD	1103	STAVANGER	G
4048	HAFRSFJORD	1103	STAVANGER	G
4049	HAFRSFJORD	1103	STAVANGER	G
4050	SOLA	1124	SOLA	G
4051	SOLA	1124	SOLA	G
4052	RØYNEBERG	1124	SOLA	G
4053	RÆGE	1124	SOLA	G
4054	TJELTA	1124	SOLA	G
4055	SOLA	1124	SOLA	G
4056	TANANGER	1124	SOLA	G
4057	TANANGER	1124	SOLA	G
4058	TANANGER	1124	SOLA	G
4059	RØYNEBERG	1124	SOLA	P
4063	TJELTA	1124	SOLA	P
4068	STAVANGER	1103	STAVANGER	P
4070	RANDABERG	1127	RANDABERG	G
4071	RANDABERG	1127	RANDABERG	G
4072	RANDABERG	1127	RANDABERG	G
4073	RANDABERG	1127	RANDABERG	G
4075	STAVANGER	1103	STAVANGER	G
4076	VASSØY	1103	STAVANGER	G
4077	HUNDVÅG	1103	STAVANGER	G
4078	STAVANGER	1103	STAVANGER	P
4079	STAVANGER	1103	STAVANGER	P
4081	STAVANGER	1103	STAVANGER	P
4082	STAVANGER	1103	STAVANGER	P
4083	HUNDVÅG	1103	STAVANGER	G
4084	STAVANGER	1103	STAVANGER	P
4085	HUNDVÅG	1103	STAVANGER	G
4086	HUNDVÅG	1103	STAVANGER	P
4087	STAVANGER	1103	STAVANGER	P
4088	STAVANGER	1103	STAVANGER	P
4089	HAFRSFJORD	1103	STAVANGER	P
4090	HAFRSFJORD	1103	STAVANGER	P
4091	HAFRSFJORD	1103	STAVANGER	P
4092	STAVANGER	1103	STAVANGER	P
4093	STAVANGER	1103	STAVANGER	P
4094	STAVANGER	1103	STAVANGER	P
4095	STAVANGER	1103	STAVANGER	P
4096	RANDABERG	1127	RANDABERG	P
4097	SOLA	1124	SOLA	P
4098	TANANGER	1124	SOLA	P
4099	STAVANGER	1103	STAVANGER	P
4100	JØRPELAND	1130	STRAND	G
4102	IDSE	1130	STRAND	G
4103	JØRPELAND	1130	STRAND	G
4104	JØRPELAND	1130	STRAND	G
4105	JØRPELAND	1130	STRAND	G
4110	FORSAND	1108	SANDNES	G
4119	FORSAND	1108	SANDNES	P
4120	TAU	1130	STRAND	G
4121	TAU	1130	STRAND	G
4123	SØR-HIDLE	1130	STRAND	G
4124	TAU	1130	STRAND	P
4126	JØRPELAND	1130	STRAND	P
4127	LYSEBOTN	1108	SANDNES	G
4128	FLØRLI	1108	SANDNES	G
4129	SONGESAND	1108	SANDNES	G
4130	HJELMELAND	1133	HJELMELAND	G
4134	JØSENFJORDEN	1133	HJELMELAND	G
4137	ÅRDAL I RYFYLKE	1133	HJELMELAND	G
4139	FISTER	1133	HJELMELAND	G
4146	SKIFTUN	1133	HJELMELAND	G
4148	HJELMELAND	1133	HJELMELAND	P
4150	RENNESØY	1103	STAVANGER	G
4152	VESTRE ÅMØY	1103	STAVANGER	G
4153	BRIMSE	1103	STAVANGER	G
4154	AUSTRE ÅMØY	1103	STAVANGER	G
4156	MOSTERØY	1103	STAVANGER	G
4158	BRU	1103	STAVANGER	G
4159	RENNESØY	1103	STAVANGER	P
4160	FINNØY	1103	STAVANGER	G
4161	FINNØY	1103	STAVANGER	P
4163	TALGJE	1103	STAVANGER	G
4164	FOGN	1103	STAVANGER	G
4167	HELGØY I RYFYLKE	1133	HJELMELAND	G
4168	BYRE	1103	STAVANGER	G
4169	SØRBOKN	1103	STAVANGER	G
4170	SJERNARØY	1103	STAVANGER	G
4173	NORD-HIDLE	1103	STAVANGER	G
4174	SJERNARØY	1103	STAVANGER	P
4180	KVITSØY	1144	KVITSØY	G
4181	KVITSØY	1144	KVITSØY	P
4182	SKARTVEIT	1103	STAVANGER	B
4187	OMBO	1103	STAVANGER	G
4198	FOLDØY	1134	SULDAL	G
4200	SAUDA	1135	SAUDA	G
4201	SAUDA	1135	SAUDA	P
4208	SAUDASJØEN	1135	SAUDA	G
4209	VANVIK	1134	SULDAL	G
4230	SAND	1134	SULDAL	G
4233	ERFJORD	1134	SULDAL	G
4234	JELSA	1134	SULDAL	G
4235	HEBNES	1134	SULDAL	G
4237	SULDALSOSEN	1134	SULDAL	G
4238	ERFJORD	1134	SULDAL	P
4239	SAND	1134	SULDAL	P
4240	SULDALSOSEN	1134	SULDAL	P
4244	NESFLATEN	1134	SULDAL	G
4250	KOPERVIK	1149	KARMØY	G
4260	TORVASTAD	1149	KARMØY	G
4262	AVALDSNES	1149	KARMØY	G
4264	KVALAVÅG	1149	KARMØY	G
4265	HÅVIK	1149	KARMØY	G
4270	ÅKREHAMN	1149	KARMØY	G
4272	SANDVE	1149	KARMØY	G
4274	STOL	1149	KARMØY	G
4275	SÆVELANDSVIK	1149	KARMØY	G
4276	VEAVÅGEN	1149	KARMØY	G
4280	SKUDENESHAVN	1149	KARMØY	G
4291	KOPERVIK	1149	KARMØY	P
4294	KOPERVIK	1149	KARMØY	P
4295	VEAVÅGEN	1149	KARMØY	P
4296	ÅKREHAMN	1149	KARMØY	P
4297	SKUDENESHAVN	1149	KARMØY	P
4298	TORVASTAD	1149	KARMØY	P
4299	AVALDSNES	1149	KARMØY	P
4301	SANDNES	1108	SANDNES	P
4302	SANDNES	1108	SANDNES	P
4306	SANDNES	1108	SANDNES	G
4307	SANDNES	1108	SANDNES	G
4308	SANDNES	1108	SANDNES	G
4309	SANDNES	1108	SANDNES	G
4310	HOMMERSÅK	1108	SANDNES	G
4311	HOMMERSÅK	1108	SANDNES	G
4312	SANDNES	1108	SANDNES	G
4313	SANDNES	1108	SANDNES	G
4314	SANDNES	1108	SANDNES	G
4315	SANDNES	1108	SANDNES	G
4316	SANDNES	1108	SANDNES	G
4317	SANDNES	1108	SANDNES	G
4318	SANDNES	1108	SANDNES	G
4319	SANDNES	1108	SANDNES	G
4320	SANDNES	1108	SANDNES	G
4321	SANDNES	1108	SANDNES	G
4322	SANDNES	1108	SANDNES	G
4323	SANDNES	1108	SANDNES	G
4324	SANDNES	1108	SANDNES	G
4325	SANDNES	1108	SANDNES	G
4326	SANDNES	1108	SANDNES	G
4327	SANDNES	1108	SANDNES	G
4328	SANDNES	1108	SANDNES	G
4329	SANDNES	1108	SANDNES	G
4330	ÅLGÅRD	1122	GJESDAL	G
4331	ÅLGÅRD	1122	GJESDAL	G
4332	FIGGJO	1108	SANDNES	G
4333	OLTEDAL	1122	GJESDAL	G
4334	ÅLGÅRD	1122	GJESDAL	G
4335	DIRDAL	1122	GJESDAL	G
4336	SANDNES	1108	SANDNES	G
4337	SANDNES	1108	SANDNES	G
4338	SANDNES	1108	SANDNES	G
4339	ÅLGÅRD	1122	GJESDAL	P
4340	BRYNE	1121	TIME	G
4341	BRYNE	1120	KLEPP	G
4342	UNDHEIM	1121	TIME	G
4343	ORRE	1120	KLEPP	G
4344	BRYNE	1121	TIME	G
4345	BRYNE	1121	TIME	G
4346	BRYNE	1121	TIME	G
4347	LYE	1121	TIME	G
4348	LYE	1121	TIME	P
4349	BRYNE	1121	TIME	P
4350	KLEPPE	1120	KLEPP	G
4351	KLEPPE	1120	KLEPP	G
4352	KLEPPE	1120	KLEPP	G
4353	KLEPP STASJON	1120	KLEPP	G
4354	VOLL	1120	KLEPP	G
4355	KVERNALAND	1121	TIME	G
4356	KVERNALAND	1121	TIME	P
4357	KLEPP STASJON	1120	KLEPP	P
4358	KLEPPE	1120	KLEPP	P
4360	VARHAUG	1119	HÅ	G
4361	SIREVÅG	1119	HÅ	P
4362	VIGRESTAD	1119	HÅ	G
4363	BRUSAND	1119	HÅ	G
4364	SIREVÅG	1119	HÅ	G
4365	NÆRBØ	1119	HÅ	G
4367	NÆRBØ	1119	HÅ	P
4368	VARHAUG	1119	HÅ	P
4369	VIGRESTAD	1119	HÅ	P
4370	EGERSUND	1101	EIGERSUND	G
4371	EGERSUND	1101	EIGERSUND	G
4372	EGERSUND	1101	EIGERSUND	G
4373	EGERSUND	1101	EIGERSUND	G
4374	EGERSUND	1101	EIGERSUND	G
4375	HELLVIK	1101	EIGERSUND	G
4376	HELLELAND	1101	EIGERSUND	G
4378	EGERSUND	1101	EIGERSUND	P
4379	EGERSUND	1101	EIGERSUND	P
4380	HAUGE I DALANE	1111	SOKNDAL	G
4381	HAUGE I DALANE	1111	SOKNDAL	P
4384	VIKESÅ	1114	BJERKREIM	P
4385	HELLELAND	1101	EIGERSUND	P
4387	BJERKREIM	1114	BJERKREIM	G
4389	VIKESÅ	1114	BJERKREIM	G
4390	OLTEDAL	1122	GJESDAL	P
4391	SANDNES	1108	SANDNES	P
4392	SANDNES	1108	SANDNES	P
4393	SANDNES	1108	SANDNES	P
4394	SANDNES	1108	SANDNES	P
4395	HOMMERSÅK	1108	SANDNES	P
4396	SANDNES	1108	SANDNES	P
4397	SANDNES	1108	SANDNES	P
4398	SANDNES	1108	SANDNES	P
4399	SANDNES	1108	SANDNES	P
4400	FLEKKEFJORD	4207	FLEKKEFJORD	G
4401	FLEKKEFJORD	4207	FLEKKEFJORD	P
4402	FLEKKEFJORD	4207	FLEKKEFJORD	P
4403	FLEKKEFJORD	4207	FLEKKEFJORD	P
4404	FLEKKEFJORD	4207	FLEKKEFJORD	G
4405	FLEKKEFJORD	4207	FLEKKEFJORD	G
4406	FLEKKEFJORD	4207	FLEKKEFJORD	G
4407	FLEKKEFJORD	4207	FLEKKEFJORD	G
4420	ÅNA-SIRA	4207	FLEKKEFJORD	G
4432	HIDRASUND	4207	FLEKKEFJORD	G
4434	ANDABELØY	4207	FLEKKEFJORD	G
4436	GYLAND	4207	FLEKKEFJORD	G
4438	SIRA	4207	FLEKKEFJORD	G
4439	SIRA	4207	FLEKKEFJORD	P
4440	TONSTAD	4228	SIRDAL	G
4441	TONSTAD	4228	SIRDAL	P
4443	TJØRHOM	4228	SIRDAL	G
4460	MOI	1112	LUND	G
4462	HOVSHERAD	1112	LUND	G
4463	UALAND	1112	LUND	G
4465	MOI	1112	LUND	P
4473	KVINLOG	4227	KVINESDAL	G
4480	KVINESDAL	4227	KVINESDAL	G
4484	ØYESTRANDA	4227	KVINESDAL	G
4485	FEDA	4227	KVINESDAL	G
4486	FEDA	4227	KVINESDAL	P
4490	KVINESDAL	4227	KVINESDAL	P
4491	KVINESDAL	4227	KVINESDAL	P
4492	KVINESDAL	4227	KVINESDAL	P
4501	MANDAL	4205	LINDESNES	P
4502	MANDAL	4205	LINDESNES	P
4503	MANDAL	4205	LINDESNES	P
4504	MANDAL	4205	LINDESNES	P
4507	MANDAL	4205	LINDESNES	P
4508	MANDAL	4205	LINDESNES	P
4509	MANDAL	4205	LINDESNES	P
4513	MANDAL	4205	LINDESNES	G
4514	MANDAL	4205	LINDESNES	G
4515	MANDAL	4205	LINDESNES	G
4516	MANDAL	4205	LINDESNES	G
4517	MANDAL	4205	LINDESNES	G
4519	HOLUM	4205	LINDESNES	G
4520	LINDESNES	4205	LINDESNES	G
4521	LINDESNES	4205	LINDESNES	G
4522	LINDESNES	4205	LINDESNES	P
4523	LINDESNES	4205	LINDESNES	P
4524	LINDESNES	4205	LINDESNES	P
4525	KONSMO	4225	LYNGDAL	G
4526	KONSMO	4225	LYNGDAL	P
4528	KOLLUNGTVEIT	4225	LYNGDAL	G
4529	BYREMO	4225	LYNGDAL	G
4532	ØYSLEBØ	4205	LINDESNES	G
4534	MARNARDAL	4205	LINDESNES	G
4535	MARNARDAL	4205	LINDESNES	P
4536	BJELLAND	4205	LINDESNES	G
4540	ÅSERAL	4224	ÅSERAL	G
4541	ÅSERAL	4224	ÅSERAL	P
4544	FOSSDAL	4224	ÅSERAL	G
4550	FARSUND	4206	FARSUND	G
4551	FARSUND	4206	FARSUND	P
4552	FARSUND	4206	FARSUND	P
4553	FARSUND	4206	FARSUND	P
4554	FARSUND	4206	FARSUND	P
4557	VANSE	4206	FARSUND	P
4558	VANSE	4206	FARSUND	P
4560	VANSE	4206	FARSUND	G
4563	BORHAUG	4206	FARSUND	G
4575	LYNGDAL	4225	LYNGDAL	P
4576	LYNGDAL	4225	LYNGDAL	P
4577	LYNGDAL	4225	LYNGDAL	P
4579	LYNGDAL	4225	LYNGDAL	P
4580	LYNGDAL	4225	LYNGDAL	G
4586	KORSHAMN	4225	LYNGDAL	G
4588	KVÅS	4225	LYNGDAL	G
4590	SNARTEMO	4226	HÆGEBOSTAD	G
4595	TINGVATN	4226	HÆGEBOSTAD	G
4596	EIKEN	4226	HÆGEBOSTAD	G
4597	EIKEN	4226	HÆGEBOSTAD	P
4604	KRISTIANSAND S	4204	KRISTIANSAND	P
4605	KRISTIANSAND S	4204	KRISTIANSAND	P
4606	KRISTIANSAND S	4204	KRISTIANSAND	P
4608	KRISTIANSAND S	4204	KRISTIANSAND	G
4609	KARDEMOMME BY	4204	KRISTIANSAND	G
4610	KRISTIANSAND S	4204	KRISTIANSAND	G
4611	KRISTIANSAND S	4204	KRISTIANSAND	G
4612	KRISTIANSAND S	4204	KRISTIANSAND	G
4613	KRISTIANSAND S	4204	KRISTIANSAND	G
4614	KRISTIANSAND S	4204	KRISTIANSAND	G
4615	KRISTIANSAND S	4204	KRISTIANSAND	G
4616	KRISTIANSAND S	4204	KRISTIANSAND	G
4617	KRISTIANSAND S	4204	KRISTIANSAND	G
4618	KRISTIANSAND S	4204	KRISTIANSAND	G
4619	MOSBY	4204	KRISTIANSAND	G
4620	KRISTIANSAND S	4204	KRISTIANSAND	G
4621	KRISTIANSAND S	4204	KRISTIANSAND	G
4622	KRISTIANSAND S	4204	KRISTIANSAND	G
4623	KRISTIANSAND S	4204	KRISTIANSAND	G
4624	KRISTIANSAND S	4204	KRISTIANSAND	G
4625	FLEKKERØY	4204	KRISTIANSAND	G
4626	KRISTIANSAND S	4204	KRISTIANSAND	G
4628	KRISTIANSAND S	4204	KRISTIANSAND	G
4629	KRISTIANSAND S	4204	KRISTIANSAND	G
4630	KRISTIANSAND S	4204	KRISTIANSAND	G
4631	KRISTIANSAND S	4204	KRISTIANSAND	G
4632	KRISTIANSAND S	4204	KRISTIANSAND	G
4633	KRISTIANSAND S	4204	KRISTIANSAND	G
4634	KRISTIANSAND S	4204	KRISTIANSAND	G
4635	KRISTIANSAND S	4204	KRISTIANSAND	G
4636	KRISTIANSAND S	4204	KRISTIANSAND	G
4637	KRISTIANSAND S	4204	KRISTIANSAND	G
4638	KRISTIANSAND S	4204	KRISTIANSAND	G
4639	KRISTIANSAND S	4204	KRISTIANSAND	G
4640	SØGNE	4204	KRISTIANSAND	G
4641	SØGNE	4204	KRISTIANSAND	G
4642	SØGNE	4204	KRISTIANSAND	G
4643	SØGNE	4204	KRISTIANSAND	G
4644	SØGNE	4204	KRISTIANSAND	G
4645	NODELAND	4204	KRISTIANSAND	G
4646	FINSLAND	4204	KRISTIANSAND	G
4647	BRENNÅSEN	4204	KRISTIANSAND	G
4649	FINSLAND	4204	KRISTIANSAND	P
4656	HAMRESANDEN	4204	KRISTIANSAND	G
4657	KJEVIK	4204	KRISTIANSAND	G
4658	TVEIT	4204	KRISTIANSAND	G
4661	KRISTIANSAND S	4204	KRISTIANSAND	P
4662	KRISTIANSAND S	4204	KRISTIANSAND	P
4663	KRISTIANSAND S	4204	KRISTIANSAND	P
4664	KRISTIANSAND S	4204	KRISTIANSAND	P
4665	KRISTIANSAND S	4204	KRISTIANSAND	P
4666	KRISTIANSAND S	4204	KRISTIANSAND	P
4670	KRISTIANSAND S	4204	KRISTIANSAND	P
4671	KRISTIANSAND S	4204	KRISTIANSAND	P
4673	KRISTIANSAND S	4204	KRISTIANSAND	P
4674	KRISTIANSAND S	4204	KRISTIANSAND	P
4675	KRISTIANSAND S	4204	KRISTIANSAND	P
4676	KRISTIANSAND S	4204	KRISTIANSAND	P
4677	KRISTIANSAND S	4204	KRISTIANSAND	P
4678	KRISTIANSAND S	4204	KRISTIANSAND	P
4679	FLEKKERØY	4204	KRISTIANSAND	P
4681	SØGNE	4204	KRISTIANSAND	P
4682	SØGNE	4204	KRISTIANSAND	P
4683	SØGNE	4204	KRISTIANSAND	P
4684	BRENNÅSEN	4204	KRISTIANSAND	P
4685	NODELAND	4204	KRISTIANSAND	P
4686	KRISTIANSAND S	4204	KRISTIANSAND	P
4687	KRISTIANSAND S	4204	KRISTIANSAND	P
4688	KRISTIANSAND S	4204	KRISTIANSAND	P
4689	KRISTIANSAND S	4204	KRISTIANSAND	P
4691	KRISTIANSAND S	4204	KRISTIANSAND	P
4693	KRISTIANSAND S	4204	KRISTIANSAND	P
4694	KRISTIANSAND S	4204	KRISTIANSAND	P
4695	KRISTIANSAND S	4204	KRISTIANSAND	P
4696	KRISTIANSAND S	4204	KRISTIANSAND	P
4697	KRISTIANSAND S	4204	KRISTIANSAND	P
4698	KRISTIANSAND S	4204	KRISTIANSAND	P
4699	TVEIT	4204	KRISTIANSAND	P
4700	VENNESLA	4223	VENNESLA	G
4701	VENNESLA	4223	VENNESLA	P
4702	VENNESLA	4223	VENNESLA	P
4703	VENNESLA	4223	VENNESLA	P
4705	ØVREBØ	4223	VENNESLA	P
4706	VENNESLA	4223	VENNESLA	G
4707	VENNESLA	4223	VENNESLA	G
4708	VENNESLA	4223	VENNESLA	G
4715	ØVREBØ	4223	VENNESLA	G
4720	HÆGELAND	4223	VENNESLA	G
4721	HÆGELAND	4223	VENNESLA	P
4724	IVELAND	4218	IVELAND	G
4725	IVELAND	4218	IVELAND	P
4730	VATNESTRØM	4218	IVELAND	G
4733	EVJE	4219	EVJE OG HORNNES	P
4734	EVJE	4219	EVJE OG HORNNES	P
4735	EVJE	4219	EVJE OG HORNNES	G
4737	HORNNES	4219	EVJE OG HORNNES	G
4741	BYGLANDSFJORD	4220	BYGLAND	G
4742	GRENDI	4220	BYGLAND	G
4744	BYGLAND	4220	BYGLAND	P
4745	BYGLAND	4220	BYGLAND	G
4746	VALLE	4221	VALLE	P
4747	VALLE	4221	VALLE	G
4748	RYSSTAD	4221	VALLE	G
4749	RYSSTAD	4221	VALLE	P
4754	BYKLE	4222	BYKLE	G
4755	HOVDEN I SETESDAL	4222	BYKLE	G
4756	HOVDEN I SETESDAL	4222	BYKLE	P
4760	BIRKELAND	4216	BIRKENES	G
4766	HEREFOSS	4216	BIRKENES	G
4768	ENGESLAND	4216	BIRKENES	G
4770	HØVÅG	4215	LILLESAND	G
4780	BREKKESTØ	4215	LILLESAND	G
4790	LILLESAND	4215	LILLESAND	G
4791	LILLESAND	4215	LILLESAND	P
4792	LILLESAND	4215	LILLESAND	P
4793	HØVÅG	4215	LILLESAND	P
4794	LILLESAND	4215	LILLESAND	P
4795	BIRKELAND	4216	BIRKENES	P
4801	ARENDAL	4203	ARENDAL	P
4802	ARENDAL	4203	ARENDAL	P
4803	ARENDAL	4203	ARENDAL	P
4804	ARENDAL	4203	ARENDAL	P
4808	ARENDAL	4203	ARENDAL	P
4809	ARENDAL	4203	ARENDAL	P
4810	EYDEHAVN	4203	ARENDAL	G
4812	KONGSHAVN	4203	ARENDAL	G
4815	SALTRØD	4203	ARENDAL	G
4816	KOLBJØRNSVIK	4203	ARENDAL	G
4817	HIS	4203	ARENDAL	G
4818	FÆRVIK	4203	ARENDAL	G
4820	FROLAND	4214	FROLAND	G
4821	RYKENE	4203	ARENDAL	G
4822	RYKENE	4203	ARENDAL	P
4823	NEDENES	4203	ARENDAL	G
4824	BJORBEKK	4203	ARENDAL	G
4825	ARENDAL	4203	ARENDAL	G
4827	FROLANDS VERK	4214	FROLAND	G
4828	MJÅVATN	4214	FROLAND	G
4830	HYNNEKLEIV	4214	FROLAND	G
4832	MYKLAND	4214	FROLAND	G
4834	RISDAL	4214	FROLAND	G
4836	ARENDAL	4203	ARENDAL	G
4838	ARENDAL	4203	ARENDAL	G
4839	ARENDAL	4203	ARENDAL	G
4841	ARENDAL	4203	ARENDAL	G
4842	ARENDAL	4203	ARENDAL	G
4843	ARENDAL	4203	ARENDAL	G
4844	ARENDAL	4203	ARENDAL	G
4846	ARENDAL	4203	ARENDAL	G
4847	ARENDAL	4203	ARENDAL	G
4848	ARENDAL	4203	ARENDAL	G
4849	ARENDAL	4203	ARENDAL	G
4851	SALTRØD	4203	ARENDAL	P
4852	FÆRVIK	4203	ARENDAL	P
4853	HIS	4203	ARENDAL	P
4854	NEDENES	4203	ARENDAL	P
4855	FROLAND	4214	FROLAND	P
4856	ARENDAL	4203	ARENDAL	P
4857	ARENDAL	4203	ARENDAL	P
4858	ARENDAL	4203	ARENDAL	P
4859	ARENDAL	4203	ARENDAL	P
4862	EYDEHAVN	4203	ARENDAL	P
4863	NELAUG	4217	ÅMLI	G
4864	ÅMLI	4217	ÅMLI	P
4865	ÅMLI	4217	ÅMLI	G
4868	SELÅSVATN	4217	ÅMLI	G
4869	DØLEMO	4217	ÅMLI	G
4870	FEVIK	4202	GRIMSTAD	G
4876	GRIMSTAD	4202	GRIMSTAD	G
4877	GRIMSTAD	4202	GRIMSTAD	G
4878	GRIMSTAD	4202	GRIMSTAD	G
4879	GRIMSTAD	4202	GRIMSTAD	G
4884	GRIMSTAD	4202	GRIMSTAD	P
4885	GRIMSTAD	4202	GRIMSTAD	G
4886	GRIMSTAD	4202	GRIMSTAD	G
4887	GRIMSTAD	4202	GRIMSTAD	G
4888	HOMBORSUND	4202	GRIMSTAD	G
4889	FEVIK	4202	GRIMSTAD	P
4891	GRIMSTAD	4202	GRIMSTAD	P
4892	GRIMSTAD	4202	GRIMSTAD	P
4893	GRIMSTAD	4202	GRIMSTAD	P
4894	GRIMSTAD	4202	GRIMSTAD	P
4896	GRIMSTAD	4202	GRIMSTAD	P
4898	GRIMSTAD	4202	GRIMSTAD	P
4900	TVEDESTRAND	4213	TVEDESTRAND	G
4901	TVEDESTRAND	4213	TVEDESTRAND	P
4902	TVEDESTRAND	4213	TVEDESTRAND	P
4903	TVEDESTRAND	4213	TVEDESTRAND	G
4904	TVEDESTRAND	4213	TVEDESTRAND	G
4905	TVEDESTRAND	4213	TVEDESTRAND	G
4909	SONGE	4213	TVEDESTRAND	G
4910	LYNGØR	4213	TVEDESTRAND	B
4912	GJEVING	4213	TVEDESTRAND	G
4915	VESTRE SANDØYA	4213	TVEDESTRAND	G
4916	BORØY	4213	TVEDESTRAND	G
4920	STAUBØ	4203	ARENDAL	G
4921	STAUBØ	4203	ARENDAL	P
4934	NES VERK	4213	TVEDESTRAND	G
4950	RISØR	4201	RISØR	G
4951	RISØR	4201	RISØR	P
4952	RISØR	4201	RISØR	P
4953	RISØR	4201	RISØR	P
4955	RISØR	4201	RISØR	P
4956	RISØR	4201	RISØR	G
4957	RISØR	4201	RISØR	G
4971	SUNDEBRU	4211	GJERSTAD	P
4972	GJERSTAD	4211	GJERSTAD	P
4973	VEGÅRSHEI	4212	VEGÅRSHEI	P
4974	SØNDELED	4201	RISØR	P
4980	GJERSTAD	4211	GJERSTAD	G
4985	VEGÅRSHEI	4212	VEGÅRSHEI	G
4990	SØNDELED	4201	RISØR	G
4993	SUNDEBRU	4211	GJERSTAD	G
4994	AKLAND	4201	RISØR	G
5003	BERGEN	4601	BERGEN	G
5004	BERGEN	4601	BERGEN	G
5005	BERGEN	4601	BERGEN	G
5006	BERGEN	4601	BERGEN	G
5007	BERGEN	4601	BERGEN	G
5008	BERGEN	4601	BERGEN	G
5009	BERGEN	4601	BERGEN	G
5010	BERGEN	4601	BERGEN	G
5011	BERGEN	4601	BERGEN	G
5012	BERGEN	4601	BERGEN	G
5013	BERGEN	4601	BERGEN	G
5014	BERGEN	4601	BERGEN	G
5015	BERGEN	4601	BERGEN	G
5016	BERGEN	4601	BERGEN	G
5017	BERGEN	4601	BERGEN	G
5018	BERGEN	4601	BERGEN	G
5019	BERGEN	4601	BERGEN	G
5020	BERGEN	4601	BERGEN	P
5021	BERGEN	4601	BERGEN	B
5022	BERGEN	4601	BERGEN	G
5031	BERGEN	4601	BERGEN	G
5032	BERGEN	4601	BERGEN	G
5033	BERGEN	4601	BERGEN	G
5034	BERGEN	4601	BERGEN	G
5035	BERGEN	4601	BERGEN	G
5036	BERGEN	4601	BERGEN	G
5037	BERGEN	4601	BERGEN	G
5038	BERGEN	4601	BERGEN	G
5039	BERGEN	4601	BERGEN	G
5041	BERGEN	4601	BERGEN	G
5042	BERGEN	4601	BERGEN	G
5043	BERGEN	4601	BERGEN	G
5045	BERGEN	4601	BERGEN	B
5052	BERGEN	4601	BERGEN	G
5053	BERGEN	4601	BERGEN	G
5054	BERGEN	4601	BERGEN	G
5055	BERGEN	4601	BERGEN	G
5056	BERGEN	4601	BERGEN	G
5057	BERGEN	4601	BERGEN	G
5058	BERGEN	4601	BERGEN	G
5059	BERGEN	4601	BERGEN	G
5063	BERGEN	4601	BERGEN	G
5067	BERGEN	4601	BERGEN	G
5068	BERGEN	4601	BERGEN	G
5072	BERGEN	4601	BERGEN	G
5073	BERGEN	4601	BERGEN	G
5075	BERGEN	4601	BERGEN	G
5081	BERGEN	4601	BERGEN	G
5082	BERGEN	4601	BERGEN	G
5089	BERGEN	4601	BERGEN	G
5093	BERGEN	4601	BERGEN	G
5094	BERGEN	4601	BERGEN	G
5096	BERGEN	4601	BERGEN	G
5097	BERGEN	4601	BERGEN	G
5098	BERGEN	4601	BERGEN	G
5099	BERGEN	4601	BERGEN	G
5101	EIDSVÅGNESET	4601	BERGEN	G
5104	EIDSVÅG I ÅSANE	4601	BERGEN	G
5105	EIDSVÅG I ÅSANE	4601	BERGEN	G
5106	ØVRE ERVIK	4601	BERGEN	G
5107	SALHUS	4601	BERGEN	G
5108	HORDVIK	4601	BERGEN	G
5109	HYLKJE	4601	BERGEN	G
5111	BREISTEIN	4601	BERGEN	G
5113	TERTNES	4601	BERGEN	G
5114	TERTNES	4601	BERGEN	G
5115	ULSET	4601	BERGEN	G
5116	ULSET	4601	BERGEN	G
5117	ULSET	4601	BERGEN	G
5118	ULSET	4601	BERGEN	G
5119	ULSET	4601	BERGEN	G
5121	ULSET	4601	BERGEN	G
5122	MORVIK	4601	BERGEN	G
5124	MORVIK	4601	BERGEN	G
5130	NYBORG	4601	BERGEN	G
5131	NYBORG	4601	BERGEN	G
5132	NYBORG	4601	BERGEN	G
5134	FLAKTVEIT	4601	BERGEN	G
5135	FLAKTVEIT	4601	BERGEN	G
5136	MJØLKERÅEN	4601	BERGEN	G
5137	MJØLKERÅEN	4601	BERGEN	G
5141	FYLLINGSDALEN	4601	BERGEN	G
5142	FYLLINGSDALEN	4601	BERGEN	G
5143	FYLLINGSDALEN	4601	BERGEN	G
5144	FYLLINGSDALEN	4601	BERGEN	G
5145	FYLLINGSDALEN	4601	BERGEN	G
5146	FYLLINGSDALEN	4601	BERGEN	G
5147	FYLLINGSDALEN	4601	BERGEN	G
5148	FYLLINGSDALEN	4601	BERGEN	G
5151	STRAUMSGREND	4601	BERGEN	G
5152	BØNES	4601	BERGEN	G
5153	BØNES	4601	BERGEN	G
5154	BØNES	4601	BERGEN	G
5155	BØNES	4601	BERGEN	G
5160	LAKSEVÅG	4601	BERGEN	G
5161	LAKSEVÅG	4601	BERGEN	G
5162	LAKSEVÅG	4601	BERGEN	G
5163	LAKSEVÅG	4601	BERGEN	G
5164	LAKSEVÅG	4601	BERGEN	G
5165	LAKSEVÅG	4601	BERGEN	G
5170	BJØRNDALSTRÆ	4601	BERGEN	G
5171	LODDEFJORD	4601	BERGEN	G
5172	LODDEFJORD	4601	BERGEN	G
5173	LODDEFJORD	4601	BERGEN	G
5174	MATHOPEN	4601	BERGEN	G
5176	LODDEFJORD	4601	BERGEN	G
5177	BJØRØYHAMN	4626	ØYGARDEN	G
5178	LODDEFJORD	4601	BERGEN	G
5179	GODVIK	4601	BERGEN	G
5183	OLSVIK	4601	BERGEN	G
5184	OLSVIK	4601	BERGEN	G
5200	OS	4624	BJØRNAFJORDEN	G
5201	OS	4624	BJØRNAFJORDEN	P
5202	OS	4624	BJØRNAFJORDEN	P
5203	OS	4624	BJØRNAFJORDEN	P
5206	OS	4624	BJØRNAFJORDEN	P
5207	SØFTELAND	4624	BJØRNAFJORDEN	P
5208	OS	4624	BJØRNAFJORDEN	G
5209	OS	4624	BJØRNAFJORDEN	G
5210	OS	4624	BJØRNAFJORDEN	G
5211	OS	4624	BJØRNAFJORDEN	G
5212	SØFTELAND	4624	BJØRNAFJORDEN	G
5213	LEPSØY	4624	BJØRNAFJORDEN	P
5215	LYSEKLOSTER	4624	BJØRNAFJORDEN	G
5216	LEPSØY	4624	BJØRNAFJORDEN	G
5217	HAGAVIK	4624	BJØRNAFJORDEN	G
5218	NORDSTRØNO	4624	BJØRNAFJORDEN	G
5221	NESTTUN	4601	BERGEN	G
5222	NESTTUN	4601	BERGEN	G
5223	NESTTUN	4601	BERGEN	G
5224	NESTTUN	4601	BERGEN	G
5225	NESTTUN	4601	BERGEN	G
5226	NESTTUN	4601	BERGEN	G
5227	NESTTUN	4601	BERGEN	G
5228	NESTTUN	4601	BERGEN	G
5229	KALANDSEIDET	4601	BERGEN	G
5230	PARADIS	4601	BERGEN	G
5231	PARADIS	4601	BERGEN	G
5232	PARADIS	4601	BERGEN	G
5235	RÅDAL	4601	BERGEN	G
5236	RÅDAL	4601	BERGEN	G
5237	RÅDAL	4601	BERGEN	G
5238	RÅDAL	4601	BERGEN	G
5239	RÅDAL	4601	BERGEN	G
5243	FANA	4601	BERGEN	G
5244	FANA	4601	BERGEN	G
5251	SØREIDGREND	4601	BERGEN	G
5252	SØREIDGREND	4601	BERGEN	G
5253	SANDSLI	4601	BERGEN	G
5254	SANDSLI	4601	BERGEN	G
5257	KOKSTAD	4601	BERGEN	G
5258	BLOMSTERDALEN	4601	BERGEN	G
5259	HJELLESTAD	4601	BERGEN	G
5260	INDRE ARNA	4601	BERGEN	G
5261	INDRE ARNA	4601	BERGEN	G
5262	ARNATVEIT	4601	BERGEN	G
5263	TRENGEREID	4601	BERGEN	G
5264	GARNES	4601	BERGEN	G
5265	YTRE ARNA	4601	BERGEN	G
5267	ESPELAND	4601	BERGEN	G
5268	HAUKELAND	4601	BERGEN	G
5281	VALESTRANDSFOSSEN	4630	OSTERØY	G
5282	LONEVÅG	4630	OSTERØY	G
5283	FOTLANDSVÅG	4630	OSTERØY	G
5284	TYSSEBOTNEN	4630	OSTERØY	G
5285	BRUVIK	4630	OSTERØY	G
5286	HAUS	4630	OSTERØY	G
5291	VALESTRANDSFOSSEN	4630	OSTERØY	P
5293	LONEVÅG	4630	OSTERØY	P
5299	HAUS	4630	OSTERØY	P
5300	KLEPPESTØ	4627	ASKØY	G
5301	KLEPPESTØ	4627	ASKØY	G
5302	STRUSSHAMN	4627	ASKØY	G
5303	FOLLESE	4627	ASKØY	G
5304	HETLEVIK	4627	ASKØY	G
5305	FLORVÅG	4627	ASKØY	G
5306	ERDAL	4627	ASKØY	G
5307	ASK	4627	ASKØY	G
5308	KLEPPESTØ	4627	ASKØY	G
5309	KLEPPESTØ	4627	ASKØY	G
5310	HAUGLANDSHELLA	4627	ASKØY	G
5311	KJERRGARDEN	4627	ASKØY	P
5314	KJERRGARDEN	4627	ASKØY	G
5315	HERDLA	4627	ASKØY	G
5318	STRUSSHAMN	4627	ASKØY	P
5319	KLEPPESTØ	4627	ASKØY	P
5321	KLEPPESTØ	4627	ASKØY	P
5322	KLEPPESTØ	4627	ASKØY	P
5323	KLEPPESTØ	4627	ASKØY	P
5325	FOLLESE	4627	ASKØY	P
5326	ASK	4627	ASKØY	P
5327	HAUGLANDSHELLA	4627	ASKØY	P
5329	FLORVÅG	4627	ASKØY	P
5331	RONG	4626	ØYGARDEN	P
5333	TJELDSTØ	4626	ØYGARDEN	P
5334	HELLESØY	4626	ØYGARDEN	G
5335	HERNAR	4626	ØYGARDEN	G
5336	TJELDSTØ	4626	ØYGARDEN	G
5337	RONG	4626	ØYGARDEN	G
5341	STRAUME	4626	ØYGARDEN	P
5342	STRAUME	4626	ØYGARDEN	P
5343	STRAUME	4626	ØYGARDEN	P
5345	KNARREVIK	4626	ØYGARDEN	P
5346	ÅGOTNES	4626	ØYGARDEN	P
5347	ÅGOTNES	4626	ØYGARDEN	G
5350	BRATTHOLMEN	4626	ØYGARDEN	G
5353	STRAUME	4626	ØYGARDEN	G
5354	STRAUME	4626	ØYGARDEN	G
5355	KNARREVIK	4626	ØYGARDEN	G
5357	FJELL	4626	ØYGARDEN	G
5358	FJELL	4626	ØYGARDEN	P
5360	KOLLTVEIT	4626	ØYGARDEN	G
5363	ÅGOTNES	4626	ØYGARDEN	G
5365	TURØY	4626	ØYGARDEN	G
5366	MISJE	4626	ØYGARDEN	G
5371	SKOGSVÅG	4626	ØYGARDEN	P
5374	STEINSLAND	4626	ØYGARDEN	P
5378	KLOKKARVIK	4626	ØYGARDEN	G
5379	STEINSLAND	4626	ØYGARDEN	G
5380	TELAVÅG	4626	ØYGARDEN	G
5381	GLESVÆR	4626	ØYGARDEN	G
5382	SKOGSVÅG	4626	ØYGARDEN	G
5384	TORANGSVÅG	4625	AUSTEVOLL	G
5385	BAKKASUND	4625	AUSTEVOLL	G
5387	MØKSTER	4625	AUSTEVOLL	B
5388	LITLAKALSØY	4625	AUSTEVOLL	G
5392	STOREBØ	4625	AUSTEVOLL	G
5393	STOREBØ	4625	AUSTEVOLL	P
5394	KOLBEINSVIK	4625	AUSTEVOLL	G
5396	VESTRE VINNESVÅG	4625	AUSTEVOLL	G
5397	BEKKJARVIK	4625	AUSTEVOLL	G
5398	STOLMEN	4625	AUSTEVOLL	G
5399	BEKKJARVIK	4625	AUSTEVOLL	P
5401	STORD	4614	STORD	P
5402	STORD	4614	STORD	P
5403	STORD	4614	STORD	P
5404	STORD	4614	STORD	P
5406	STORD	4614	STORD	P
5407	STORD	4614	STORD	P
5408	SAGVÅG	4614	STORD	P
5409	STORD	4614	STORD	P
5410	SAGVÅG	4614	STORD	G
5411	STORD	4614	STORD	G
5412	STORD	4614	STORD	G
5413	HUGLO	4614	STORD	G
5414	STORD	4614	STORD	G
5415	STORD	4614	STORD	G
5416	STORD	4614	STORD	G
5417	STORD	4614	STORD	G
5418	FITJAR	4615	FITJAR	P
5419	FITJAR	4615	FITJAR	G
5420	RUBBESTADNESET	4613	BØMLO	G
5423	BRANDASUND	4613	BØMLO	G
5427	URANGSVÅG	4613	BØMLO	G
5428	FOLDRØYHAMN	4613	BØMLO	G
5430	BREMNES	4613	BØMLO	G
5437	FINNÅS	4613	BØMLO	G
5440	MOSTERHAMN	4613	BØMLO	G
5443	BØMLO	4613	BØMLO	G
5444	ESPEVÆR	4613	BØMLO	B
5445	BREMNES	4613	BØMLO	P
5447	MOSTERHAMN	4613	BØMLO	P
5449	BØMLO	4613	BØMLO	P
5450	SUNDE I SUNNHORDLAND	4617	KVINNHERAD	G
5451	VALEN	4617	KVINNHERAD	G
5452	SANDVOLL	4617	KVINNHERAD	G
5453	UTÅKER	4617	KVINNHERAD	G
5454	SÆBØVIK	4617	KVINNHERAD	G
5455	HALSNØY KLOSTER	4617	KVINNHERAD	G
5457	HØYLANDSBYGD	4617	KVINNHERAD	G
5458	ARNAVIK	4617	KVINNHERAD	G
5459	FJELBERG	4617	KVINNHERAD	G
5460	HUSNES	4617	KVINNHERAD	G
5462	HERØYSUNDET	4617	KVINNHERAD	G
5463	USKEDALEN	4617	KVINNHERAD	G
5464	DIMMELSVIK	4617	KVINNHERAD	G
5465	USKEDALEN	4617	KVINNHERAD	P
5470	ROSENDAL	4617	KVINNHERAD	G
5472	SEIMSFOSS	4617	KVINNHERAD	G
5473	SNILSTVEITØY	4617	KVINNHERAD	G
5474	LØFALLSTRAND	4617	KVINNHERAD	G
5475	ÆNES	4617	KVINNHERAD	G
5476	MAURANGER	4617	KVINNHERAD	G
5480	HUSNES	4617	KVINNHERAD	P
5484	SÆBØVIK	4617	KVINNHERAD	P
5486	ROSENDAL	4617	KVINNHERAD	P
5498	MATRE	4617	KVINNHERAD	G
5499	ÅKRA	4617	KVINNHERAD	G
5501	HAUGESUND	1106	HAUGESUND	P
5502	HAUGESUND	1106	HAUGESUND	P
5503	HAUGESUND	1106	HAUGESUND	P
5504	HAUGESUND	1106	HAUGESUND	P
5505	HAUGESUND	1106	HAUGESUND	P
5506	HAUGESUND	1106	HAUGESUND	P
5507	HAUGESUND	1106	HAUGESUND	P
5508	KARMSUND	1149	KARMØY	P
5509	HAUGESUND	1106	HAUGESUND	P
5511	HAUGESUND	1106	HAUGESUND	P
5512	HAUGESUND	1106	HAUGESUND	P
5514	HAUGESUND	1106	HAUGESUND	G
5515	HAUGESUND	1106	HAUGESUND	G
5516	HAUGESUND	1106	HAUGESUND	G
5517	HAUGESUND	1106	HAUGESUND	G
5518	HAUGESUND	1106	HAUGESUND	G
5519	HAUGESUND	1106	HAUGESUND	G
5521	HAUGESUND	1106	HAUGESUND	G
5522	HAUGESUND	1106	HAUGESUND	G
5523	HAUGESUND	1106	HAUGESUND	G
5525	HAUGESUND	1106	HAUGESUND	G
5527	HAUGESUND	1106	HAUGESUND	G
5528	HAUGESUND	1106	HAUGESUND	G
5529	HAUGESUND	1106	HAUGESUND	G
5531	HAUGESUND	1106	HAUGESUND	G
5532	HAUGESUND	1106	HAUGESUND	G
5533	HAUGESUND	1106	HAUGESUND	G
5534	HAUGESUND	1106	HAUGESUND	G
5535	HAUGESUND	1106	HAUGESUND	G
5536	HAUGESUND	1106	HAUGESUND	G
5537	HAUGESUND	1106	HAUGESUND	G
5538	HAUGESUND	1106	HAUGESUND	G
5541	KOLNES	1149	KARMØY	G
5542	KARMSUND	1149	KARMØY	G
5544	VORMEDAL	1149	KARMØY	P
5545	VORMEDAL	1149	KARMØY	G
5546	RØYKSUND	1149	KARMØY	G
5547	UTSIRA	1151	UTSIRA	B
5548	FEØY	1149	KARMØY	B
5549	RØVÆR	1106	HAUGESUND	B
5550	SVEIO	4612	SVEIO	G
5551	AUKLANDSHAMN	4612	SVEIO	G
5554	VALEVÅG	4612	SVEIO	G
5555	FØRDE I HORDALAND	4612	SVEIO	G
5556	FØRDE I HORDALAND	4612	SVEIO	P
5559	SVEIO	4612	SVEIO	P
5560	NEDSTRAND	1146	TYSVÆR	G
5561	BOKN	1145	BOKN	G
5562	NEDSTRAND	1146	TYSVÆR	P
5563	FØRRESFJORDEN	1146	TYSVÆR	G
5565	TYSVÆRVÅG	1146	TYSVÆR	G
5566	HERVIK	1146	TYSVÆR	G
5567	SKJOLDASTRAUMEN	1146	TYSVÆR	G
5568	VIKEBYGD	1160	VINDAFJORD	G
5569	BOKN	1145	BOKN	P
5570	AKSDAL	1146	TYSVÆR	G
5574	SKJOLD	1160	VINDAFJORD	G
5575	AKSDAL	1146	TYSVÆR	P
5576	ØVRE VATS	1160	VINDAFJORD	G
5578	NEDRE VATS	1160	VINDAFJORD	G
5580	ØLEN	1160	VINDAFJORD	G
5582	ØLENSVÅG	1160	VINDAFJORD	G
5583	VIKEDAL	1160	VINDAFJORD	G
5584	BJOA	1160	VINDAFJORD	G
5585	SANDEID	1160	VINDAFJORD	G
5586	VIKEDAL	1160	VINDAFJORD	P
5588	ØLEN	1160	VINDAFJORD	P
5589	SANDEID	1160	VINDAFJORD	P
5590	ETNE	4611	ETNE	G
5591	ETNE	4611	ETNE	P
5593	SKÅNEVIK	4611	ETNE	G
5594	SKÅNEVIK	4611	ETNE	P
5595	FØRRESFJORDEN	1146	TYSVÆR	P
5596	MARKHUS	4611	ETNE	G
5598	FJÆRA	4611	ETNE	G
5600	NORHEIMSUND	4622	KVAM	G
5601	NORHEIMSUND	4622	KVAM	P
5602	NORHEIMSUND	4622	KVAM	P
5604	ØYSTESE	4622	KVAM	P
5605	ÅLVIK	4622	KVAM	P
5610	ØYSTESE	4622	KVAM	G
5612	STEINSTØ	4622	KVAM	G
5614	ÅLVIK	4622	KVAM	G
5620	TØRVIKBYGD	4622	KVAM	G
5626	KYSNESSTRAND	4618	ULLENSVANG	G
5627	JONDAL	4618	ULLENSVANG	G
5628	HERAND	4618	ULLENSVANG	G
5629	JONDAL	4618	ULLENSVANG	P
5630	STRANDEBARM	4622	KVAM	G
5631	STRANDEBARM	4622	KVAM	P
5632	OMASTRAND	4622	KVAM	G
5633	OMASTRAND	4622	KVAM	P
5635	HATLESTRAND	4617	KVINNHERAD	G
5636	VARALDSØY	4617	KVINNHERAD	G
5637	ØLVE	4617	KVINNHERAD	G
5640	EIKELANDSOSEN	4624	BJØRNAFJORDEN	G
5641	FUSA	4624	BJØRNAFJORDEN	G
5642	HOLMEFJORD	4624	BJØRNAFJORDEN	G
5643	STRANDVIK	4624	BJØRNAFJORDEN	G
5644	SÆVAREID	4624	BJØRNAFJORDEN	P
5645	SÆVAREID	4624	BJØRNAFJORDEN	G
5646	NORDTVEITGREND	4624	BJØRNAFJORDEN	G
5647	BALDERSHEIM	4624	BJØRNAFJORDEN	G
5648	FUSA	4624	BJØRNAFJORDEN	P
5649	EIKELANDSOSEN	4624	BJØRNAFJORDEN	P
5650	TYSSE	4623	SAMNANGER	G
5651	TYSSE	4623	SAMNANGER	P
5652	ÅRLAND	4623	SAMNANGER	G
5653	ÅRLAND	4623	SAMNANGER	P
5680	TYSNES	4616	TYSNES	G
5683	REKSTEREN	4616	TYSNES	G
5685	UGGDAL	4616	TYSNES	G
5687	FLATRÅKER	4616	TYSNES	G
5690	LUNDEGREND	4616	TYSNES	G
5693	ÅRBAKKA	4616	TYSNES	G
5694	ONARHEIM	4616	TYSNES	G
5695	UGGDAL	4616	TYSNES	P
5696	TYSNES	4616	TYSNES	P
5700	VOSS	4621	VOSS	G
5701	VOSS	4621	VOSS	P
5702	VOSS	4621	VOSS	P
5703	VOSS	4621	VOSS	P
5704	VOSS	4621	VOSS	G
5705	VOSS	4621	VOSS	G
5706	VOSS	4621	VOSS	G
5707	EVANGER	4621	VOSS	G
5708	VOSS	4621	VOSS	G
5709	VOSS	4621	VOSS	G
5710	SKULESTADMO	4621	VOSS	G
5711	SKULESTADMO	4621	VOSS	P
5712	VOSSESTRAND	4621	VOSS	P
5713	VOSSESTRAND	4621	VOSS	G
5714	VOSS	4621	VOSS	P
5715	STALHEIM	4621	VOSS	G
5718	MYRDAL	4641	AURLAND	G
5719	FINSE	4620	ULVIK	B
5720	STANGHELLE	4628	VAKSDAL	P
5721	DALEKVAM	4628	VAKSDAL	P
5722	DALEKVAM	4628	VAKSDAL	G
5723	BOLSTADØYRI	4621	VOSS	G
5724	STANGHELLE	4628	VAKSDAL	G
5725	VAKSDAL	4628	VAKSDAL	G
5726	VAKSDAL	4628	VAKSDAL	P
5727	STAMNES	4628	VAKSDAL	G
5728	EIDSLANDET	4628	VAKSDAL	G
5729	MODALEN	4629	MODALEN	G
5730	ULVIK	4620	ULVIK	G
5731	ULVIK	4620	ULVIK	P
5732	MODALEN	4629	MODALEN	P
5733	GRANVIN	4621	VOSS	P
5734	VALLAVIK	4621	VOSS	G
5736	GRANVIN	4621	VOSS	G
5741	AURLAND	4641	AURLAND	P
5742	FLÅM	4641	AURLAND	P
5743	FLÅM	4641	AURLAND	G
5745	AURLAND	4641	AURLAND	G
5746	UNDREDAL	4641	AURLAND	B
5747	GUDVANGEN	4641	AURLAND	G
5749	GUDVANGEN	4641	AURLAND	P
5750	ODDA	4618	ULLENSVANG	G
5751	ODDA	4618	ULLENSVANG	P
5752	ODDA	4618	ULLENSVANG	P
5760	RØLDAL	4618	ULLENSVANG	G
5763	SKARE	4618	ULLENSVANG	G
5770	TYSSEDAL	4618	ULLENSVANG	G
5773	HOVLAND	4618	ULLENSVANG	G
5775	NÅ	4618	ULLENSVANG	P
5776	NÅ	4618	ULLENSVANG	G
5777	GRIMO	4618	ULLENSVANG	G
5778	UTNE	4618	ULLENSVANG	G
5779	UTNE	4618	ULLENSVANG	P
5780	KINSARVIK	4618	ULLENSVANG	G
5781	LOFTHUS	4618	ULLENSVANG	G
5782	KINSARVIK	4618	ULLENSVANG	P
5783	EIDFJORD	4619	EIDFJORD	G
5784	ØVRE EIDFJORD	4619	EIDFJORD	G
5785	VØRINGSFOSS	4619	EIDFJORD	G
5786	EIDFJORD	4619	EIDFJORD	P
5787	LOFTHUS	4618	ULLENSVANG	P
5788	KINSARVIK	4618	ULLENSVANG	P
5802	BERGEN	4601	BERGEN	P
5803	BERGEN	4601	BERGEN	P
5804	BERGEN	4601	BERGEN	P
5805	BERGEN	4601	BERGEN	P
5806	BERGEN	4601	BERGEN	P
5807	BERGEN	4601	BERGEN	P
5808	BERGEN	4601	BERGEN	P
5809	BERGEN	4601	BERGEN	P
5810	BERGEN	4601	BERGEN	P
5811	BERGEN	4601	BERGEN	P
5812	BERGEN	4601	BERGEN	P
5813	BERGEN	4601	BERGEN	P
5814	BERGEN	4601	BERGEN	P
5815	BERGEN	4601	BERGEN	P
5816	BERGEN	4601	BERGEN	P
5817	BERGEN	4601	BERGEN	P
5818	BERGEN	4601	BERGEN	P
5819	BERGEN	4601	BERGEN	P
5820	BERGEN	4601	BERGEN	P
5821	BERGEN	4601	BERGEN	P
5822	BERGEN	4601	BERGEN	P
5823	BERGEN	4601	BERGEN	P
5824	BERGEN	4601	BERGEN	P
5825	BERGEN	4601	BERGEN	P
5826	BERGEN	4601	BERGEN	P
5827	BERGEN	4601	BERGEN	P
5829	BERGEN	4601	BERGEN	P
5830	BERGEN	4601	BERGEN	P
5831	BERGEN	4601	BERGEN	P
5832	BERGEN	4601	BERGEN	P
5833	BERGEN	4601	BERGEN	P
5834	BERGEN	4601	BERGEN	P
5835	BERGEN	4601	BERGEN	P
5836	BERGEN	4601	BERGEN	P
5837	BERGEN	4601	BERGEN	P
5838	BERGEN	4601	BERGEN	P
5841	BERGEN	4601	BERGEN	P
5843	BERGEN	4601	BERGEN	P
5844	BERGEN	4601	BERGEN	P
5845	BERGEN	4601	BERGEN	P
5847	BERGEN	4601	BERGEN	P
5848	BERGEN	4601	BERGEN	P
5849	BERGEN	4601	BERGEN	P
5851	BERGEN	4601	BERGEN	P
5852	BERGEN	4601	BERGEN	P
5853	BERGEN	4601	BERGEN	P
5854	BERGEN	4601	BERGEN	P
5855	BERGEN	4601	BERGEN	P
5857	BERGEN	4601	BERGEN	P
5858	BERGEN	4601	BERGEN	P
5859	BERGEN	4601	BERGEN	P
5861	BERGEN	4601	BERGEN	P
5862	BERGEN	4601	BERGEN	P
5863	BERGEN	4601	BERGEN	P
5864	BERGEN	4601	BERGEN	P
5865	BERGEN	4601	BERGEN	P
5866	BERGEN	4601	BERGEN	P
5867	BERGEN	4601	BERGEN	P
5868	BERGEN	4601	BERGEN	P
5872	BERGEN	4601	BERGEN	P
5873	BERGEN	4601	BERGEN	P
5876	BERGEN	4601	BERGEN	P
5877	BERGEN	4601	BERGEN	P
5878	BERGEN	4601	BERGEN	P
5879	BERGEN	4601	BERGEN	P
5881	BERGEN	4601	BERGEN	P
5884	BERGEN	4601	BERGEN	P
5886	BERGEN	4601	BERGEN	P
5887	BERGEN	4601	BERGEN	P
5888	BERGEN	4601	BERGEN	P
5889	BERGEN	4601	BERGEN	P
5892	BERGEN	4601	BERGEN	P
5893	BERGEN	4601	BERGEN	P
5895	BERGEN	4601	BERGEN	P
5896	BERGEN	4601	BERGEN	P
5899	BERGEN	4601	BERGEN	P
5902	ISDALSTØ	4631	ALVER	P
5903	ISDALSTØ	4631	ALVER	P
5904	ISDALSTØ	4631	ALVER	P
5906	FREKHAUG	4631	ALVER	P
5907	ALVERSUND	4631	ALVER	P
5908	ISDALSTØ	4631	ALVER	P
5911	ALVERSUND	4631	ALVER	G
5912	SEIM	4631	ALVER	G
5913	EIKANGERVÅG	4631	ALVER	G
5914	ISDALSTØ	4631	ALVER	G
5915	HJELMÅS	4631	ALVER	G
5916	ISDALSTØ	4631	ALVER	G
5917	ROSSLAND	4631	ALVER	G
5918	FREKHAUG	4631	ALVER	G
5919	FREKHAUG	4631	ALVER	G
5931	MANGER	4631	ALVER	P
5935	BØVÅGEN	4631	ALVER	P
5936	MANGER	4631	ALVER	G
5937	BØVÅGEN	4631	ALVER	G
5938	SÆBØVÅGEN	4631	ALVER	G
5939	SLETTA	4631	ALVER	G
5941	AUSTRHEIM	4632	AUSTRHEIM	P
5943	AUSTRHEIM	4632	AUSTRHEIM	G
5947	FEDJE	4633	FEDJE	G
5948	FEDJE	4633	FEDJE	P
5951	LINDÅS	4631	ALVER	P
5952	FONNES	4632	AUSTRHEIM	P
5953	FONNES	4632	AUSTRHEIM	G
5954	MONGSTAD	4631	ALVER	G
5955	LINDÅS	4631	ALVER	G
5956	HUNDVIN	4631	ALVER	G
5957	MYKING	4631	ALVER	G
5960	DALSØYRA	4635	GULEN	G
5961	BREKKE	4635	GULEN	G
5962	BJORDAL	4638	HØYANGER	G
5963	DALSØYRA	4635	GULEN	P
5964	BREKKE	4635	GULEN	P
5965	BJORDAL	4638	HØYANGER	P
5966	EIVINDVIK	4635	GULEN	G
5967	EIVINDVIK	4635	GULEN	P
5970	BYRKNESØY	4635	GULEN	G
5977	ÅNNELAND	4635	GULEN	G
5978	MJØMNA	4635	GULEN	G
5979	BYRKNESØY	4635	GULEN	P
5981	MASFJORDNES	4634	MASFJORDEN	G
5983	HAUGSVÆR	4634	MASFJORDEN	G
5984	MATREDAL	4634	MASFJORDEN	G
5985	HAUGSVÆR	4634	MASFJORDEN	P
5986	HOSTELAND	4634	MASFJORDEN	G
5987	HOSTELAND	4634	MASFJORDEN	P
5991	OSTEREIDET	4631	ALVER	P
5993	OSTEREIDET	4631	ALVER	G
5994	VIKANES	4631	ALVER	G
6001	ÅLESUND	1508	ÅLESUND	P
6002	ÅLESUND	1508	ÅLESUND	G
6003	ÅLESUND	1508	ÅLESUND	G
6004	ÅLESUND	1508	ÅLESUND	G
6005	ÅLESUND	1508	ÅLESUND	G
6006	ÅLESUND	1508	ÅLESUND	G
6007	ÅLESUND	1508	ÅLESUND	G
6008	ÅLESUND	1508	ÅLESUND	G
6009	ÅLESUND	1508	ÅLESUND	G
6010	ÅLESUND	1508	ÅLESUND	G
6011	ÅLESUND	1508	ÅLESUND	G
6012	ÅLESUND	1508	ÅLESUND	G
6013	ÅLESUND	1508	ÅLESUND	G
6014	ÅLESUND	1508	ÅLESUND	G
6015	ÅLESUND	1508	ÅLESUND	G
6016	ÅLESUND	1508	ÅLESUND	G
6017	ÅLESUND	1508	ÅLESUND	G
6018	ÅLESUND	1508	ÅLESUND	G
6019	ÅLESUND	1508	ÅLESUND	G
6020	ÅLESUND	1508	ÅLESUND	G
6021	ÅLESUND	1508	ÅLESUND	P
6022	ÅLESUND	1508	ÅLESUND	P
6023	ÅLESUND	1508	ÅLESUND	P
6024	ÅLESUND	1508	ÅLESUND	P
6025	ÅLESUND	1508	ÅLESUND	P
6026	ÅLESUND	1508	ÅLESUND	P
6028	ÅLESUND	1508	ÅLESUND	P
6030	LANGEVÅG	1531	SULA	G
6034	EIDSNES	1531	SULA	P
6035	FISKARSTRAND	1531	SULA	G
6036	MAUSEIDVÅG	1531	SULA	G
6037	EIDSNES	1531	SULA	G
6039	LANGEVÅG	1531	SULA	P
6040	VIGRA	1532	GISKE	G
6044	ÅLESUND	1508	ÅLESUND	P
6045	ÅLESUND	1508	ÅLESUND	P
6046	ÅLESUND	1508	ÅLESUND	P
6047	ÅLESUND	1508	ÅLESUND	P
6048	ÅLESUND	1508	ÅLESUND	P
6050	VALDERØYA	1532	GISKE	G
6052	GISKE	1532	GISKE	G
6054	GODØYA	1532	GISKE	P
6055	GODØYA	1532	GISKE	G
6057	ELLINGSØY	1508	ÅLESUND	G
6058	VALDERØYA	1532	GISKE	P
6059	VIGRA	1532	GISKE	P
6060	HAREID	1517	HAREID	G
6062	BRANDAL	1517	HAREID	G
6063	HJØRUNGAVÅG	1517	HAREID	G
6064	HADDAL	1516	ULSTEIN	G
6065	ULSTEINVIK	1516	ULSTEIN	G
6067	ULSTEINVIK	1516	ULSTEIN	P
6068	EIKSUND	1516	ULSTEIN	G
6069	HAREID	1517	HAREID	P
6070	TJØRVÅG	1515	HERØY (MØRE OG ROMSDAL)	G
6075	MOLTUSTRANDA	1515	HERØY (MØRE OG ROMSDAL)	P
6076	MOLTUSTRANDA	1515	HERØY (MØRE OG ROMSDAL)	G
6078	GJERDSVIKA	1514	SANDE	P
6080	GURSKØY	1515	HERØY (MØRE OG ROMSDAL)	G
6082	GURSKEN	1514	SANDE	G
6083	GJERDSVIKA	1514	SANDE	G
6084	LARSNES	1514	SANDE	G
6085	LARSNES	1514	SANDE	P
6086	KVAMSØY	1514	SANDE	P
6087	KVAMSØY	1514	SANDE	G
6088	SANDSHAMN	1514	SANDE	P
6089	SANDSHAMN	1514	SANDE	G
6090	FOSNAVÅG	1515	HERØY (MØRE OG ROMSDAL)	G
6091	FOSNAVÅG	1515	HERØY (MØRE OG ROMSDAL)	G
6092	FOSNAVÅG	1515	HERØY (MØRE OG ROMSDAL)	G
6094	LEINØY	1515	HERØY (MØRE OG ROMSDAL)	G
6095	BØLANDET	1515	HERØY (MØRE OG ROMSDAL)	G
6096	RUNDE	1515	HERØY (MØRE OG ROMSDAL)	G
6098	NERLANDSØY	1515	HERØY (MØRE OG ROMSDAL)	G
6099	FOSNAVÅG	1515	HERØY (MØRE OG ROMSDAL)	P
6100	VOLDA	1577	VOLDA	G
6101	VOLDA	1577	VOLDA	P
6102	VOLDA	1577	VOLDA	G
6103	VOLDA	1577	VOLDA	G
6104	VOLDA	1577	VOLDA	G
6105	VOLDA	1577	VOLDA	G
6106	VOLDA	1577	VOLDA	G
6110	AUSTEFJORDEN	1577	VOLDA	G
6120	FOLKESTAD	1577	VOLDA	G
6121	FOLKESTAD	1577	VOLDA	P
6133	LAUVSTAD	1577	VOLDA	G
6138	SYVDE	1511	VANYLVEN	P
6139	FISKÅ	1511	VANYLVEN	P
6140	SYVDE	1511	VANYLVEN	G
6141	ROVDE	1511	VANYLVEN	G
6142	EIDSÅ	1511	VANYLVEN	G
6143	FISKÅ	1511	VANYLVEN	G
6144	SYLTE	1511	VANYLVEN	G
6146	ÅHEIM	1511	VANYLVEN	G
6147	ÅHEIM	1511	VANYLVEN	P
6149	ÅRAM	1511	VANYLVEN	G
6150	ØRSTA	1520	ØRSTA	G
6151	ØRSTA	1520	ØRSTA	P
6152	ØRSTA	1520	ØRSTA	G
6153	ØRSTA	1520	ØRSTA	G
6154	ØRSTA	1520	ØRSTA	G
6155	ØRSTA	1520	ØRSTA	G
6156	ØRSTA	1520	ØRSTA	G
6160	HOVDEBYGDA	1520	ØRSTA	G
6161	HOVDEBYGDA	1520	ØRSTA	P
6165	SÆBØ	1520	ØRSTA	G
6166	SÆBØ	1520	ØRSTA	P
6170	VARTDAL	1520	ØRSTA	G
6171	VARTDAL	1520	ØRSTA	P
6174	BARSTADVIK	1520	ØRSTA	G
6183	TRANDAL	1520	ØRSTA	G
6184	STORESTANDAL	1520	ØRSTA	G
6190	BJØRKE	1577	VOLDA	G
6196	NORANGSFJORDEN	1520	ØRSTA	G
6200	STRANDA	1525	STRANDA	G
6201	STRANDA	1525	STRANDA	P
6210	VALLDAL	1578	FJORD	G
6211	VALLDAL	1578	FJORD	P
6212	LIABYGDA	1525	STRANDA	G
6213	TAFJORD	1578	FJORD	G
6214	NORDDAL	1578	FJORD	G
6215	EIDSDAL	1578	FJORD	G
6216	GEIRANGER	1525	STRANDA	G
6217	GEIRANGER	1525	STRANDA	P
6218	HELLESYLT	1525	STRANDA	G
6219	HELLESYLT	1525	STRANDA	P
6220	STRAUMGJERDE	1528	SYKKYLVEN	G
6222	IKORNNES	1528	SYKKYLVEN	G
6223	IKORNNES	1528	SYKKYLVEN	P
6224	HUNDEIDVIK	1528	SYKKYLVEN	G
6230	SYKKYLVEN	1528	SYKKYLVEN	G
6238	STRAUMGJERDE	1528	SYKKYLVEN	P
6239	SYKKYLVEN	1528	SYKKYLVEN	P
6240	ØRSKOG	1508	ÅLESUND	G
6249	ØRSKOG	1508	ÅLESUND	P
6250	STORDAL	1578	FJORD	G
6255	EIDSDAL	1578	FJORD	P
6259	STORDAL	1578	FJORD	P
6260	SKODJE	1508	ÅLESUND	G
6263	SKODJE	1508	ÅLESUND	P
6264	TENNFJORD	1580	HARAM	G
6265	VATNE	1580	HARAM	G
6270	BRATTVÅG	1580	HARAM	G
6272	HILDRE	1580	HARAM	G
6280	SØVIK	1580	HARAM	G
6281	SØVIK	1580	HARAM	P
6282	BRATTVÅG	1580	HARAM	P
6283	VATNE	1580	HARAM	P
6285	STOREKALVØY	1580	HARAM	G
6286	ORTEN	1547	AUKRA	B
6287	HARØY	1508	ÅLESUND	P
6290	HARAMSØY	1580	HARAM	G
6291	HARAMSØY	1580	HARAM	P
6292	KJERSTAD	1580	HARAM	G
6293	LONGVA	1580	HARAM	G
6294	FJØRTOFT	1580	HARAM	G
6295	MYKLEBUST	1508	ÅLESUND	G
6296	HARØY	1508	ÅLESUND	G
6297	SANDØY	1508	ÅLESUND	B
6298	ONA	1508	ÅLESUND	G
6300	ÅNDALSNES	1539	RAUMA	G
6301	ÅNDALSNES	1539	RAUMA	P
6310	VEBLUNGSNES	1539	RAUMA	G
6315	INNFJORDEN	1539	RAUMA	G
6320	ISFJORDEN	1539	RAUMA	G
6330	VERMA	1539	RAUMA	G
6331	VERMA	1539	RAUMA	P
6339	ISFJORDEN	1539	RAUMA	P
6350	EIDSBYGDA	1539	RAUMA	G
6360	ÅFARNES	1539	RAUMA	G
6361	ÅFARNES	1539	RAUMA	P
6363	MITTET	1539	RAUMA	G
6364	VISTDAL	1506	MOLDE	G
6365	VISTDAL	1506	MOLDE	P
6385	MÅNDALEN	1539	RAUMA	P
6386	MÅNDALEN	1539	RAUMA	G
6387	VÅGSTRANDA	1535	VESTNES	G
6388	VÅGSTRANDA	1535	VESTNES	P
6389	FIKSDAL	1535	VESTNES	P
6390	VESTNES	1535	VESTNES	G
6391	TRESFJORD	1535	VESTNES	G
6392	VIKEBUKT	1535	VESTNES	G
6393	TOMREFJORD	1535	VESTNES	G
6394	FIKSDAL	1535	VESTNES	G
6395	REKDAL	1535	VESTNES	G
6396	VIKEBUKT	1535	VESTNES	P
6397	TRESFJORD	1535	VESTNES	P
6398	TOMREFJORD	1535	VESTNES	P
6399	VESTNES	1535	VESTNES	P
6401	MOLDE	1506	MOLDE	P
6402	MOLDE	1506	MOLDE	P
6403	MOLDE	1506	MOLDE	P
6404	MOLDE	1506	MOLDE	P
6405	MOLDE	1506	MOLDE	P
6407	MOLDE	1506	MOLDE	P
6408	AUREOSEN	1579	HUSTADVIKA	G
6409	MOLDE	1547	AUKRA	G
6410	MOLDE	1506	MOLDE	G
6411	MOLDE	1506	MOLDE	G
6412	MOLDE	1506	MOLDE	G
6413	MOLDE	1506	MOLDE	G
6414	MOLDE	1506	MOLDE	G
6415	MOLDE	1506	MOLDE	G
6416	MOLDE	1506	MOLDE	G
6418	SEKKEN	1506	MOLDE	G
6419	MOLDE	1506	MOLDE	G
6420	MOLDE	1506	MOLDE	G
6421	MOLDE	1506	MOLDE	G
6422	MOLDE	1506	MOLDE	G
6423	MOLDE	1506	MOLDE	G
6425	MOLDE	1506	MOLDE	G
6429	MOLDE	1506	MOLDE	G
6430	BUD	1579	HUSTADVIKA	G
6431	BUD	1579	HUSTADVIKA	P
6433	HUSTAD	1579	HUSTADVIKA	G
6434	MOLDE	1506	MOLDE	P
6436	MOLDE	1506	MOLDE	P
6440	ELNESVÅGEN	1579	HUSTADVIKA	G
6443	TORNES I ROMSDAL	1579	HUSTADVIKA	G
6444	FARSTAD	1579	HUSTADVIKA	G
6445	MALMEFJORDEN	1579	HUSTADVIKA	G
6446	FARSTAD	1579	HUSTADVIKA	P
6447	ELNESVÅGEN	1579	HUSTADVIKA	P
6450	HJELSET	1506	MOLDE	G
6452	KLEIVE	1506	MOLDE	P
6453	KLEIVE	1506	MOLDE	G
6454	HJELSET	1506	MOLDE	P
6455	KORTGARDEN	1506	MOLDE	G
6456	SKÅLA	1506	MOLDE	G
6457	BOLSØYA	1506	MOLDE	G
6458	SKÅLA	1506	MOLDE	P
6460	EIDSVÅG I ROMSDAL	1506	MOLDE	G
6461	EIDSVÅG I ROMSDAL	1506	MOLDE	P
6462	RAUDSAND	1506	MOLDE	G
6470	ERESFJORD	1506	MOLDE	G
6471	ERESFJORD	1506	MOLDE	P
6472	EIKESDAL	1506	MOLDE	G
6475	MIDSUND	1506	MOLDE	G
6476	MIDSUND	1506	MOLDE	P
6480	AUKRA	1547	AUKRA	G
6481	AUKRA	1547	AUKRA	P
6490	EIDE	1579	HUSTADVIKA	G
6493	LYNGSTAD	1579	HUSTADVIKA	G
6494	VEVANG	1579	HUSTADVIKA	G
6499	EIDE	1579	HUSTADVIKA	P
6501	KRISTIANSUND N	1505	KRISTIANSUND	P
6502	KRISTIANSUND N	1505	KRISTIANSUND	P
6503	KRISTIANSUND N	1505	KRISTIANSUND	P
6504	KRISTIANSUND N	1505	KRISTIANSUND	P
6507	KRISTIANSUND N	1505	KRISTIANSUND	G
6508	KRISTIANSUND N	1505	KRISTIANSUND	G
6509	KRISTIANSUND N	1505	KRISTIANSUND	G
6510	KRISTIANSUND N	1505	KRISTIANSUND	G
6511	KRISTIANSUND N	1505	KRISTIANSUND	G
6512	KRISTIANSUND N	1505	KRISTIANSUND	G
6514	KRISTIANSUND N	1505	KRISTIANSUND	G
6515	KRISTIANSUND N	1505	KRISTIANSUND	G
6516	KRISTIANSUND N	1505	KRISTIANSUND	G
6517	KRISTIANSUND N	1505	KRISTIANSUND	G
6518	KRISTIANSUND N	1505	KRISTIANSUND	G
6520	FREI	1505	KRISTIANSUND	G
6521	FREI	1505	KRISTIANSUND	G
6522	FREI	1505	KRISTIANSUND	G
6523	FREI	1505	KRISTIANSUND	G
6524	FREI	1505	KRISTIANSUND	G
6525	FREI	1505	KRISTIANSUND	G
6527	FREI	1505	KRISTIANSUND	P
6528	FREI	1505	KRISTIANSUND	P
6529	FREI	1505	KRISTIANSUND	P
6530	AVERØY	1554	AVERØY	G
6531	AVERØY	1554	AVERØY	G
6532	AVERØY	1554	AVERØY	G
6533	AVERØY	1554	AVERØY	G
6538	AVERØY	1554	AVERØY	P
6539	AVERØY	1554	AVERØY	P
6546	KRISTIANSUND N	1505	KRISTIANSUND	P
6547	KRISTIANSUND N	1505	KRISTIANSUND	P
6548	KRISTIANSUND N	1505	KRISTIANSUND	P
6570	SMØLA	1573	SMØLA	G
6571	SMØLA	1573	SMØLA	P
6590	TUSTNA	1576	AURE	G
6591	TUSTNA	1576	AURE	P
6600	SUNNDALSØRA	1563	SUNNDAL	G
6601	SUNNDALSØRA	1563	SUNNDAL	P
6610	ØKSENDAL	1563	SUNNDAL	G
6611	FURUGRENDA	1563	SUNNDAL	G
6612	GRØA	1563	SUNNDAL	G
6613	GJØRA	1563	SUNNDAL	G
6614	GJØRA	1563	SUNNDAL	P
6620	ÅLVUNDEID	1563	SUNNDAL	G
6622	ÅLVUNDFJORD	1563	SUNNDAL	G
6623	ÅLVUNDFJORD	1563	SUNNDAL	P
6627	TINGVOLL	1560	TINGVOLL	P
6628	MEISINGSET	1560	TINGVOLL	G
6629	TORJULVÅGEN	1560	TINGVOLL	G
6630	TINGVOLL	1560	TINGVOLL	G
6631	BATNFJORDSØRA	1557	GJEMNES	G
6632	BATNFJORDSØRA	1557	GJEMNES	P
6633	GJEMNES	1557	GJEMNES	G
6636	ANGVIK	1557	GJEMNES	G
6637	FLEMMA	1557	GJEMNES	G
6638	OSMARKA	1557	GJEMNES	G
6639	TORVIKBUKT	1557	GJEMNES	G
6640	KVANNE	1566	SURNADAL	G
6641	TORVIKBUKT	1557	GJEMNES	P
6642	STANGVIK	1566	SURNADAL	G
6643	BØFJORDEN	1566	SURNADAL	G
6644	BÆVERFJORD	1566	SURNADAL	G
6645	TODALEN	1566	SURNADAL	G
6650	SURNADAL	1566	SURNADAL	G
6652	SURNADAL	1566	SURNADAL	G
6653	ØVRE SURNADAL	1566	SURNADAL	G
6655	VINDØLA	1566	SURNADAL	G
6656	SURNADAL	1566	SURNADAL	P
6657	RINDAL	5061	RINDAL	G
6658	RINDALSSKOGEN	5061	RINDAL	G
6659	RINDAL	5061	RINDAL	P
6670	ØYDEGARD	1560	TINGVOLL	G
6671	ØYDEGARD	1560	TINGVOLL	P
6674	KVISVIK	1560	TINGVOLL	G
6675	KVISVIK	1560	TINGVOLL	P
6680	HALSANAUSTAN	5055	HEIM	G
6683	VÅGLAND	5055	HEIM	G
6686	VALSØYBOTN	5055	HEIM	G
6687	VALSØYFJORD	5055	HEIM	G
6688	VÅGLAND	5055	HEIM	P
6689	AURE	1576	AURE	P
6690	AURE	1576	AURE	G
6693	MJOSUNDET	1576	AURE	G
6694	FOLDFJORDEN	1576	AURE	G
6697	VIHALS	1576	AURE	G
6698	LESUND	1576	AURE	G
6699	KJØRSVIKBUGEN	1576	AURE	G
6700	MÅLØY	4602	KINN	G
6701	MÅLØY	4602	KINN	P
6702	MÅLØY	4602	KINN	P
6704	DEKNEPOLLEN	4602	KINN	P
6707	RAUDEBERG	4602	KINN	P
6708	BRYGGJA	4649	STAD	P
6710	RAUDEBERG	4602	KINN	G
6711	BRYGGJA	4649	STAD	G
6713	ALMENNINGEN	4602	KINN	G
6714	SILDA	4602	KINN	G
6715	BARMEN	4649	STAD	G
6716	HUSEVÅG	4602	KINN	G
6717	FLATRAKET	4649	STAD	G
6718	DEKNEPOLLEN	4602	KINN	G
6719	SKATESTRAUMEN	4648	BREMANGER	G
6721	SVELGEN	4648	BREMANGER	P
6723	SVELGEN	4648	BREMANGER	G
6726	BREMANGER	4648	BREMANGER	P
6727	BREMANGER	4648	BREMANGER	G
6728	KALVÅG	4648	BREMANGER	P
6729	KALVÅG	4648	BREMANGER	G
6730	DAVIK	4648	BREMANGER	G
6734	RUGSUND	4648	BREMANGER	G
6737	ÅLFOTEN	4648	BREMANGER	G
6740	SELJE	4649	STAD	G
6741	SELJE	4649	STAD	P
6750	STADLANDET	4649	STAD	G
6751	STADLANDET	4649	STAD	P
6761	HORNINDAL	1577	VOLDA	P
6763	HORNINDAL	1577	VOLDA	G
6770	NORDFJORDEID	4649	STAD	G
6771	NORDFJORDEID	4649	STAD	P
6772	NORDFJORDEID	4649	STAD	P
6773	NORDFJORDEID	4649	STAD	G
6774	NORDFJORDEID	4649	STAD	G
6776	KJØLSDALEN	4649	STAD	G
6777	STÅRHEIM	4649	STAD	G
6778	LOTE	4649	STAD	G
6779	HOLMØYANE	4649	STAD	G
6781	STRYN	4651	STRYN	P
6782	STRYN	4651	STRYN	P
6783	STRYN	4651	STRYN	G
6784	OLDEN	4651	STRYN	P
6788	OLDEN	4651	STRYN	G
6789	LOEN	4651	STRYN	G
6790	LOEN	4651	STRYN	P
6791	OLDEDALEN	4651	STRYN	G
6792	BRIKSDALSBRE	4651	STRYN	G
6793	INNVIK	4651	STRYN	G
6794	INNVIK	4651	STRYN	P
6795	BLAKSÆTER	4651	STRYN	G
6796	HOPLAND	4651	STRYN	G
6797	UTVIK	4651	STRYN	G
6798	HJELLEDALEN	4651	STRYN	G
6799	OPPSTRYN	4651	STRYN	G
6800	FØRDE	4647	SUNNFJORD	G
6801	FØRDE	4647	SUNNFJORD	P
6802	FØRDE	4647	SUNNFJORD	P
6803	FØRDE	4647	SUNNFJORD	P
6804	FØRDE	4647	SUNNFJORD	P
6805	FØRDE	4647	SUNNFJORD	P
6806	NAUSTDAL	4647	SUNNFJORD	P
6807	FØRDE	4647	SUNNFJORD	P
6808	FØRDE	4647	SUNNFJORD	P
6809	FØRDE	4647	SUNNFJORD	G
6810	FØRDE	4647	SUNNFJORD	G
6811	FØRDE	4647	SUNNFJORD	G
6812	FØRDE	4647	SUNNFJORD	G
6813	FØRDE	4647	SUNNFJORD	G
6814	FØRDE	4647	SUNNFJORD	G
6815	FØRDE	4647	SUNNFJORD	G
6817	NAUSTDAL	4647	SUNNFJORD	G
6818	HAUKEDALEN	4647	SUNNFJORD	G
6819	FØRDE	4647	SUNNFJORD	G
6820	FØRDE	4647	SUNNFJORD	P
6821	SANDANE	4650	GLOPPEN	P
6822	SANDANE	4650	GLOPPEN	P
6823	SANDANE	4650	GLOPPEN	G
6826	BYRKJELO	4650	GLOPPEN	G
6827	BREIM	4650	GLOPPEN	G
6828	HESTENESØYRA	4650	GLOPPEN	G
6829	HYEN	4650	GLOPPEN	G
6830	BYRKJELO	4650	GLOPPEN	P
6831	HYEN	4650	GLOPPEN	P
6841	SKEI I JØLSTER	4647	SUNNFJORD	P
6843	SKEI I JØLSTER	4647	SUNNFJORD	G
6844	VASSENDEN	4647	SUNNFJORD	P
6847	VASSENDEN	4647	SUNNFJORD	G
6848	FJÆRLAND	4640	SOGNDAL	G
6849	KAUPANGER	4640	SOGNDAL	P
6851	SOGNDAL	4640	SOGNDAL	P
6852	SOGNDAL	4640	SOGNDAL	P
6853	SOGNDAL	4640	SOGNDAL	P
6854	KAUPANGER	4640	SOGNDAL	G
6855	FRØNNINGEN	4642	LÆRDAL	G
6856	SOGNDAL	4640	SOGNDAL	G
6857	SOGNDAL	4640	SOGNDAL	G
6858	FARDAL	4640	SOGNDAL	G
6859	SLINDA	4640	SOGNDAL	G
6861	LEIKANGER	4640	SOGNDAL	P
6863	LEIKANGER	4640	SOGNDAL	G
6866	GAUPNE	4644	LUSTER	P
6867	HAFSLO	4644	LUSTER	P
6868	GAUPNE	4644	LUSTER	G
6869	HAFSLO	4644	LUSTER	G
6870	ORNES	4644	LUSTER	G
6871	JOSTEDAL	4644	LUSTER	G
6872	LUSTER	4644	LUSTER	G
6873	MARIFJØRA	4644	LUSTER	G
6874	LUSTER	4644	LUSTER	P
6875	HØYHEIMSVIK	4644	LUSTER	G
6876	SKJOLDEN	4644	LUSTER	G
6877	FORTUN	4644	LUSTER	G
6878	VEITASTROND	4644	LUSTER	G
6879	SOLVORN	4644	LUSTER	G
6881	ÅRDALSTANGEN	4643	ÅRDAL	P
6882	ØVRE ÅRDAL	4643	ÅRDAL	P
6884	ØVRE ÅRDAL	4643	ÅRDAL	G
6885	ÅRDALSTANGEN	4643	ÅRDAL	G
6886	LÆRDAL	4642	LÆRDAL	P
6887	LÆRDAL	4642	LÆRDAL	G
6888	BORGUND	4642	LÆRDAL	G
6891	VIK I SOGN	4639	VIK	P
6893	VIK I SOGN	4639	VIK	G
6894	VANGSNES	4639	VIK	G
6895	FEIOS	4639	VIK	G
6896	FRESVIK	4639	VIK	G
6898	BALESTRAND	4640	SOGNDAL	P
6899	BALESTRAND	4640	SOGNDAL	G
6900	FLORØ	4602	KINN	G
6901	FLORØ	4602	KINN	P
6902	FLORØ	4602	KINN	P
6903	FLORØ	4602	KINN	P
6905	FLORØ	4602	KINN	G
6906	FLORØ	4602	KINN	G
6907	FLORØ	4602	KINN	G
6908	FLORØ	4602	KINN	G
6909	FLORØ	4602	KINN	P
6910	FLORØ	4602	KINN	G
6912	KINN	4602	KINN	G
6913	FLORØ	4602	KINN	G
6914	SVANØYBUKT	4602	KINN	G
6915	ROGNALDSVÅG	4602	KINN	G
6916	BAREKSTAD	4602	KINN	G
6917	BATALDEN	4602	KINN	G
6918	SØR-SKORPA	4602	KINN	G
6919	TANSØY	4602	KINN	G
6921	HARDBAKKE	4636	SOLUND	P
6924	HARDBAKKE	4636	SOLUND	G
6926	KRAKHELLA	4636	SOLUND	G
6927	YTRØYGREND	4636	SOLUND	G
6928	KOLGROV	4636	SOLUND	G
6929	HERSVIKBYGDA	4636	SOLUND	G
6940	EIKEFJORD	4602	KINN	G
6941	EIKEFJORD	4602	KINN	P
6942	SVORTEVIK	4602	KINN	G
6944	STAVANG	4602	KINN	G
6946	LAVIK	4638	HØYANGER	P
6947	LAVIK	4638	HØYANGER	G
6951	HYLLESTAD	4637	HYLLESTAD	P
6953	LEIRVIK I SOGN	4637	HYLLESTAD	G
6957	HYLLESTAD	4637	HYLLESTAD	G
6958	SØRBØVÅG	4637	HYLLESTAD	G
6959	SØRBØVÅG	4637	HYLLESTAD	P
6961	DALE I SUNNFJORD	4646	FJALER	P
6963	DALE I SUNNFJORD	4646	FJALER	G
6964	KORSSUND	4646	FJALER	G
6966	GUDDAL	4646	FJALER	G
6967	HELLEVIK I FJALER	4646	FJALER	G
6968	FLEKKE	4646	FJALER	G
6969	STRAUMSNES	4646	FJALER	G
6971	SANDE I SUNNFJORD	4647	SUNNFJORD	P
6973	SANDE I SUNNFJORD	4647	SUNNFJORD	G
6975	SKILBREI	4647	SUNNFJORD	G
6976	BYGSTAD	4647	SUNNFJORD	P
6977	BYGSTAD	4647	SUNNFJORD	G
6978	VIKSDALEN	4647	SUNNFJORD	G
6980	ASKVOLL	4645	ASKVOLL	G
6982	HOLMEDAL	4645	ASKVOLL	G
6983	KVAMMEN	4645	ASKVOLL	G
6984	STONGFJORDEN	4645	ASKVOLL	G
6985	ATLØY	4645	ASKVOLL	G
6986	VÆRLANDET	4645	ASKVOLL	G
6987	BULANDET	4645	ASKVOLL	G
6988	ASKVOLL	4645	ASKVOLL	P
6991	HØYANGER	4638	HØYANGER	P
6993	HØYANGER	4638	HØYANGER	G
6994	NESSANE	4638	HØYANGER	G
6995	KYRKJEBØ	4638	HØYANGER	G
6996	VADHEIM	4638	HØYANGER	G
7003	TRONDHEIM	5001	TRONDHEIM	P
7004	TRONDHEIM	5001	TRONDHEIM	P
7005	TRONDHEIM	5001	TRONDHEIM	P
7006	TRONDHEIM	5001	TRONDHEIM	P
7010	TRONDHEIM	5001	TRONDHEIM	G
7011	TRONDHEIM	5001	TRONDHEIM	G
7012	TRONDHEIM	5001	TRONDHEIM	G
7013	TRONDHEIM	5001	TRONDHEIM	G
7014	TRONDHEIM	5001	TRONDHEIM	G
7015	TRONDHEIM	5001	TRONDHEIM	G
7016	TRONDHEIM	5001	TRONDHEIM	G
7017	TRONDHEIM	5001	TRONDHEIM	G
7018	TRONDHEIM	5001	TRONDHEIM	G
7019	TRONDHEIM	5001	TRONDHEIM	G
7020	TRONDHEIM	5001	TRONDHEIM	G
7021	TRONDHEIM	5001	TRONDHEIM	G
7022	TRONDHEIM	5001	TRONDHEIM	G
7023	TRONDHEIM	5001	TRONDHEIM	G
7024	TRONDHEIM	5001	TRONDHEIM	G
7025	TRONDHEIM	5001	TRONDHEIM	G
7026	TRONDHEIM	5001	TRONDHEIM	G
7027	TRONDHEIM	5001	TRONDHEIM	G
7028	TRONDHEIM	5001	TRONDHEIM	G
7029	TRONDHEIM	5001	TRONDHEIM	G
7030	TRONDHEIM	5001	TRONDHEIM	G
7031	TRONDHEIM	5001	TRONDHEIM	G
7032	TRONDHEIM	5001	TRONDHEIM	G
7033	TRONDHEIM	5001	TRONDHEIM	G
7034	TRONDHEIM	5001	TRONDHEIM	G
7035	TRONDHEIM	5001	TRONDHEIM	G
7036	TRONDHEIM	5001	TRONDHEIM	G
7037	TRONDHEIM	5001	TRONDHEIM	G
7038	TRONDHEIM	5001	TRONDHEIM	G
7039	TRONDHEIM	5001	TRONDHEIM	G
7040	TRONDHEIM	5001	TRONDHEIM	G
7041	TRONDHEIM	5001	TRONDHEIM	G
7042	TRONDHEIM	5001	TRONDHEIM	G
7043	TRONDHEIM	5001	TRONDHEIM	G
7044	TRONDHEIM	5001	TRONDHEIM	G
7045	TRONDHEIM	5001	TRONDHEIM	G
7046	TRONDHEIM	5001	TRONDHEIM	G
7047	TRONDHEIM	5001	TRONDHEIM	G
7048	TRONDHEIM	5001	TRONDHEIM	G
7049	TRONDHEIM	5001	TRONDHEIM	G
7050	TRONDHEIM	5001	TRONDHEIM	G
7051	TRONDHEIM	5001	TRONDHEIM	G
7052	TRONDHEIM	5001	TRONDHEIM	G
7053	RANHEIM	5001	TRONDHEIM	G
7054	RANHEIM	5001	TRONDHEIM	G
7055	RANHEIM	5001	TRONDHEIM	G
7056	RANHEIM	5001	TRONDHEIM	G
7057	JONSVATNET	5001	TRONDHEIM	G
7058	CHARLOTTENLUND	5001	TRONDHEIM	G
7059	JAKOBSLI	5001	TRONDHEIM	G
7060	CHARLOTTENLUND	5001	TRONDHEIM	G
7061	TRONDHEIM	5001	TRONDHEIM	G
7066	TRONDHEIM	5001	TRONDHEIM	G
7067	TRONDHEIM	5001	TRONDHEIM	G
7068	TRONDHEIM	5001	TRONDHEIM	G
7069	TRONDHEIM	5001	TRONDHEIM	G
7070	BOSBERG	5001	TRONDHEIM	G
7071	TRONDHEIM	5001	TRONDHEIM	G
7072	HEIMDAL	5001	TRONDHEIM	G
7074	SPONGDAL	5001	TRONDHEIM	G
7075	TILLER	5001	TRONDHEIM	G
7078	SAUPSTAD	5001	TRONDHEIM	G
7079	FLATÅSEN	5001	TRONDHEIM	G
7080	HEIMDAL	5001	TRONDHEIM	G
7081	SJETNEMARKA	5001	TRONDHEIM	G
7082	KATTEM	5001	TRONDHEIM	G
7083	LEINSTRAND	5001	TRONDHEIM	G
7088	HEIMDAL	5001	TRONDHEIM	G
7089	HEIMDAL	5001	TRONDHEIM	G
7091	TILLER	5001	TRONDHEIM	G
7092	TILLER	5001	TRONDHEIM	G
7093	TILLER	5001	TRONDHEIM	G
7097	SAUPSTAD	5001	TRONDHEIM	G
7098	SAUPSTAD	5001	TRONDHEIM	G
7099	FLATÅSEN	5001	TRONDHEIM	G
7100	RISSA	5054	INDRE FOSEN	G
7101	RISSA	5054	INDRE FOSEN	P
7105	STADSBYGD	5054	INDRE FOSEN	G
7110	FEVÅG	5054	INDRE FOSEN	G
7111	HASSELVIKA	5054	INDRE FOSEN	P
7112	HASSELVIKA	5054	INDRE FOSEN	G
7113	HUSBYSJØEN	5054	INDRE FOSEN	G
7114	RÅKVÅG	5054	INDRE FOSEN	G
7115	HUSBYSJØEN	5054	INDRE FOSEN	P
7116	RÅKVÅG	5054	INDRE FOSEN	P
7119	STADSBYGD	5054	INDRE FOSEN	P
7120	LEKSVIK	5054	INDRE FOSEN	G
7121	LEKSVIK	5054	INDRE FOSEN	P
7125	VANVIKAN	5054	INDRE FOSEN	G
7126	VANVIKAN	5054	INDRE FOSEN	P
7127	OPPHAUG	5057	ØRLAND	P
7129	BREKSTAD	5057	ØRLAND	P
7130	BREKSTAD	5057	ØRLAND	G
7140	OPPHAUG	5057	ØRLAND	G
7142	UTHAUG	5057	ØRLAND	G
7150	STORFOSNA	5057	ØRLAND	G
7151	STORFOSNA	5057	ØRLAND	P
7152	KRÅKVÅG	5057	ØRLAND	G
7153	GARTEN	5057	ØRLAND	G
7156	LEKSA	5059	ORKLAND	G
7159	BJUGN	5057	ØRLAND	P
7160	BJUGN	5057	ØRLAND	G
7164	LYSØYSUNDET	5057	ØRLAND	P
7165	OKSVOLL	5057	ØRLAND	G
7166	TARVA	5057	ØRLAND	G
7167	VALLERSUND	5057	ØRLAND	G
7168	LYSØYSUNDET	5057	ØRLAND	G
7169	ÅFJORD	5058	ÅFJORD	P
7170	ÅFJORD	5058	ÅFJORD	G
7174	REVSNES	5058	ÅFJORD	P
7175	STOKKØY	5058	ÅFJORD	P
7176	LINESØYA	5058	ÅFJORD	G
7177	REVSNES	5058	ÅFJORD	G
7178	STOKKØY	5058	ÅFJORD	G
7180	ROAN	5058	ÅFJORD	G
7181	ROAN	5058	ÅFJORD	P
7190	BESSAKER	5058	ÅFJORD	G
7194	BRANDSFJORD	5058	ÅFJORD	G
7200	KYRKSÆTERØRA	5055	HEIM	G
7201	KYRKSÆTERØRA	5055	HEIM	P
7203	VINJEØRA	5055	HEIM	G
7206	HELLANDSJØEN	5055	HEIM	G
7207	YTRE SNILLFJORD	5055	HEIM	G
7211	KORSVEGEN	5028	MELHUS	P
7212	KORSVEGEN	5028	MELHUS	G
7213	GÅSBAKKEN	5028	MELHUS	G
7221	MELHUS	5028	MELHUS	P
7223	MELHUS	5028	MELHUS	P
7224	MELHUS	5028	MELHUS	G
7227	GIMSE	5028	MELHUS	G
7228	KVÅL	5028	MELHUS	G
7231	LUNDAMO	5028	MELHUS	P
7232	LUNDAMO	5028	MELHUS	G
7234	LER	5028	MELHUS	G
7235	LER	5028	MELHUS	P
7236	HOVIN I GAULDAL	5028	MELHUS	G
7238	HOVIN I GAULDAL	5028	MELHUS	P
7239	HITRA	5056	HITRA	P
7240	HITRA	5056	HITRA	G
7241	ANSNES	5056	HITRA	G
7242	KNARRLAGSUND	5056	HITRA	G
7243	KVENVÆR	5056	HITRA	G
7244	KNARRLAGSUND	5056	HITRA	P
7245	KVENVÆR	5056	HITRA	P
7246	SANDSTAD	5056	HITRA	G
7247	HESTVIKA	5056	HITRA	G
7250	MELANDSJØ	5056	HITRA	G
7252	DOLMØY	5056	HITRA	G
7255	SUNDLANDET	5056	HITRA	G
7256	HEMNSKJELA	5056	HITRA	G
7257	SNILLFJORD	5059	ORKLAND	G
7259	SNILLFJORD	5059	ORKLAND	P
7260	SISTRANDA	5014	FRØYA	G
7261	SISTRANDA	5014	FRØYA	P
7263	HAMARVIK	5014	FRØYA	G
7264	HAMARVIK	5014	FRØYA	P
7266	KVERVA	5014	FRØYA	G
7267	KVERVA	5014	FRØYA	P
7268	TITRAN	5014	FRØYA	G
7270	DYRVIK	5014	FRØYA	G
7273	NORDDYRØY	5014	FRØYA	G
7274	NORDDYRØY	5014	FRØYA	P
7280	SULA	5014	FRØYA	B
7282	BOGØYVÆR	5014	FRØYA	G
7284	MAUSUND	5014	FRØYA	B
7285	GJÆSINGEN	5014	FRØYA	G
7286	SØRBURØY	5014	FRØYA	G
7287	SAUØY	5014	FRØYA	G
7288	SOKNEDAL	5027	MIDTRE GAULDAL	G
7289	SOKNEDAL	5027	MIDTRE GAULDAL	P
7290	STØREN	5027	MIDTRE GAULDAL	G
7291	STØREN	5027	MIDTRE GAULDAL	P
7295	ROGNES	5027	MIDTRE GAULDAL	G
7298	BUDALEN	5027	MIDTRE GAULDAL	G
7300	ORKANGER	5059	ORKLAND	G
7301	ORKANGER	5059	ORKLAND	P
7302	ORKANGER	5059	ORKLAND	P
7303	ORKANGER	5059	ORKLAND	G
7310	GJØLME	5059	ORKLAND	G
7315	LENSVIK	5059	ORKLAND	P
7316	LENSVIK	5059	ORKLAND	G
7318	AGDENES	5059	ORKLAND	G
7319	AGDENES	5059	ORKLAND	P
7320	FANNREM	5059	ORKLAND	G
7321	FANNREM	5059	ORKLAND	P
7327	SVORKMO	5059	ORKLAND	G
7329	SVORKMO	5059	ORKLAND	P
7331	LØKKEN VERK	5059	ORKLAND	P
7332	LØKKEN VERK	5059	ORKLAND	G
7333	STORÅS	5059	ORKLAND	P
7334	STORÅS	5059	ORKLAND	G
7335	JERPSTAD	5059	ORKLAND	G
7336	MELDAL	5059	ORKLAND	G
7338	MELDAL	5059	ORKLAND	P
7340	OPPDAL	5021	OPPDAL	G
7341	OPPDAL	5021	OPPDAL	P
7342	LØNSET	5021	OPPDAL	G
7343	VOGNILL	5021	OPPDAL	G
7344	OPPDAL	5021	OPPDAL	G
7345	DRIVDALEN	5021	OPPDAL	G
7346	OPPDAL	5021	OPPDAL	G
7347	OPPDAL	5021	OPPDAL	G
7350	BUVIKA	5029	SKAUN	G
7351	BUVIKA	5029	SKAUN	P
7353	BØRSA	5029	SKAUN	G
7354	VIGGJA	5029	SKAUN	G
7355	EGGKLEIVA	5029	SKAUN	G
7356	SKAUN	5029	SKAUN	P
7357	SKAUN	5029	SKAUN	G
7358	BØRSA	5029	SKAUN	P
7361	RØROS	5025	RØROS	P
7370	BREKKEBYGD	5025	RØROS	G
7372	GLÅMOS	5025	RØROS	G
7374	RØROS	5025	RØROS	G
7375	RØROS	5025	RØROS	G
7380	ÅLEN	5026	HOLTÅLEN	G
7383	HALTDALEN	5026	HOLTÅLEN	G
7384	ÅLEN	5026	HOLTÅLEN	P
7386	SINGSÅS	5027	MIDTRE GAULDAL	P
7387	SINGSÅS	5027	MIDTRE GAULDAL	G
7388	SINGSÅS	5027	MIDTRE GAULDAL	P
7391	RENNEBU	5022	RENNEBU	G
7392	RENNEBU	5022	RENNEBU	G
7393	RENNEBU	5022	RENNEBU	G
7397	RENNEBU	5022	RENNEBU	G
7398	RENNEBU	5022	RENNEBU	G
7399	RENNEBU	5022	RENNEBU	P
7400	TRONDHEIM	5001	TRONDHEIM	P
7401	TRONDHEIM	5001	TRONDHEIM	P
7402	TRONDHEIM	5001	TRONDHEIM	P
7403	TRONDHEIM	5001	TRONDHEIM	P
7404	TRONDHEIM	5001	TRONDHEIM	P
7405	TRONDHEIM	5001	TRONDHEIM	P
7406	TRONDHEIM	5001	TRONDHEIM	P
7407	TRONDHEIM	5001	TRONDHEIM	P
7408	TRONDHEIM	5001	TRONDHEIM	P
7409	TRONDHEIM	5001	TRONDHEIM	P
7410	TRONDHEIM	5001	TRONDHEIM	P
7411	TRONDHEIM	5001	TRONDHEIM	P
7412	TRONDHEIM	5001	TRONDHEIM	P
7413	TRONDHEIM	5001	TRONDHEIM	P
7414	TRONDHEIM	5001	TRONDHEIM	P
7415	TRONDHEIM	5001	TRONDHEIM	P
7416	TRONDHEIM	5001	TRONDHEIM	P
7417	TRONDHEIM	5001	TRONDHEIM	P
7418	TRONDHEIM	5001	TRONDHEIM	P
7419	TRONDHEIM	5001	TRONDHEIM	P
7420	TRONDHEIM	5001	TRONDHEIM	P
7421	TRONDHEIM	5001	TRONDHEIM	P
7422	TRONDHEIM	5001	TRONDHEIM	P
7424	TRONDHEIM	5001	TRONDHEIM	P
7425	TRONDHEIM	5001	TRONDHEIM	P
7427	TRONDHEIM	5001	TRONDHEIM	P
7428	TRONDHEIM	5001	TRONDHEIM	P
7429	TRONDHEIM	5001	TRONDHEIM	P
7430	TRONDHEIM	5001	TRONDHEIM	P
7431	TRONDHEIM	5001	TRONDHEIM	P
7432	TRONDHEIM	5001	TRONDHEIM	P
7433	TRONDHEIM	5001	TRONDHEIM	P
7434	TRONDHEIM	5001	TRONDHEIM	P
7435	TRONDHEIM	5001	TRONDHEIM	P
7436	TRONDHEIM	5001	TRONDHEIM	P
7437	TRONDHEIM	5001	TRONDHEIM	P
7438	TRONDHEIM	5001	TRONDHEIM	P
7439	TRONDHEIM	5001	TRONDHEIM	P
7440	TRONDHEIM	5001	TRONDHEIM	P
7441	TRONDHEIM	5001	TRONDHEIM	P
7442	TRONDHEIM	5001	TRONDHEIM	P
7443	TRONDHEIM	5001	TRONDHEIM	P
7444	TRONDHEIM	5001	TRONDHEIM	P
7445	TRONDHEIM	5001	TRONDHEIM	P
7446	TRONDHEIM	5001	TRONDHEIM	P
7447	TRONDHEIM	5001	TRONDHEIM	P
7448	TRONDHEIM	5001	TRONDHEIM	P
7449	TRONDHEIM	5001	TRONDHEIM	P
7450	TRONDHEIM	5001	TRONDHEIM	P
7451	TRONDHEIM	5001	TRONDHEIM	P
7452	TRONDHEIM	5001	TRONDHEIM	P
7453	TRONDHEIM	5001	TRONDHEIM	P
7454	TRONDHEIM	5001	TRONDHEIM	P
7455	TRONDHEIM	5001	TRONDHEIM	P
7456	TRONDHEIM	5001	TRONDHEIM	P
7457	TRONDHEIM	5001	TRONDHEIM	P
7458	TRONDHEIM	5001	TRONDHEIM	P
7462	TRONDHEIM	5001	TRONDHEIM	P
7463	TRONDHEIM	5001	TRONDHEIM	P
7464	TRONDHEIM	5001	TRONDHEIM	P
7465	TRONDHEIM	5001	TRONDHEIM	P
7466	TRONDHEIM	5001	TRONDHEIM	P
7467	TRONDHEIM	5001	TRONDHEIM	P
7468	TRONDHEIM	5001	TRONDHEIM	P
7469	TRONDHEIM	5001	TRONDHEIM	P
7470	TRONDHEIM	5001	TRONDHEIM	P
7471	TRONDHEIM	5001	TRONDHEIM	P
7472	TRONDHEIM	5001	TRONDHEIM	P
7473	TRONDHEIM	5001	TRONDHEIM	P
7474	TRONDHEIM	5001	TRONDHEIM	P
7475	TRONDHEIM	5001	TRONDHEIM	P
7476	TRONDHEIM	5001	TRONDHEIM	P
7477	TRONDHEIM	5001	TRONDHEIM	P
7478	TRONDHEIM	5001	TRONDHEIM	P
7479	TRONDHEIM	5001	TRONDHEIM	P
7480	TRONDHEIM	5001	TRONDHEIM	P
7481	TRONDHEIM	5001	TRONDHEIM	P
7482	TRONDHEIM	5001	TRONDHEIM	P
7483	TRONDHEIM	5001	TRONDHEIM	P
7484	TRONDHEIM	5001	TRONDHEIM	P
7485	TRONDHEIM	5001	TRONDHEIM	P
7486	TRONDHEIM	5001	TRONDHEIM	P
7487	TRONDHEIM	5001	TRONDHEIM	P
7488	TRONDHEIM	5001	TRONDHEIM	P
7489	TRONDHEIM	5001	TRONDHEIM	P
7490	TRONDHEIM	5001	TRONDHEIM	P
7491	TRONDHEIM	5001	TRONDHEIM	P
7492	TRONDHEIM	5001	TRONDHEIM	P
7493	TRONDHEIM	5001	TRONDHEIM	P
7494	TRONDHEIM	5001	TRONDHEIM	P
7495	TRONDHEIM	5001	TRONDHEIM	P
7496	TRONDHEIM	5001	TRONDHEIM	P
7497	TRONDHEIM	5001	TRONDHEIM	P
7498	TRONDHEIM	5001	TRONDHEIM	P
7500	STJØRDAL	5035	STJØRDAL	G
7501	STJØRDAL	5035	STJØRDAL	P
7502	STJØRDAL	5035	STJØRDAL	G
7503	STJØRDAL	5035	STJØRDAL	G
7504	STJØRDAL	5035	STJØRDAL	G
7505	STJØRDAL	5035	STJØRDAL	G
7506	STJØRDAL	5035	STJØRDAL	G
7507	STJØRDAL	5035	STJØRDAL	G
7508	STJØRDAL	5035	STJØRDAL	P
7509	STJØRDAL	5035	STJØRDAL	G
7510	SKATVAL	5035	STJØRDAL	G
7511	SKATVAL	5035	STJØRDAL	P
7512	STJØRDAL	5035	STJØRDAL	G
7513	STJØRDAL	5035	STJØRDAL	G
7514	STJØRDAL	5035	STJØRDAL	G
7517	HELL	5035	STJØRDAL	G
7519	ELVARLI	5035	STJØRDAL	G
7520	HEGRA	5035	STJØRDAL	G
7525	FLORNES	5035	STJØRDAL	G
7529	HEGRA	5035	STJØRDAL	P
7530	MERÅKER	5034	MERÅKER	G
7531	MERÅKER	5034	MERÅKER	P
7533	KOPPERÅ	5034	MERÅKER	G
7540	KLÆBU	5001	TRONDHEIM	G
7541	KLÆBU	5001	TRONDHEIM	P
7549	TANEM	5001	TRONDHEIM	G
7550	HOMMELVIK	5031	MALVIK	G
7551	HOMMELVIK	5031	MALVIK	P
7560	VIKHAMMER	5031	MALVIK	G
7562	SAKSVIK	5031	MALVIK	G
7563	MALVIK	5031	MALVIK	G
7566	VIKHAMMER	5031	MALVIK	P
7570	HELL	5035	STJØRDAL	P
7580	SELBU	5032	SELBU	G
7581	SELBU	5032	SELBU	P
7583	SELBU	5032	SELBU	P
7584	SELBUSTRAND	5032	SELBU	G
7590	TYDAL	5033	TYDAL	G
7591	TYDAL	5033	TYDAL	P
7596	FLAKNAN	5032	SELBU	G
7600	LEVANGER	5037	LEVANGER	G
7601	LEVANGER	5037	LEVANGER	P
7602	LEVANGER	5037	LEVANGER	G
7603	LEVANGER	5037	LEVANGER	G
7604	LEVANGER	5037	LEVANGER	G
7605	LEVANGER	5037	LEVANGER	G
7606	LEVANGER	5037	LEVANGER	G
7607	LEVANGER	5037	LEVANGER	G
7608	LEVANGER	5037	LEVANGER	G
7609	LEVANGER	5037	LEVANGER	G
7610	LEVANGER	5037	LEVANGER	P
7619	SKOGN	5037	LEVANGER	P
7620	SKOGN	5037	LEVANGER	G
7622	MARKABYGDA	5037	LEVANGER	G
7623	RONGLAN	5037	LEVANGER	G
7624	EKNE	5037	LEVANGER	G
7629	YTTERØY	5037	LEVANGER	G
7630	ÅSEN	5037	LEVANGER	G
7631	ÅSEN	5037	LEVANGER	P
7632	ÅSENFJORD	5037	LEVANGER	G
7633	FROSTA	5036	FROSTA	G
7634	FROSTA	5036	FROSTA	P
7650	VERDAL	5038	VERDAL	G
7651	VERDAL	5038	VERDAL	P
7652	VERDAL	5038	VERDAL	G
7653	VERDAL	5038	VERDAL	G
7654	VERDAL	5038	VERDAL	G
7655	VERDAL	5038	VERDAL	G
7656	VERDAL	5038	VERDAL	G
7657	VERDAL	5038	VERDAL	G
7658	VERDAL	5038	VERDAL	P
7660	VUKU	5038	VERDAL	G
7661	VUKU	5038	VERDAL	P
7670	INDERØY	5053	INDERØY	G
7671	INDERØY	5053	INDERØY	P
7672	INDERØY	5053	INDERØY	P
7690	MOSVIK	5053	INDERØY	G
7691	MOSVIK	5053	INDERØY	P
7701	STEINKJER	5006	STEINKJER	P
7702	STEINKJER	5006	STEINKJER	P
7703	STEINKJER	5006	STEINKJER	P
7704	STEINKJER	5006	STEINKJER	P
7705	STEINKJER	5006	STEINKJER	P
7707	STEINKJER	5006	STEINKJER	P
7708	STEINKJER	5006	STEINKJER	P
7709	STEINKJER	5006	STEINKJER	P
7710	SPARBU	5006	STEINKJER	G
7711	STEINKJER	5006	STEINKJER	G
7712	STEINKJER	5006	STEINKJER	G
7713	STEINKJER	5006	STEINKJER	G
7714	STEINKJER	5006	STEINKJER	G
7715	STEINKJER	5006	STEINKJER	G
7716	STEINKJER	5006	STEINKJER	G
7717	STEINKJER	5006	STEINKJER	G
7718	STEINKJER	5006	STEINKJER	G
7724	STEINKJER	5006	STEINKJER	G
7725	STEINKJER	5006	STEINKJER	G
7726	STEINKJER	5006	STEINKJER	P
7729	STEINKJER	5006	STEINKJER	P
7730	BEITSTAD	5006	STEINKJER	G
7732	STEINKJER	5006	STEINKJER	G
7733	SPARBU	5006	STEINKJER	P
7734	STEINKJER	5006	STEINKJER	P
7735	STEINKJER	5006	STEINKJER	P
7736	STEINKJER	5006	STEINKJER	P
7737	STEINKJER	5006	STEINKJER	P
7738	STEINKJER	5006	STEINKJER	P
7739	BEITSTAD	5006	STEINKJER	P
7740	STEINSDALEN	5020	OSEN	G
7741	STEINSDALEN	5020	OSEN	P
7742	YTTERVÅG	5020	OSEN	G
7744	HEPSØY	5020	OSEN	G
7745	OPPLAND	5049	FLATANGER	G
7746	HASVÅG	5049	FLATANGER	G
7748	SETER	5020	OSEN	G
7750	NAMDALSEID	5007	NAMSOS	G
7751	NAMDALSEID	5007	NAMSOS	P
7760	SNÅSA	5041	SNÅSA	G
7761	SNÅSA	5041	SNÅSA	P
7770	FLATANGER	5049	FLATANGER	G
7771	FLATANGER	5049	FLATANGER	P
7777	NORD-STATLAND	5007	NAMSOS	G
7790	MALM	5006	STEINKJER	G
7791	MALM	5006	STEINKJER	P
7795	FOLLAFOSS	5006	STEINKJER	P
7796	FOLLAFOSS	5006	STEINKJER	G
7797	VERRABOTN	5054	INDRE FOSEN	G
7800	NAMSOS	5007	NAMSOS	G
7801	NAMSOS	5007	NAMSOS	P
7802	NAMSOS	5007	NAMSOS	G
7803	NAMSOS	5007	NAMSOS	G
7804	NAMSOS	5007	NAMSOS	G
7805	NAMSOS	5007	NAMSOS	G
7808	NAMSOS	5007	NAMSOS	P
7810	NAMSOS	5007	NAMSOS	G
7817	SALSNES	5007	NAMSOS	G
7818	LUND	5007	NAMSOS	G
7819	FOSSLANDSOSEN	5007	NAMSOS	G
7820	SPILLUM	5007	NAMSOS	G
7821	SPILLUM	5007	NAMSOS	P
7822	BANGSUND	5007	NAMSOS	G
7823	BANGSUND	5007	NAMSOS	P
7856	JØA	5007	NAMSOS	G
7860	SKAGE I NAMDALEN	5047	OVERHALLA	G
7863	OVERHALLA	5047	OVERHALLA	G
7864	OVERHALLA	5047	OVERHALLA	P
7869	SKAGE I NAMDALEN	5047	OVERHALLA	P
7870	GRONG	5045	GRONG	G
7871	GRONG	5045	GRONG	P
7873	HARRAN	5045	GRONG	G
7874	HARRAN	5045	GRONG	P
7876	KONGSMOEN	5046	HØYLANDET	G
7877	HØYLANDET	5046	HØYLANDET	G
7878	HØYLANDET	5046	HØYLANDET	P
7881	NORDLI	5042	LIERNE	P
7882	NORDLI	5042	LIERNE	G
7884	SØRLI	5042	LIERNE	G
7885	SØRLI	5042	LIERNE	P
7890	NAMSSKOGAN	5044	NAMSSKOGAN	G
7891	NAMSSKOGAN	5044	NAMSSKOGAN	P
7892	TRONES	5044	NAMSSKOGAN	G
7893	SKOROVATN	5044	NAMSSKOGAN	G
7896	BREKKVASSELV	5044	NAMSSKOGAN	G
7897	LIMINGEN	5043	RØYRVIK	P
7898	LIMINGEN	5043	RØYRVIK	G
7900	RØRVIK	5060	NÆRØYSUND	G
7901	RØRVIK	5060	NÆRØYSUND	P
7902	RØRVIK	5060	NÆRØYSUND	P
7924	AUSTAFJORD	5060	NÆRØYSUND	G
7940	OTTERSØY	5060	NÆRØYSUND	G
7941	OTTERSØY	5060	NÆRØYSUND	P
7944	INDRE NÆRØY	5060	NÆRØYSUND	G
7950	ABELVÆR	5060	NÆRØYSUND	G
7960	SALSBRUKET	5060	NÆRØYSUND	G
7970	KOLVEREID	5060	NÆRØYSUND	G
7971	KOLVEREID	5060	NÆRØYSUND	P
7973	GJERDINGA	5060	NÆRØYSUND	G
7979	TERRÅK	1811	BINDAL	P
7980	TERRÅK	1811	BINDAL	G
7981	HARANGSFJORD	1811	BINDAL	G
7982	BINDALSEIDET	1811	BINDAL	G
7983	BINDALSEIDET	1811	BINDAL	P
7985	FOLDEREID	5060	NÆRØYSUND	G
7986	FOLDEREID	5060	NÆRØYSUND	P
7990	NAUSTBUKTA	5060	NÆRØYSUND	G
7993	GUTVIK	5052	LEKA	G
7994	LEKA	5052	LEKA	G
7995	LEKA	5052	LEKA	P
8001	BODØ	1804	BODØ	P
8002	BODØ	1804	BODØ	P
8003	BODØ	1804	BODØ	G
8004	BODØ	1804	BODØ	G
8005	BODØ	1804	BODØ	G
8006	BODØ	1804	BODØ	G
8007	BODØ	1804	BODØ	G
8008	BODØ	1804	BODØ	G
8009	BODØ	1804	BODØ	G
8010	BODØ	1804	BODØ	G
8011	BODØ	1804	BODØ	G
8012	BODØ	1804	BODØ	G
8013	BODØ	1804	BODØ	G
8014	BODØ	1804	BODØ	G
8015	BODØ	1804	BODØ	G
8016	BODØ	1804	BODØ	G
8019	BODØ	1804	BODØ	G
8020	BODØ	1804	BODØ	G
8021	BODØ	1804	BODØ	G
8022	BODØ	1804	BODØ	G
8023	BODØ	1804	BODØ	G
8025	BODØ	1804	BODØ	G
8026	BODØ	1804	BODØ	G
8027	BODØ	1804	BODØ	G
8028	BODØ	1804	BODØ	G
8029	BODØ	1804	BODØ	G
8030	BODØ	1804	BODØ	G
8031	BODØ	1804	BODØ	P
8037	BODØ	1804	BODØ	P
8038	BODØ	1804	BODØ	P
8041	BODØ	1804	BODØ	P
8047	BODØ	1804	BODØ	P
8048	BODØ	1804	BODØ	P
8049	BODØ	1804	BODØ	P
8050	TVERLANDET	1804	BODØ	G
8056	SALTSTRAUMEN	1804	BODØ	G
8057	SALTSTRAUMEN	1804	BODØ	P
8058	TVERLANDET	1804	BODØ	P
8062	VÆRØY	1857	VÆRØY	P
8063	VÆRØY	1857	VÆRØY	G
8064	RØST	1856	RØST	G
8065	RØST	1856	RØST	P
8070	BODØ	1804	BODØ	G
8071	BODØ	1804	BODØ	G
8072	BODØ	1804	BODØ	G
8073	BODØ	1804	BODØ	G
8074	BODØ	1804	BODØ	G
8075	BODØ	1804	BODØ	G
8076	BODØ	1804	BODØ	G
8079	BODØ	1804	BODØ	G
8084	BODØ	1804	BODØ	P
8085	BODØ	1804	BODØ	P
8086	BODØ	1804	BODØ	P
8087	BODØ	1804	BODØ	P
8088	BODØ	1804	BODØ	P
8089	BODØ	1804	BODØ	P
8091	BODØ	1804	BODØ	P
8092	BODØ	1804	BODØ	P
8093	KJERRINGØY	1804	BODØ	G
8094	FLEINVÆR	1838	GILDESKÅL	G
8095	HELLIGVÆR	1804	BODØ	B
8096	BLIKSVÆR	1804	BODØ	G
8097	GIVÆR	1804	BODØ	G
8098	LANDEGODE	1804	BODØ	G
8099	JAN MAYEN	2211	JAN MAYEN	G
8100	MISVÆR	1804	BODØ	G
8102	SKJERSTAD	1804	BODØ	G
8103	BREIVIK I SALTEN	1804	BODØ	G
8108	MISVÆR	1804	BODØ	P
8110	MOLDJORD	1839	BEIARN	G
8114	TOLLÅ	1839	BEIARN	G
8118	MOLDJORD	1839	BEIARN	P
8120	NYGÅRDSJØEN	1838	GILDESKÅL	G
8130	SANDHORNØY	1838	GILDESKÅL	G
8134	SØRARNØY	1838	GILDESKÅL	P
8135	SØRARNØY	1838	GILDESKÅL	G
8136	NORDARNØY	1838	GILDESKÅL	G
8138	INNDYR	1838	GILDESKÅL	P
8140	INNDYR	1838	GILDESKÅL	G
8145	STORVIK	1838	GILDESKÅL	G
8146	REIPÅ	1837	MELØY	G
8149	NEVERDAL	1837	MELØY	G
8150	ØRNES	1837	MELØY	G
8151	ØRNES	1837	MELØY	P
8157	MELØY	1837	MELØY	G
8158	BOLGA	1837	MELØY	B
8159	STØTT	1837	MELØY	G
8160	GLOMFJORD	1837	MELØY	G
8161	GLOMFJORD	1837	MELØY	P
8168	ENGAVÅGEN	1837	MELØY	P
8170	ENGAVÅGEN	1837	MELØY	G
8178	HALSA	1837	MELØY	G
8179	HALSA	1837	MELØY	P
8181	MYKEN	1836	RØDØY	G
8182	MELFJORDBOTN	1836	RØDØY	G
8183	VÅGAHOLMEN	1836	RØDØY	P
8184	ÅGSKARDET	1837	MELØY	G
8185	VÅGAHOLMEN	1836	RØDØY	G
8186	TJONGSFJORDEN	1836	RØDØY	G
8187	JEKTVIK	1836	RØDØY	G
8188	NORDVÆRNES	1836	RØDØY	G
8189	GJERSVIKGRENDA	1836	RØDØY	G
8190	SØRFJORDEN	1836	RØDØY	B
8192	JEKTVIK	1836	RØDØY	P
8193	RØDØY	1836	RØDØY	B
8195	GJERDØYA	1836	RØDØY	G
8196	SELSØYVIK	1836	RØDØY	G
8197	STORSELSØYA	1836	RØDØY	G
8198	NORDNESØYA	1836	RØDØY	G
8200	FAUSKE	1841	FAUSKE	G
8201	FAUSKE	1841	FAUSKE	P
8202	FAUSKE	1841	FAUSKE	P
8203	FAUSKE	1841	FAUSKE	P
8205	FAUSKE	1841	FAUSKE	P
8206	FAUSKE	1841	FAUSKE	G
8207	FAUSKE	1841	FAUSKE	G
8208	FAUSKE	1841	FAUSKE	G
8209	FAUSKE	1841	FAUSKE	G
8210	FAUSKE	1841	FAUSKE	G
8211	FAUSKE	1841	FAUSKE	G
8214	FAUSKE	1841	FAUSKE	G
8215	VALNESFJORD	1841	FAUSKE	G
8218	FAUSKE	1841	FAUSKE	G
8219	FAUSKE	1841	FAUSKE	G
8220	RØSVIK	1845	SØRFOLD	G
8226	STRAUMEN	1845	SØRFOLD	G
8230	SULITJELMA	1841	FAUSKE	G
8231	SULITJELMA	1841	FAUSKE	P
8232	STRAUMEN	1845	SØRFOLD	P
8233	VALNESFJORD	1841	FAUSKE	P
8250	ROGNAN	1840	SALTDAL	G
8251	ROGNAN	1840	SALTDAL	P
8252	ROGNAN	1840	SALTDAL	G
8253	ROGNAN	1840	SALTDAL	G
8255	RØKLAND	1840	SALTDAL	G
8256	RØKLAND	1840	SALTDAL	P
8260	INNHAVET	1875	HAMARØY	G
8261	INNHAVET	1875	HAMARØY	P
8264	ENGAN	1845	SØRFOLD	G
8266	MØRSVIKBOTN	1845	SØRFOLD	G
8270	DRAG	1875	HAMARØY	G
8271	DRAG	1875	HAMARØY	P
8273	NEVERVIKA	1875	HAMARØY	G
8274	MUSKEN	1875	HAMARØY	G
8275	STORJORDA I TYSFJORDEN	1875	HAMARØY	G
8276	ULVSVÅG	1875	HAMARØY	G
8278	STORÅ	1806	NARVIK	G
8281	LEINESFJORD	1848	STEIGEN	P
8283	LEINESFJORD	1848	STEIGEN	G
8285	LEINES	1848	STEIGEN	G
8286	NORDFOLD	1848	STEIGEN	G
8287	ENGELØYA	1848	STEIGEN	P
8288	BOGØY	1848	STEIGEN	G
8289	ENGELØYA	1848	STEIGEN	G
8290	SKUTVIK	1875	HAMARØY	G
8294	HAMARØY	1875	HAMARØY	G
8297	TRANØY	1875	HAMARØY	G
8298	HAMARØY	1875	HAMARØY	P
8300	SVOLVÆR	1865	VÅGAN	G
8301	SVOLVÆR	1865	VÅGAN	P
8305	SVOLVÆR	1865	VÅGAN	P
8309	KABELVÅG	1865	VÅGAN	P
8310	KABELVÅG	1865	VÅGAN	G
8311	HENNINGSVÆR	1865	VÅGAN	P
8312	HENNINGSVÆR	1865	VÅGAN	G
8313	KLEPPSTAD	1865	VÅGAN	G
8314	GIMSØYSAND	1865	VÅGAN	G
8315	LAUKVIK	1865	VÅGAN	G
8316	LAUPSTAD	1865	VÅGAN	G
8317	STRØNSTAD	1866	HADSEL	G
8320	SKROVA	1865	VÅGAN	B
8322	BRETTESNES	1865	VÅGAN	G
8323	STORFJELL	1865	VÅGAN	G
8324	DIGERMULEN	1865	VÅGAN	G
8325	TENGELFJORD	1866	HADSEL	G
8326	MYRLAND	1866	HADSEL	G
8328	STORMOLLA	1865	VÅGAN	G
8340	STAMSUND	1860	VESTVÅGØY	G
8352	SENNESVIK	1860	VESTVÅGØY	G
8357	VALBERG	1860	VESTVÅGØY	G
8360	BØSTAD	1860	VESTVÅGØY	G
8361	BØSTAD	1860	VESTVÅGØY	P
8370	LEKNES	1860	VESTVÅGØY	G
8372	GRAVDAL	1860	VESTVÅGØY	G
8373	BALLSTAD	1860	VESTVÅGØY	G
8374	BALLSTAD	1860	VESTVÅGØY	P
8376	LEKNES	1860	VESTVÅGØY	P
8377	GRAVDAL	1860	VESTVÅGØY	P
8378	STAMSUND	1860	VESTVÅGØY	P
8380	RAMBERG	1859	FLAKSTAD	G
8382	NAPP	1859	FLAKSTAD	G
8384	SUND I LOFOTEN	1859	FLAKSTAD	G
8385	MØLNARODDEN	1859	FLAKSTAD	G
8387	FREDVANG	1859	FLAKSTAD	G
8388	RAMBERG	1859	FLAKSTAD	P
8390	REINE	1874	MOSKENES	G
8392	SØRVÅGEN	1874	MOSKENES	G
8393	SØRVÅGEN	1874	MOSKENES	P
8398	REINE	1874	MOSKENES	P
8400	SORTLAND	1870	SORTLAND	G
8401	SORTLAND	1870	SORTLAND	P
8402	SORTLAND	1870	SORTLAND	G
8403	SORTLAND	1870	SORTLAND	G
8404	SORTLAND	1870	SORTLAND	G
8405	SORTLAND	1870	SORTLAND	P
8406	SORTLAND	1870	SORTLAND	G
8407	SORTLAND	1870	SORTLAND	G
8408	SORTLAND	1868	ØKSNES	G
8409	GULLESFJORDEN	5510	KVÆFJORD	G
8410	LØDINGEN	1851	LØDINGEN	G
8411	LØDINGEN	1851	LØDINGEN	P
8412	VESTBYGDA	1851	LØDINGEN	G
8413	KVITNES	1866	HADSEL	G
8414	HENNES	1866	HADSEL	G
8415	SORTLAND	1870	SORTLAND	G
8416	SORTLAND	1870	SORTLAND	G
8419	SORTLAND	1870	SORTLAND	P
8426	BARKESTAD	1868	ØKSNES	G
8428	TUNSTAD	1868	ØKSNES	G
8430	MYRE	1868	ØKSNES	G
8432	ALSVÅG	1868	ØKSNES	G
8438	STØ	1868	ØKSNES	G
8439	MYRE	1868	ØKSNES	P
8445	MELBU	1866	HADSEL	G
8447	LONKAN	1866	HADSEL	G
8450	STOKMARKNES	1866	HADSEL	G
8455	STOKMARKNES	1866	HADSEL	P
8459	MELBU	1866	HADSEL	P
8465	STRAUMSJØEN	1867	BØ	P
8469	BØ I VESTERÅLEN	1867	BØ	P
8470	BØ I VESTERÅLEN	1867	BØ	G
8475	STRAUMSJØEN	1867	BØ	G
8480	ANDENES	1871	ANDØY	G
8481	BLEIK	1871	ANDØY	G
8483	ANDENES	1871	ANDØY	P
8484	RISØYHAMN	1871	ANDØY	G
8485	DVERBERG	1871	ANDØY	G
8488	NØSS	1871	ANDØY	G
8489	NORDMELA	1871	ANDØY	G
8493	RISØYHAMN	1871	ANDØY	P
8501	NARVIK	1806	NARVIK	P
8502	NARVIK	1806	NARVIK	P
8503	NARVIK	1806	NARVIK	P
8504	NARVIK	1806	NARVIK	P
8505	NARVIK	1806	NARVIK	P
8506	NARVIK	1806	NARVIK	P
8507	NARVIK	1806	NARVIK	P
8508	NARVIK	1806	NARVIK	P
8509	NARVIK	1806	NARVIK	P
8510	NARVIK	1806	NARVIK	P
8512	NARVIK	1806	NARVIK	P
8513	ANKENES	1806	NARVIK	P
8514	NARVIK	1806	NARVIK	G
8515	NARVIK	1806	NARVIK	G
8516	NARVIK	1806	NARVIK	G
8517	NARVIK	1806	NARVIK	G
8518	NARVIK	1806	NARVIK	P
8519	NARVIK	1806	NARVIK	G
8520	ANKENES	1806	NARVIK	G
8521	ANKENES	1806	NARVIK	G
8522	BEISFJORD	1806	NARVIK	G
8523	SKJOMEN	1806	NARVIK	G
8530	BJERKVIK	1806	NARVIK	G
8531	BJERKVIK	1806	NARVIK	P
8533	BOGEN I OFOTEN	1853	EVENES	G
8534	LILAND	1853	EVENES	G
8535	TÅRSTAD	1853	EVENES	G
8536	EVENES	1853	EVENES	G
8539	BOGEN I OFOTEN	1853	EVENES	P
8540	BALLANGEN	1806	NARVIK	G
8543	KJELDEBOTN	1806	NARVIK	G
8546	BALLANGEN	1806	NARVIK	P
8590	KJØPSVIK	1806	NARVIK	G
8591	KJØPSVIK	1806	NARVIK	P
8601	MO I RANA	1833	RANA	P
8602	MO I RANA	1833	RANA	P
8603	MO I RANA	1833	RANA	P
8604	MO I RANA	1833	RANA	P
8607	MO I RANA	1833	RANA	P
8609	MO I RANA	1833	RANA	P
8610	MO I RANA	1833	RANA	G
8611	MO I RANA	1833	RANA	G
8613	MO I RANA	1833	RANA	G
8614	MO I RANA	1833	RANA	G
8615	SKONSENG	1833	RANA	G
8616	MO I RANA	1833	RANA	G
8617	DALSGRENDA	1833	RANA	G
8618	MO I RANA	1833	RANA	G
8619	MO I RANA	1833	RANA	P
8622	MO I RANA	1833	RANA	G
8624	MO I RANA	1833	RANA	G
8626	MO I RANA	1833	RANA	G
8630	STORFORSHEIA	1833	RANA	G
8638	STORFORSHEIA	1833	RANA	P
8640	HEMNESBERGET	1832	HEMNES	G
8641	HEMNESBERGET	1832	HEMNES	P
8642	FINNEIDFJORD	1832	HEMNES	G
8643	BJERKA	1832	HEMNES	G
8644	BJERKA	1832	HEMNES	P
8646	KORGEN	1832	HEMNES	G
8647	BLEIKVASSLIA	1832	HEMNES	G
8648	KORGEN	1832	HEMNES	P
8651	MOSJØEN	1824	VEFSN	P
8652	MOSJØEN	1824	VEFSN	P
8654	MOSJØEN	1824	VEFSN	P
8655	MOSJØEN	1824	VEFSN	P
8656	MOSJØEN	1824	VEFSN	G
8657	MOSJØEN	1824	VEFSN	G
8658	MOSJØEN	1824	VEFSN	G
8659	MOSJØEN	1824	VEFSN	G
8660	MOSJØEN	1824	VEFSN	G
8661	MOSJØEN	1824	VEFSN	G
8663	MOSJØEN	1824	VEFSN	G
8664	MOSJØEN	1824	VEFSN	G
8665	MOSJØEN	1824	VEFSN	G
8666	MOSJØEN	1824	VEFSN	G
8672	ELSFJORD	1824	VEFSN	G
8681	TROFORS	1825	GRANE	P
8682	TROFORS	1825	GRANE	G
8683	TROFORS	1825	GRANE	G
8684	TROFORS	1825	GRANE	G
8685	TROFORS	1825	GRANE	G
8691	HATTFJELLDAL	1826	HATTFJELLDAL	P
8692	HATTFJELLDAL	1826	HATTFJELLDAL	G
8693	HATTFJELLDAL	1826	HATTFJELLDAL	G
8694	HATTFJELLDAL	1826	HATTFJELLDAL	G
8695	HATTFJELLDAL	1826	HATTFJELLDAL	G
8696	HATTFJELLDAL	1826	HATTFJELLDAL	G
8700	NESNA	1828	NESNA	G
8701	NESNA	1828	NESNA	P
8704	NESNASTRANDA	1828	NESNA	G
8705	STRANDLANDET	1828	NESNA	G
8720	VIKHOLMEN	1828	NESNA	G
8723	HUSBY	1828	NESNA	G
8724	SAURA	1828	NESNA	G
8725	UTSKARPEN	1833	RANA	G
8730	ALDERSUNDET	1834	LURØY	G
8732	ALDRA	1834	LURØY	G
8733	STUVLAND	1834	LURØY	G
8735	STOKKVÅGEN	1834	LURØY	G
8740	NORDSOLVÆR	1834	LURØY	G
8742	SELVÆR	1835	TRÆNA	G
8743	INDRE KVARØY	1834	LURØY	B
8750	TONNES	1834	LURØY	G
8752	KONSVIKOSEN	1834	LURØY	G
8754	ØRESVIK	1836	RØDØY	G
8762	SLENESET	1834	LURØY	G
8764	LOVUND	1834	LURØY	B
8766	LURØY	1834	LURØY	G
8770	TRÆNA	1835	TRÆNA	B
8800	SANDNESSJØEN	1820	ALSTAHAUG	G
8801	SANDNESSJØEN	1820	ALSTAHAUG	P
8802	SANDNESSJØEN	1820	ALSTAHAUG	G
8803	SANDNESSJØEN	1820	ALSTAHAUG	G
8804	SANDNESSJØEN	1820	ALSTAHAUG	G
8805	SANDNESSJØEN	1820	ALSTAHAUG	P
8809	SANDNESSJØEN	1820	ALSTAHAUG	P
8813	LØKTA	1827	DØNNA	G
8820	DØNNA	1827	DØNNA	G
8827	DØNNA	1827	DØNNA	P
8830	VANDVE	1827	DØNNA	G
8842	BRASØY	1818	HERØY (NORDLAND)	B
8844	SANDVÆR	1818	HERØY (NORDLAND)	B
8845	SELØY	1818	HERØY (NORDLAND)	G
8850	HERØY	1818	HERØY (NORDLAND)	G
8851	HERØY	1818	HERØY (NORDLAND)	P
8852	HERØY	1818	HERØY (NORDLAND)	P
8854	AUSTBØ	1820	ALSTAHAUG	G
8860	TJØTTA	1820	ALSTAHAUG	G
8861	TJØTTA	1820	ALSTAHAUG	P
8865	TRO	1820	ALSTAHAUG	G
8866	MINDLANDET	1820	ALSTAHAUG	G
8870	VISTHUS	1816	VEVELSTAD	G
8880	BÆRØYVÅGEN	1820	ALSTAHAUG	G
8890	LEIRFJORD	1822	LEIRFJORD	G
8891	LEIRFJORD	1822	LEIRFJORD	P
8892	SUNDØYA	1822	LEIRFJORD	G
8897	BARDAL	1822	LEIRFJORD	G
8900	BRØNNØYSUND	1813	BRØNNØY	G
8901	BRØNNØYSUND	1813	BRØNNØY	P
8902	BRØNNØYSUND	1813	BRØNNØY	P
8904	BRØNNØYSUND	1813	BRØNNØY	G
8905	BRØNNØYSUND	1813	BRØNNØY	P
8906	BRØNNØYSUND	1813	BRØNNØY	G
8907	BRØNNØYSUND	1813	BRØNNØY	G
8908	BRØNNØYSUND	1813	BRØNNØY	G
8909	BRØNNØYSUND	1813	BRØNNØY	G
8910	BRØNNØYSUND	1813	BRØNNØY	P
8920	SØMNA	1812	SØMNA	G
8921	SØMNA	1812	SØMNA	P
8922	SØMNA	1812	SØMNA	P
8960	VELFJORD	1813	BRØNNØY	G
8961	VELFJORD	1813	BRØNNØY	P
8976	VEVELSTAD	1816	VEVELSTAD	G
8977	VEVELSTAD	1816	VEVELSTAD	P
8981	VEGA	1815	VEGA	P
8982	VEGA	1815	VEGA	G
8983	VEGA	1815	VEGA	G
8984	VEGA	1815	VEGA	G
8985	YLVINGEN	1815	VEGA	G
8986	VEGA	1815	VEGA	G
9006	TROMSØ	5501	TROMSØ	G
9007	TROMSØ	5501	TROMSØ	G
9008	TROMSØ	5501	TROMSØ	G
9009	TROMSØ	5501	TROMSØ	G
9010	TROMSØ	5501	TROMSØ	G
9011	TROMSØ	5501	TROMSØ	G
9012	TROMSØ	5501	TROMSØ	G
9013	TROMSØ	5501	TROMSØ	G
9014	TROMSØ	5501	TROMSØ	G
9015	TROMSØ	5501	TROMSØ	G
9016	TROMSØ	5501	TROMSØ	G
9017	TROMSØ	5501	TROMSØ	G
9018	TROMSØ	5501	TROMSØ	G
9019	TROMSØ	5501	TROMSØ	G
9020	TROMSDALEN	5501	TROMSØ	G
9021	TROMSDALEN	5501	TROMSØ	G
9022	KROKELVDALEN	5501	TROMSØ	G
9023	KROKELVDALEN	5501	TROMSØ	G
9024	TOMASJORD	5501	TROMSØ	G
9027	RAMFJORDBOTN	5501	TROMSØ	G
9029	TROMSDALEN	5501	TROMSØ	P
9030	SJURSNES	5501	TROMSØ	G
9034	OLDERVIK	5501	TROMSØ	G
9037	TROMSØ	5501	TROMSØ	P
9038	TROMSØ	5501	TROMSØ	P
9040	NORDKJOSBOTN	5532	BALSFJORD	G
9042	LAKSVATN	5532	BALSFJORD	G
9043	JØVIKA	5501	TROMSØ	G
9045	LAKSELVBUKT	5501	TROMSØ	G
9046	OTEREN	5538	STORFJORD	G
9049	NORDKJOSBOTN	5532	BALSFJORD	P
9050	STORSTEINNES	5532	BALSFJORD	G
9055	MEISTERVIK	5532	BALSFJORD	G
9056	MORTENHALS	5532	BALSFJORD	G
9057	VIKRAN	5501	TROMSØ	G
9059	STORSTEINNES	5532	BALSFJORD	P
9060	LYNGSEIDET	5536	LYNGEN	G
9062	FURUFLATEN	5536	LYNGEN	G
9064	SVENSBY	5536	LYNGEN	G
9068	NORD-LENANGEN	5536	LYNGEN	G
9069	LYNGSEIDET	5536	LYNGEN	P
9100	KVALØYSLETTA	5501	TROMSØ	G
9101	KVALØYSLETTA	5501	TROMSØ	G
9102	KVALØYSLETTA	5501	TROMSØ	G
9103	KVALØYA	5501	TROMSØ	G
9104	KVALØYA	5501	TROMSØ	G
9105	KVALØYA	5501	TROMSØ	G
9106	STRAUMSBUKTA	5501	TROMSØ	G
9107	KVALØYA	5501	TROMSØ	G
9108	KVALØYA	5501	TROMSØ	G
9109	KVALØYA	5501	TROMSØ	G
9110	SOMMARØYA	5501	TROMSØ	G
9118	BRENSHOLMEN	5501	TROMSØ	G
9119	SOMMARØYA	5501	TROMSØ	P
9120	VENGSØY	5501	TROMSØ	G
9128	TUSSØY	5501	TROMSØ	G
9130	HANSNES	5534	KARLSØY	G
9131	KÅRVIK	5501	TROMSØ	G
9132	STAKKVIK	5534	KARLSØY	G
9134	HANSNES	5534	KARLSØY	P
9135	VANNVÅG	5534	KARLSØY	G
9136	VANNAREID	5534	KARLSØY	G
9137	VANNVÅG	5534	KARLSØY	P
9138	KARLSØY	5534	KARLSØY	B
9140	REBBENES	5534	KARLSØY	G
9141	MELVIKA	5501	TROMSØ	G
9142	SKIBOTN	5538	STORFJORD	P
9143	SKIBOTN	5538	STORFJORD	G
9144	SAMUELSBERG	5540	GÁIVUOTNA KÅFJORD	G
9145	SAMUELSBERG	5540	GÁIVUOTNA KÅFJORD	P
9146	OLDERDALEN	5540	GÁIVUOTNA KÅFJORD	G
9147	BIRTAVARRE	5540	GÁIVUOTNA KÅFJORD	G
9148	OLDERDALEN	5540	GÁIVUOTNA KÅFJORD	P
9149	BIRTAVARRE	5540	GÁIVUOTNA KÅFJORD	P
9151	STORSLETT	5544	NORDREISA	G
9152	SØRKJOSEN	5544	NORDREISA	G
9153	ROTSUND	5544	NORDREISA	G
9154	STORSLETT	5544	NORDREISA	G
9155	SØRKJOSEN	5544	NORDREISA	P
9156	STORSLETT	5544	NORDREISA	P
9157	STORSLETT	5544	NORDREISA	G
9158	STORSLETT	5544	NORDREISA	G
9159	HAVNNES	5544	NORDREISA	B
9161	BURFJORD	5546	KVÆNANGEN	G
9162	SØRSTRAUMEN	5546	KVÆNANGEN	G
9163	JØKELFJORD	5546	KVÆNANGEN	G
9169	BURFJORD	5546	KVÆNANGEN	P
9170	LONGYEARBYEN	2100	SVALBARD	G
9171	LONGYEARBYEN	2100	SVALBARD	P
9173	NY-ÅLESUND	2100	SVALBARD	B
9174	HOPEN	2100	SVALBARD	G
9175	SVEAGRUVA	2100	SVALBARD	G
9176	BJØRNØYA	2100	SVALBARD	G
9178	BARENTSBURG	2100	SVALBARD	G
9180	SKJERVØY	5542	SKJERVØY	G
9181	HAMNEIDET	5544	NORDREISA	G
9182	SEGLVIK	5546	KVÆNANGEN	G
9184	REINFJORD	5546	KVÆNANGEN	G
9185	SPILDRA	5546	KVÆNANGEN	G
9186	ANDSNES	5614	LOPPA	G
9187	VALANHAMN	5546	KVÆNANGEN	G
9189	SKJERVØY	5542	SKJERVØY	P
9190	AKKARVIK	5542	SKJERVØY	G
9192	ARNØYHAMN	5542	SKJERVØY	G
9193	NIKKEBY	5542	SKJERVØY	G
9194	LAUKSLETTA	5542	SKJERVØY	G
9195	ÅRVIKSAND	5542	SKJERVØY	G
9197	ULØYBUKT	5542	SKJERVØY	G
9240	TROMSØ	5501	TROMSØ	P
9251	TROMSØ	5501	TROMSØ	P
9252	TROMSØ	5501	TROMSØ	P
9253	TROMSØ	5501	TROMSØ	P
9254	TROMSØ	5501	TROMSØ	P
9255	TROMSØ	5501	TROMSØ	P
9256	TROMSØ	5501	TROMSØ	P
9257	TROMSØ	5501	TROMSØ	P
9258	TROMSØ	5501	TROMSØ	P
9259	TROMSØ	5501	TROMSØ	P
9260	TROMSØ	5501	TROMSØ	P
9261	TROMSØ	5501	TROMSØ	P
9262	TROMSØ	5501	TROMSØ	P
9263	TROMSØ	5501	TROMSØ	P
9265	TROMSØ	5501	TROMSØ	P
9266	TROMSØ	5501	TROMSØ	P
9267	TROMSØ	5501	TROMSØ	P
9268	TROMSØ	5501	TROMSØ	P
9269	TROMSØ	5501	TROMSØ	P
9270	TROMSØ	5501	TROMSØ	P
9271	TROMSØ	5501	TROMSØ	P
9272	TROMSØ	5501	TROMSØ	P
9273	TROMSØ	5501	TROMSØ	P
9274	TROMSØ	5501	TROMSØ	P
9275	TROMSØ	5501	TROMSØ	P
9276	TROMSØ	5501	TROMSØ	P
9277	TROMSØ	5501	TROMSØ	P
9278	TROMSØ	5501	TROMSØ	P
9279	TROMSØ	5501	TROMSØ	P
9280	TROMSØ	5501	TROMSØ	P
9281	TROMSØ	5501	TROMSØ	P
9282	TROMSØ	5501	TROMSØ	P
9283	TROMSØ	5501	TROMSØ	P
9284	TROMSØ	5501	TROMSØ	P
9285	TROMSØ	5501	TROMSØ	P
9286	TROMSØ	5501	TROMSØ	P
9287	TROMSØ	5501	TROMSØ	P
9288	TROMSØ	5501	TROMSØ	P
9291	TROMSØ	5501	TROMSØ	P
9292	TROMSØ	5501	TROMSØ	P
9293	TROMSØ	5501	TROMSØ	P
9294	TROMSØ	5501	TROMSØ	P
9296	TROMSØ	5501	TROMSØ	P
9298	TROMSØ	5501	TROMSØ	P
9299	TROMSØ	5501	TROMSØ	P
9300	FINNSNES	5530	SENJA	G
9302	ROSSFJORDSTRAUMEN	5530	SENJA	G
9303	SILSAND	5530	SENJA	G
9304	VANGSVIK	5530	SENJA	G
9305	FINNSNES	5530	SENJA	P
9306	FINNSNES	5530	SENJA	P
9307	FINNSNES	5530	SENJA	G
9308	FINNSNES	5530	SENJA	G
9309	FINNSNES	5530	SENJA	G
9310	SØRREISA	5526	SØRREISA	G
9311	BRØSTADBOTN	5528	DYRØY	G
9315	SØRREISA	5526	SØRREISA	P
9316	BRØSTADBOTN	5528	DYRØY	P
9321	MOEN	5524	MÅLSELV	G
9322	KARLSTAD	5524	MÅLSELV	G
9325	BARDUFOSS	5524	MÅLSELV	G
9326	BARDUFOSS	5524	MÅLSELV	P
9329	MOEN	5524	MÅLSELV	P
9334	ØVERBYGD	5524	MÅLSELV	G
9335	ØVERBYGD	5524	MÅLSELV	P
9336	RUNDHAUG	5524	MÅLSELV	G
9350	SJØVEGAN	5522	SALANGEN	G
9355	SJØVEGAN	5522	SALANGEN	P
9357	TENNEVOLL	5518	LAVANGEN	G
9358	TENNEVOLL	5518	LAVANGEN	P
9360	BARDU	5520	BARDU	G
9365	BARDU	5520	BARDU	P
9370	SILSAND	5530	SENJA	P
9372	GIBOSTAD	5530	SENJA	G
9373	BOTNHAMN	5530	SENJA	G
9376	SKATVIK	5530	SENJA	G
9379	GRYLLEFJORD	5530	SENJA	P
9380	GRYLLEFJORD	5530	SENJA	G
9381	TORSKEN	5530	SENJA	G
9382	GIBOSTAD	5530	SENJA	P
9384	SKALAND	5530	SENJA	P
9385	SKALAND	5530	SENJA	G
9386	SENJAHOPEN	5530	SENJA	G
9387	SENJAHOPEN	5530	SENJA	P
9388	FJORDGARD	5530	SENJA	G
9389	HUSØY I SENJA	5530	SENJA	B
9391	STONGLANDSEIDET	5530	SENJA	P
9392	STONGLANDSEIDET	5530	SENJA	G
9393	FLAKSTADVÅG	5530	SENJA	G
9395	KALDFARNES	5530	SENJA	G
9402	HARSTAD	5503	HARSTAD	G
9403	HARSTAD	5503	HARSTAD	G
9404	HARSTAD	5503	HARSTAD	G
9405	HARSTAD	5503	HARSTAD	G
9406	HARSTAD	5503	HARSTAD	G
9407	HARSTAD	5503	HARSTAD	G
9408	HARSTAD	5503	HARSTAD	G
9409	HARSTAD	5503	HARSTAD	G
9411	HARSTAD	5503	HARSTAD	G
9414	HARSTAD	5503	HARSTAD	G
9415	HARSTAD	5503	HARSTAD	G
9416	HARSTAD	5503	HARSTAD	P
9419	SØRVIK	5503	HARSTAD	G
9420	LUNDENES	5503	HARSTAD	G
9423	GRØTAVÆR	5503	HARSTAD	G
9424	KJØTTA	5503	HARSTAD	G
9425	SANDSØY	5503	HARSTAD	G
9426	BJARKØY	5503	HARSTAD	G
9427	MELØYVÆR	5503	HARSTAD	G
9430	SANDTORG	5503	HARSTAD	G
9436	KONGSVIK	5512	TJELDSUND	G
9439	EVENSKJER	5512	TJELDSUND	P
9440	EVENSKJER	5512	TJELDSUND	G
9441	FJELLDAL	5512	TJELDSUND	G
9442	RAMSUND	5512	TJELDSUND	G
9443	MYKLEBOSTAD	5512	TJELDSUND	G
9444	HOL I TJELDSUND	5512	TJELDSUND	G
9445	TOVIK	5512	TJELDSUND	G
9446	GROVFJORD	5512	TJELDSUND	G
9447	GROVFJORD	5512	TJELDSUND	P
9448	RAMSUND	5512	TJELDSUND	P
9450	HAMNVIK	5514	IBESTAD	G
9451	HAMNVIK	5514	IBESTAD	P
9453	KRÅKRØHAMN	5514	IBESTAD	G
9454	ÅNSTAD	5514	IBESTAD	G
9455	ENGENES	5514	IBESTAD	G
9456	ENGENES	5514	IBESTAD	P
9470	GRATANGEN	5516	GRATANGEN	G
9471	GRATANGEN	5516	GRATANGEN	P
9475	BORKENES	5510	KVÆFJORD	G
9476	BORKENES	5510	KVÆFJORD	P
9479	HARSTAD	5503	HARSTAD	P
9480	HARSTAD	5503	HARSTAD	P
9481	HARSTAD	5503	HARSTAD	P
9482	HARSTAD	5503	HARSTAD	P
9483	HARSTAD	5503	HARSTAD	P
9484	HARSTAD	5503	HARSTAD	P
9485	HARSTAD	5503	HARSTAD	P
9486	HARSTAD	5503	HARSTAD	P
9487	HARSTAD	5503	HARSTAD	P
9488	HARSTAD	5503	HARSTAD	P
9489	HARSTAD	5503	HARSTAD	P
9496	HARSTAD	5503	HARSTAD	P
9497	HARSTAD	5503	HARSTAD	P
9498	HARSTAD	5503	HARSTAD	P
9501	ALTA	5601	ALTA	P
9502	ALTA	5601	ALTA	P
9503	ALTA	5601	ALTA	P
9504	ALTA	5601	ALTA	P
9505	ALTA	5601	ALTA	P
9506	ALTA	5601	ALTA	P
9507	ALTA	5601	ALTA	P
9508	ALTA	5601	ALTA	P
9509	ALTA	5601	ALTA	P
9510	ALTA	5601	ALTA	G
9511	ALTA	5601	ALTA	G
9512	ALTA	5601	ALTA	G
9513	ALTA	5601	ALTA	G
9514	ALTA	5601	ALTA	G
9515	ALTA	5601	ALTA	G
9516	ALTA	5601	ALTA	G
9517	ALTA	5601	ALTA	G
9518	ALTA	5601	ALTA	G
9519	KVIBY	5601	ALTA	G
9520	KAUTOKEINO	5612	GUOVDAGEAIDNU KAUTOKEINO	G
9521	KAUTOKEINO	5612	GUOVDAGEAIDNU KAUTOKEINO	P
9522	KAUTOKEINO	5612	GUOVDAGEAIDNU KAUTOKEINO	G
9523	KAUTOKEINO	5612	GUOVDAGEAIDNU KAUTOKEINO	G
9524	KAUTOKEINO	5612	GUOVDAGEAIDNU KAUTOKEINO	G
9525	MAZE	5612	GUOVDAGEAIDNU KAUTOKEINO	B
9527	KAUTOKEINO	5612	GUOVDAGEAIDNU KAUTOKEINO	G
9528	KAUTOKEINO	5612	GUOVDAGEAIDNU KAUTOKEINO	G
9529	KAUTOKEINO	5612	GUOVDAGEAIDNU KAUTOKEINO	G
9531	KVALFJORD	5601	ALTA	B
9532	HAKKSTABBEN	5601	ALTA	G
9533	KONGSHUS	5601	ALTA	B
9536	KORSFJORDEN	5601	ALTA	G
9537	TVERRELVDALEN	5601	ALTA	G
9538	ALTA	5601	ALTA	G
9540	TALVIK	5601	ALTA	G
9541	ALTA	5601	ALTA	G
9545	LANGFJORDBOTN	5601	ALTA	G
9550	ØKSFJORD	5614	LOPPA	G
9552	ØKSFJORDEN	5614	LOPPA	G
9580	BERGSFJORD	5614	LOPPA	B
9582	NUVSVÅG	5614	LOPPA	G
9583	LANGFJORDHAMN	5614	LOPPA	G
9584	SØR-TVERRFJORD	5614	LOPPA	B
9585	SANDLAND	5614	LOPPA	G
9586	LOPPA	5614	LOPPA	G
9587	SKAVNAKK	5614	LOPPA	G
9590	HASVIK	5616	HASVIK	G
9591	HASVIK	5616	HASVIK	P
9593	BREIVIKBOTN	5616	HASVIK	B
9595	SØRVÆR	5616	HASVIK	B
9600	HAMMERFEST	5603	HAMMERFEST	G
9601	HAMMERFEST	5603	HAMMERFEST	G
9602	HAMMERFEST	5603	HAMMERFEST	G
9603	HAMMERFEST	5603	HAMMERFEST	G
9609	NORDRE SEILAND	5603	HAMMERFEST	G
9610	RYPEFJORD	5603	HAMMERFEST	G
9611	RYPEFJORD	5603	HAMMERFEST	P
9612	FORSØL	5603	HAMMERFEST	G
9615	HAMMERFEST	5603	HAMMERFEST	P
9616	HAMMERFEST	5603	HAMMERFEST	P
9620	KVALSUND	5603	HAMMERFEST	G
9621	KVALSUND	5603	HAMMERFEST	P
9624	REVSNESHAMN	5603	HAMMERFEST	G
9650	AKKARFJORD	5603	HAMMERFEST	B
9651	LANGSTRAND	5603	HAMMERFEST	G
9657	KÅRHAMN	5603	HAMMERFEST	G
9664	SANDØYBOTN	5603	HAMMERFEST	G
9670	TUFJORD	5618	MÅSØY	B
9672	INGØY	5618	MÅSØY	B
9690	HAVØYSUND	5618	MÅSØY	G
9691	HAVØYSUND	5618	MÅSØY	P
9692	MÅSØY	5618	MÅSØY	B
9700	LAKSELV	5622	PORSANGER PORSÁNGU PORSANKI	G
9709	PORSANGMOEN	5622	PORSANGER PORSÁNGU PORSANKI	G
9710	INDRE BILLEFJORD	5622	PORSANGER PORSÁNGU PORSANKI	G
9711	LAKSELV	5622	PORSANGER PORSÁNGU PORSANKI	P
9712	LAKSELV	5622	PORSANGER PORSÁNGU PORSANKI	P
9713	RUSSENES	5622	PORSANGER PORSÁNGU PORSANKI	G
9714	SNEFJORD	5618	MÅSØY	G
9715	KOKELV	5603	HAMMERFEST	G
9716	BØRSELV	5622	PORSANGER PORSÁNGU PORSANKI	G
9717	VEIDNES	5624	LEBESBY	B
9722	SKOGANVARRE	5622	PORSANGER PORSÁNGU PORSANKI	G
9730	KARASJOK	5610	KARASJOHKA KARASJOK	G
9731	KARASJOK	5610	KARASJOHKA KARASJOK	G
9732	KARASJOK	5610	KARASJOHKA KARASJOK	G
9733	KARASJOK	5610	KARASJOHKA KARASJOK	G
9734	KARASJOK	5610	KARASJOHKA KARASJOK	G
9735	KARASJOK	5610	KARASJOHKA KARASJOK	P
9736	KARASJOK	5610	KARASJOHKA KARASJOK	G
9737	KARASJOK	5610	KARASJOHKA KARASJOK	G
9740	LEBESBY	5624	LEBESBY	G
9742	KUNES	5624	LEBESBY	B
9750	HONNINGSVÅG	5620	NORDKAPP	G
9751	HONNINGSVÅG	5620	NORDKAPP	P
9760	NORDVÅGEN	5620	NORDKAPP	G
9762	KAMØYVÆR	5620	NORDKAPP	G
9763	SKARSVÅG	5620	NORDKAPP	G
9764	NORDKAPP	5620	NORDKAPP	G
9765	GJESVÆR	5620	NORDKAPP	G
9766	SARNES	5620	NORDKAPP	G
9768	REPVÅG	5620	NORDKAPP	G
9770	MEHAMN	5626	GAMVIK	B
9771	SKJÅNES	5626	GAMVIK	G
9772	LANGFJORDNES	5626	GAMVIK	G
9773	NERVEI	5626	GAMVIK	B
9775	GAMVIK	5626	GAMVIK	B
9782	DYFJORD	5624	LEBESBY	G
9790	KJØLLEFJORD	5624	LEBESBY	B
9800	VADSØ	5607	VADSØ	G
9801	VADSØ	5607	VADSØ	G
9802	VESTRE JAKOBSELV	5607	VADSØ	G
9803	VADSØ	5607	VADSØ	G
9804	VADSØ	5607	VADSØ	G
9810	VESTRE JAKOBSELV	5607	VADSØ	P
9811	VADSØ	5607	VADSØ	P
9815	VADSØ	5607	VADSØ	P
9820	VARANGERBOTN	5636	UNJARGGA NESSEBY	P
9826	SIRMA	5628	DEATNU TANA	G
9840	VARANGERBOTN	5636	UNJARGGA NESSEBY	G
9841	TANA	5628	DEATNU TANA	G
9842	TANA	5628	DEATNU TANA	G
9843	TANA	5628	DEATNU TANA	G
9844	TANA	5628	DEATNU TANA	G
9845	TANA	5628	DEATNU TANA	G
9846	TANA	5628	DEATNU TANA	P
9900	KIRKENES	5605	SØR-VARANGER	G
9901	KIRKENES	5605	SØR-VARANGER	G
9910	BJØRNEVATN	5605	SØR-VARANGER	G
9911	JARFJORD	5605	SØR-VARANGER	G
9912	HESSENG	5605	SØR-VARANGER	G
9914	BJØRNEVATN	5605	SØR-VARANGER	P
9915	KIRKENES	5605	SØR-VARANGER	P
9916	HESSENG	5605	SØR-VARANGER	P
9917	KIRKENES	5605	SØR-VARANGER	P
9925	SVANVIK	5605	SØR-VARANGER	G
9926	PASVIK	5605	SØR-VARANGER	G
9930	NEIDEN	5605	SØR-VARANGER	G
9935	BUGØYNES	5605	SØR-VARANGER	B
9950	VARDØ	5634	VARDØ	G
9951	VARDØ	5634	VARDØ	P
9952	VARDØ	5634	VARDØ	G
9955	SVARTNES	5634	VARDØ	G
9960	KIBERG	5634	VARDØ	G
9980	BERLEVÅG	5630	BERLEVÅG	G
9981	BERLEVÅG	5630	BERLEVÅG	P
9982	KONGSFJORD	5630	BERLEVÅG	G
9990	BÅTSFJORD	5632	BÅTSFJORD	G
9991	BÅTSFJORD	5632	BÅTSFJORD	P
`;
export default postalCodesMap;